export default

  [
    {
      "UIC": "WG6WA0",
      "LINNumber": "T07679",
      "AdminNo": "A06",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869926,
      "Serial": 502440,
      "Material": 13469317,
      "EQSLOC": "EGPK"
    },
    {
      "UIC": "WG6WA0",
      "LINNumber": "T41995",
      "AdminNo": "A100",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867010,
      "Serial": "L-A114438BGKT",
      "Material": 14473882,
      "EQSLOC": "EGPJ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A110",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017867157,
      "Serial": "10TGJAM19AS116903",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T41036",
      "AdminNo": "A112",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869246,
      "Serial": "M-A114291BGKT",
      "Material": 14473889,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T05061",
      "AdminNo": "A204E",
      "Description": "TRUCK TRACTOR",
      "Model": "M1120A4 ECHU",
      "Equipment": 1017870697,
      "Serial": "10TGJAM12AS113051",
      "Material": 16263301,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T41995",
      "AdminNo": "A27",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867460,
      "Serial": "L-T120834EHMV",
      "Material": 14473882,
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T58318",
      "AdminNo": "A312",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869202,
      "Serial": "10TGJAM12AS123479",
      "Material": 15341117,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96496",
      "AdminNo": "A330",
      "Description": "TRK PAL LO M1120A2",
      "Model": "M1120A2",
      "Equipment": 1017869103,
      "Serial": "10TGJ6Y148S101114",
      "Material": 14928221,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T76541",
      "AdminNo": "A371",
      "Description": "TRCTR FULL TRKD HI SP",
      "Model": "H1-DV-100",
      "Equipment": 1017866781,
      "Serial": "7RR00014",
      "Material": 14232819,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T76541",
      "AdminNo": "A372",
      "Description": "TRCTR FULL TRKD HI SP",
      "Model": "H1-DV-100",
      "Equipment": 1017866780,
      "Serial": "7RR00047",
      "Material": 14232819,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T56383",
      "AdminNo": "B110",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868319,
      "Serial": 258786,
      "Material": 15402017,
      "EQSLOC": "DW2X"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T95555",
      "AdminNo": "B17T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1002328383,
      "Serial": "TM-204750EGJT",
      "Material": 14491776,
      "EQSLOC": "DVYK"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T56383",
      "AdminNo": "B220",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868071,
      "Serial": 258864,
      "Material": 15402017,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "L77215",
      "AdminNo": "B220",
      "Description": "LOAD SKD STR TYP III",
      "Model": "M400W",
      "Equipment": 1017869980,
      "Serial": "NBM425892",
      "Material": 15524487,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "V05001",
      "AdminNo": "B31H",
      "Description": "VEHICLE MINE MOUNTE",
      "Model": "HUSKY MK3",
      "Equipment": 1017866795,
      "Serial": "3452A",
      "Material": 15815174,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T93271",
      "AdminNo": "B326",
      "Description": "TRK CGO LWB WO/WINCH",
      "Model": "M1085A1P2WOW",
      "Equipment": 1017868840,
      "Serial": "P-D713068EHGW",
      "Material": 15527773,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T63161",
      "AdminNo": "B352",
      "Description": "TRK WRECK M984A4 WO/W",
      "Model": "M984A4WO/W",
      "Equipment": 1017867922,
      "Serial": "10T2K1J28J1033036",
      "Material": 15342245,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T41995",
      "AdminNo": "B40",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867335,
      "Serial": "L-A114406BGKT",
      "Material": 14473882,
      "EQSLOC": "DW4O"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T56383",
      "AdminNo": "B6",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868316,
      "Serial": 262290,
      "Material": 15402017,
      "EQSLOC": "EGMZ"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T41036",
      "AdminNo": "C11",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868646,
      "Serial": "M-A114566BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0X"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T07679",
      "AdminNo": "C26",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870433,
      "Serial": 511049,
      "Material": 13469317,
      "EQSLOC": "EGQD"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T07679",
      "AdminNo": "C6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869757,
      "Serial": 502284,
      "Material": 13469317,
      "EQSLOC": "DW33"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T07679",
      "AdminNo": "C7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870511,
      "Serial": 511305,
      "Material": 13469317,
      "EQSLOC": "DW33"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "CEA6",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869332,
      "Serial": "M-A114488BGKT",
      "Material": 14473889,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G18358",
      "AdminNo": "CGEN2",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1010190596,
      "Serial": "FZA02758",
      "Material": 12853012,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G18358",
      "AdminNo": "CGEN85",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864397,
      "Serial": "FZA02347",
      "Material": 12853012,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "H57916",
      "AdminNo": "CH11",
      "Description": "HOWIT MED TWD M777",
      "Model": "M777A2",
      "Equipment": 1009906635,
      "Serial": 399,
      "Material": 994637551,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T56383",
      "AdminNo": "CML226",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1011558664,
      "Serial": 331073,
      "Material": 15402017,
      "EQSLOC": "EGQE"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T41036",
      "AdminNo": "D102",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868588,
      "Serial": "M-A114642BGKT",
      "Material": 14473889,
      "EQSLOC": "EGRB"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34704",
      "AdminNo": "D16H",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868807,
      "Serial": 325408,
      "Material": 15402038,
      "EQSLOC": "AH3J"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34704",
      "AdminNo": "D22",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868810,
      "Serial": 325442,
      "Material": 15402038,
      "EQSLOC": "DW0B"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T55054",
      "AdminNo": "D220",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869331,
      "Serial": "10T2K1J25F1025791",
      "Material": 15341872,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T95992",
      "AdminNo": "D28T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865531,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "DW0B"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T41036",
      "AdminNo": "D306",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866922,
      "Serial": "M-A114337BGKT",
      "Material": 14473889,
      "EQSLOC": "EGRC"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34704",
      "AdminNo": "D32",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868815,
      "Serial": 325542,
      "Material": 15402038,
      "EQSLOC": "AH3T"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T60081",
      "AdminNo": "D410",
      "Description": "TRK CGO M1078A1 LMTV",
      "Model": "M1078A1",
      "Equipment": 1017868466,
      "Serial": "A-A012518BFCJ",
      "Material": 14476343,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34704",
      "AdminNo": "D46H",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868802,
      "Serial": 325328,
      "Material": 15402038,
      "EQSLOC": "EGPW"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34840",
      "AdminNo": "D47",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868962,
      "Serial": 328191,
      "Material": 15449638,
      "EQSLOC": "EGOB"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "W98825",
      "AdminNo": "D5T",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863959,
      "Serial": 320,
      "Material": 11087367,
      "EQSLOC": "EGPZ"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T07679",
      "AdminNo": "D7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870065,
      "Serial": 511220,
      "Material": 13469317,
      "EQSLOC": "EVCT"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T95992",
      "AdminNo": "D7T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865139,
      "Serial": 10718,
      "Material": 13875443,
      "EQSLOC": "EGPZ"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "S75175",
      "AdminNo": "E341T",
      "Description": "STRLR VAN SUP",
      "Model": "M129A3",
      "Equipment": 1011568084,
      "Serial": "1HZV29203E1007214",
      "Material": 11757379,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "M05030",
      "AdminNo": "EOD28",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1240A1",
      "Equipment": 1020269939,
      "Serial": "10TBTAX35AS119413",
      "Material": 15961330,
      "EQSLOC": "FK9A"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "M74226",
      "AdminNo": "EOD33",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1227A1",
      "Equipment": 1019573028,
      "Serial": "MMPVR00211",
      "Material": 16096047,
      "EQSLOC": "EGS1"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T55054",
      "AdminNo": "F247",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869428,
      "Serial": "10T2K1J28F1026045",
      "Material": 15341872,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T96496",
      "AdminNo": "F314",
      "Description": "TRK PAL LO M1120A2",
      "Model": "M1120A2",
      "Equipment": 1017869106,
      "Serial": "10TGJ6Y165S085848",
      "Material": 14928221,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T58318",
      "AdminNo": "F332",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869205,
      "Serial": "10TGJAM19AS123480",
      "Material": 15341117,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41995",
      "AdminNo": "G240",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867384,
      "Serial": "L-T120897EHAW",
      "Material": 14473882,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T55054",
      "AdminNo": "G244",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869434,
      "Serial": "10T2K1J23G1026245",
      "Material": 15341872,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "W98825",
      "AdminNo": "G3W",
      "Description": "TRALR WTR M1112 8 WHL",
      "Model": "M1112",
      "Equipment": 1017863875,
      "Serial": "PH0C8T-204",
      "Material": 13899073,
      "EQSLOC": "DW33"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T56383",
      "AdminNo": "G6",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868710,
      "Serial": 258819,
      "Material": 15402017,
      "EQSLOC": "DW11"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T07679",
      "AdminNo": "H101",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870453,
      "Serial": 510829,
      "Material": 13469317,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41036",
      "AdminNo": "H244",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869691,
      "Serial": "M-A114687BGKT",
      "Material": 14473889,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H312",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867012,
      "Serial": "L-A114530BGKT",
      "Material": 14473882,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T55054",
      "AdminNo": "H318",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869432,
      "Serial": "10T2K1J26J1035402",
      "Material": 15341872,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T73347",
      "AdminNo": "HFORK",
      "Description": "TRK LFT FK VAR RCH RT",
      "Model": "ATLAS",
      "Equipment": 1017869724,
      "Serial": "10KA2262R",
      "Material": 14172886,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB163",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870081,
      "Serial": 511437,
      "Material": 13469317,
      "EQSLOC": "EGQT"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "K29708",
      "AdminNo": "HHB242",
      "Description": "KNIGHT ARMORED M1200",
      "Model": "M1200",
      "Equipment": 1009719401,
      "Serial": "K1434",
      "Material": 15388373,
      "EQSLOC": "DW37"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "K29708",
      "AdminNo": "HHB243",
      "Description": "KNIGHT ARMORED M1200",
      "Model": "M1200",
      "Equipment": 1009719403,
      "Serial": "K1433",
      "Material": 15388373,
      "EQSLOC": "DW37"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "K29708",
      "AdminNo": "HHB244",
      "Description": "KNIGHT ARMORED M1200",
      "Model": "M1200",
      "Equipment": 1011498394,
      "Serial": "K1237",
      "Material": 15388373,
      "EQSLOC": "DW37"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T38844",
      "AdminNo": "HHB321",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869010,
      "Serial": 55779,
      "Material": 11112274,
      "EQSLOC": "EGQK"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "L26934",
      "AdminNo": "HHB334G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870720,
      "Serial": "T14-311-013",
      "Material": 15623992,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T41995",
      "AdminNo": "HHC5",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869119,
      "Serial": "L-A115035BGLT",
      "Material": 14473882,
      "EQSLOC": "DW1Q"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "W98825",
      "AdminNo": "HHC5T",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863722,
      "Serial": 574,
      "Material": 11087367,
      "EQSLOC": "DW1Q"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T41995",
      "AdminNo": "HQ100",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869728,
      "Serial": "L-A114970BGLT",
      "Material": 14473882,
      "EQSLOC": "DVZZ"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ18",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870588,
      "Serial": 573381,
      "Material": 13469317,
      "EQSLOC": "DW3R"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T37588",
      "AdminNo": "HQ22",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867843,
      "Serial": 262956,
      "Material": 15402007,
      "EQSLOC": "DW2S"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ31",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870650,
      "Serial": 573410,
      "Material": 13469317,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "G42170",
      "AdminNo": "HQ32GT",
      "Description": "GEN SET HMT PU-798A",
      "Model": "PU798A",
      "Equipment": 1017869908,
      "Serial": "T-96-019-004",
      "Material": 14133818,
      "EQSLOC": "EGR3"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "G18358",
      "AdminNo": "HQ34G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866100,
      "Serial": "FZA14977",
      "Material": 12853012,
      "EQSLOC": "EGR3"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T37588",
      "AdminNo": "HQ36",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868160,
      "Serial": 333450,
      "Material": 15402007,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T56383",
      "AdminNo": "HQ6",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1014516131,
      "Serial": 315311,
      "Material": 15402017,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T34704",
      "AdminNo": "HQ6",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017867746,
      "Serial": 300002,
      "Material": 15402038,
      "EQSLOC": "DW3P"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T56383",
      "AdminNo": "HQ6",
      "Description": "TRK UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868073,
      "Serial": 258910,
      "Material": 15402017,
      "EQSLOC": "EGQQ"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ63",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870509,
      "Serial": 511399,
      "Material": 13469317,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "C11280",
      "AdminNo": "HQ6S",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869184,
      "Serial": "88-AFL6190",
      "Material": 12816451,
      "EQSLOC": "DVZW"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T38844",
      "AdminNo": "HQ83",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869137,
      "Serial": 56009,
      "Material": 11112274,
      "EQSLOC": "EGQ1"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "MED7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870361,
      "Serial": 511145,
      "Material": 13469317,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "MTR1",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870072,
      "Serial": 511250,
      "Material": 13469317,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "MTR3",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870064,
      "Serial": 511216,
      "Material": 13469317,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "MTR4",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870073,
      "Serial": 511254,
      "Material": 13469317,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "LF3002",
      "AdminNo": "R138F",
      "Description": "TRUCK FORKLIFT: 930 (6K) JCB",
      "Model": "",
      "Equipment": 1017869366,
      "Serial": 608489,
      "Material": "01C045641",
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T56383",
      "AdminNo": "SNE-C",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1014516186,
      "Serial": 324749,
      "Material": 15402017,
      "EQSLOC": "AH2G"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "H00586",
      "AdminNo": "WC9TG0-60H",
      "Description": "HEATER D 120000BTU/HR",
      "Model": "H140",
      "Equipment": 1017868876,
      "Serial": "H1403360",
      "Material": 14770568,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "H00586",
      "AdminNo": "WC9TG0-EE48H",
      "Description": "HEATER D 120000BTU/HR",
      "Model": "H140",
      "Equipment": 1017862743,
      "Serial": "H1403325",
      "Material": 14770568,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T41995",
      "AdminNo": "WH9RT0-HHC4",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869133,
      "Serial": "L-A114709BGKT",
      "Material": 14473882,
      "EQSLOC": "DVYV"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T38844",
      "AdminNo": "WH9RT0-HHC85A",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869136,
      "Serial": 55194,
      "Material": 11112274,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ23",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870260,
      "Serial": 511341,
      "Material": 13469317,
      "EQSLOC": "DVZ2"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ32Z",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870094,
      "Serial": 203524,
      "Material": 13808604,
      "EQSLOC": "AH3U"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091501,
      "Serial": "1120180611X1297",
      "Material": 16698480,
      "EQSLOC": "EGNM"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A11",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017201248,
      "Serial": 603387,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T41036",
      "AdminNo": "A113",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868772,
      "Serial": "M-T120800EHMV",
      "Material": 14473889,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A114",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869433,
      "Serial": "10T2K1J22H1029963",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96496",
      "AdminNo": "A205",
      "Description": "TRK PAL LO M1120A2R1",
      "Model": "M1120A2R1",
      "Equipment": 1017867855,
      "Serial": "10T2K1J20D1020916",
      "Material": 14928230,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A21",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017197614,
      "Serial": 500817,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A21A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017198783,
      "Serial": 503925,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A23",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017199296,
      "Serial": 604821,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34840",
      "AdminNo": "A23",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868958,
      "Serial": 328072,
      "Material": 15449638,
      "EQSLOC": "EGQ8"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34840",
      "AdminNo": "A33",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869087,
      "Serial": 326064,
      "Material": 15449638,
      "EQSLOC": "EGQ7"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T91656",
      "AdminNo": "A333",
      "Description": "LGHT EQ TRNSP M916A3",
      "Model": "M916A3",
      "Equipment": 1017830582,
      "Serial": "1FULATCG25PN30174",
      "Material": 14886962,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "S70594",
      "AdminNo": "A333T",
      "Description": "STLR LB 40T M870A1",
      "Model": "M870A1",
      "Equipment": 1017869809,
      "Serial": "1HZL42306108864",
      "Material": 12249245,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T91656",
      "AdminNo": "A334",
      "Description": "LGHT EQ TRNSP M916A3",
      "Model": "M916A3",
      "Equipment": 1017830583,
      "Serial": "1FULATCG85PN30180",
      "Material": 14886962,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "S70594",
      "AdminNo": "A334T",
      "Description": "STLR LB 40T M870A1",
      "Model": "M870A1",
      "Equipment": 1017869810,
      "Serial": 8911,
      "Material": 12249245,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A334T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870183,
      "Serial": "SB859102",
      "Material": 13035197,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T05029",
      "AdminNo": "A362",
      "Description": "TRACTOR,FULL TRACKE",
      "Model": "D6K W/WINCH",
      "Equipment": 1017868784,
      "Serial": "HMG00134",
      "Material": 15652600,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T41995",
      "AdminNo": "A37",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869117,
      "Serial": "L-A115004BGLT",
      "Material": 14473882,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T41995",
      "AdminNo": "A4",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867395,
      "Serial": "L-T120966EHBW",
      "Material": 14473882,
      "EQSLOC": "DW3L"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T07679",
      "AdminNo": "A92",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869991,
      "Serial": 511342,
      "Material": 13469317,
      "EQSLOC": "DW2W"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "G42488",
      "AdminNo": "A9567",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1017870429,
      "Serial": "K120419567",
      "Material": 15617329,
      "EQSLOC": "DW2X"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "AE1",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870343,
      "Serial": 511313,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T37588",
      "AdminNo": "AE3",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868035,
      "Serial": 263028,
      "Material": 15402007,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B11",
      "Description": "TRK UTIL HV M1097A1",
      "Model": "M1097A1",
      "Equipment": 1017199493,
      "Serial": 165085,
      "Material": 13719583,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B11",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868848,
      "Serial": 901261,
      "Material": 15402038,
      "EQSLOC": "AH2F"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B11A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017200523,
      "Serial": 601589,
      "Material": 13469317,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "H05007",
      "AdminNo": "B13H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059275,
      "Serial": 259,
      "Material": 15984568,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34840",
      "AdminNo": "B16",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869088,
      "Serial": 315807,
      "Material": 15449638,
      "EQSLOC": "AH2F"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T88983",
      "AdminNo": "B205",
      "Description": "TRK TCTR WO/WINCH",
      "Model": "M1088A1P2WOW",
      "Equipment": 1031488012,
      "Serial": "10TANHFF2JS782383",
      "Material": 15527759,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B21",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017198922,
      "Serial": 770037,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T76541",
      "AdminNo": "B210",
      "Description": "TRCTR FULL TRKD HI SP",
      "Model": "H1-DV-100",
      "Equipment": 1017869560,
      "Serial": "7RR00116",
      "Material": 14232819,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T40090",
      "AdminNo": "B210TG",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870918,
      "Serial": "A130435401",
      "Material": 15623689,
      "EQSLOC": "DW0C"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T41036",
      "AdminNo": "B211",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868649,
      "Serial": "M-A114647BGKT",
      "Material": 14473889,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T76541",
      "AdminNo": "B211",
      "Description": "TRCTR FULL TRKD HI SP",
      "Model": "H1-DV-100",
      "Equipment": 1017869561,
      "Serial": "7RR00084",
      "Material": 14232819,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T41036",
      "AdminNo": "B212",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868760,
      "Serial": "M-A114670BGKT",
      "Material": 14473889,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "L76556",
      "AdminNo": "B221",
      "Description": "LDR SCP 950BNS",
      "Model": "950BNS",
      "Equipment": 1017869945,
      "Serial": "22Z00717PFA",
      "Material": 11267915,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B22X",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870505,
      "Serial": 511373,
      "Material": 13469317,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B23",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017198925,
      "Serial": 770048,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "S70594",
      "AdminNo": "B231T",
      "Description": "STLR LB 40T M870A1",
      "Model": "M870A1",
      "Equipment": 1017868028,
      "Serial": "1HZL44305G1008919",
      "Material": 12249245,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T56383",
      "AdminNo": "B27 (FOX)",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868320,
      "Serial": 258890,
      "Material": 15402017,
      "EQSLOC": "EGP4"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "M05004",
      "AdminNo": "B31B",
      "Description": "TRUCK,BOMB SERVICE",
      "Model": "BUFFALO MK3",
      "Equipment": 1017866845,
      "Serial": "5ZSB6EAGXDA106510",
      "Material": 15674930,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T39954",
      "AdminNo": "B325TG",
      "Description": "GENERAT SE DIE",
      "Model": "PU-2102",
      "Equipment": 1017869773,
      "Serial": "C150808399",
      "Material": 15624106,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "V05001",
      "AdminNo": "B32H",
      "Description": "VEHICLE MINE MOUNTE",
      "Model": "HUSKY MK3",
      "Equipment": 1017866838,
      "Serial": "3453B",
      "Material": 15815174,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34840",
      "AdminNo": "B33",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869086,
      "Serial": 315845,
      "Material": 15449638,
      "EQSLOC": "DW4N"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41995",
      "AdminNo": "B355",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867377,
      "Serial": "L-A114909BGKT",
      "Material": 14473882,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41515",
      "AdminNo": "C11",
      "Description": "TRK CGO 5 TON WO/W",
      "Model": "M1083A1P2WOW",
      "Equipment": 1017189353,
      "Serial": "10TANHFF3DS751809",
      "Material": 15498610,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T37588",
      "AdminNo": "C110",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868062,
      "Serial": 263215,
      "Material": 15402007,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41104",
      "AdminNo": "C111",
      "Description": "TK CG 5T 6X6 W/E W/W",
      "Model": "M1093A1WW",
      "Equipment": 1017869244,
      "Serial": "M-A114518BGKT",
      "Material": 14476342,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C113",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870352,
      "Serial": 511283,
      "Material": 13469317,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG6WC0",
      "LINNumber": "YF1097",
      "AdminNo": "C12",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091509,
      "Serial": "1120180619X1297",
      "Material": 16698480,
      "EQSLOC": "EGPU"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T59584",
      "AdminNo": "C12A",
      "Description": "TK CAR M1084A1P2 WO/W",
      "Model": "M1084A1P2WOW",
      "Equipment": 1017188594,
      "Serial": "C-D707467EHLV",
      "Material": 15527739,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "C13",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868587,
      "Serial": "M-A114662BGKT",
      "Material": 14473889,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T59584",
      "AdminNo": "C13A",
      "Description": "TK CAR M1084A1P2 WO/W",
      "Model": "M1084A1P2WOW",
      "Equipment": 1017188743,
      "Serial": "C-D707464EHLV",
      "Material": 15527739,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "C16",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870297,
      "Serial": 213059,
      "Material": 13808604,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "C17",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870111,
      "Serial": 213477,
      "Material": 13808604,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WG6WC0",
      "LINNumber": "YF1097",
      "AdminNo": "C21",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091513,
      "Serial": "1120180623X1297",
      "Material": 16698480,
      "EQSLOC": "EGPS"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T59584",
      "AdminNo": "C21A",
      "Description": "TK CAR M1084A1P2 WO/W",
      "Model": "M1084A1P2WOW",
      "Equipment": 1017188738,
      "Serial": "C-D707536EHLV",
      "Material": 15527739,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "C22",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866927,
      "Serial": "M-A114492BGKT",
      "Material": 14473889,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T59584",
      "AdminNo": "C23A",
      "Description": "TK CAR M1084A1P2 WO/W",
      "Model": "M1084A1P2WOW",
      "Equipment": 1017188736,
      "Serial": "C-D707537EHLV",
      "Material": 15527739,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "C26",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870105,
      "Serial": 201959,
      "Material": 13808604,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "C28",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870115,
      "Serial": 206748,
      "Material": 13808604,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T56383",
      "AdminNo": "C285",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868075,
      "Serial": 262279,
      "Material": 15402017,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T56383",
      "AdminNo": "C290",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868396,
      "Serial": 330973,
      "Material": 15402017,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T38844",
      "AdminNo": "C31",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869000,
      "Serial": 46501,
      "Material": 11112274,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T38844",
      "AdminNo": "C38",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869006,
      "Serial": 55024,
      "Material": 11112274,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T07679",
      "AdminNo": "C5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870002,
      "Serial": 511275,
      "Material": 13469317,
      "EQSLOC": "DW32"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "C5",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870098,
      "Serial": 179977,
      "Material": 13808604,
      "EQSLOC": "DVYE"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "CEA13",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869110,
      "Serial": "M-A114683BGKT",
      "Material": 14473889,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G18358",
      "AdminNo": "D202G3K",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861484,
      "Serial": "FZA15430",
      "Material": 12853012,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G18358",
      "AdminNo": "D207G3K",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861483,
      "Serial": "FZA08906",
      "Material": 12853012,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T55054",
      "AdminNo": "D222",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869539,
      "Serial": "10T2K1J29L1041939",
      "Material": 15341872,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T55054",
      "AdminNo": "D224",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869426,
      "Serial": "10T2K1J2XG1027862",
      "Material": 15341872,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34840",
      "AdminNo": "D23H",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869078,
      "Serial": 316143,
      "Material": 15449638,
      "EQSLOC": "EGPY"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34840",
      "AdminNo": "D33",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868956,
      "Serial": 327108,
      "Material": 15449638,
      "EQSLOC": "AH3T"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41036",
      "AdminNo": "D4",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868592,
      "Serial": "M-A114665BGKT",
      "Material": 14473889,
      "EQSLOC": "EGP5"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T61630",
      "AdminNo": "D403",
      "Description": "TRUCK UTILITY M1113",
      "Model": "M1113",
      "Equipment": 1017870279,
      "Serial": 222122,
      "Material": 14120143,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D406",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869830,
      "Serial": 502528,
      "Material": 13469317,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T49255",
      "AdminNo": "D4K",
      "Description": "TRK LF FK 4K W/O CAB",
      "Model": "MHE270",
      "Equipment": 1017869158,
      "Serial": "8909-560",
      "Material": 13308907,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D5",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870298,
      "Serial": 222245,
      "Material": 13808604,
      "EQSLOC": "EGRD"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D503",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097R1",
      "Equipment": 1017870571,
      "Serial": 571617,
      "Material": 13469317,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T07679",
      "AdminNo": "D6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869763,
      "Serial": 502552,
      "Material": 13469317,
      "EQSLOC": "EGP5"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869820,
      "Serial": 502492,
      "Material": 13469317,
      "EQSLOC": "EGRD"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "M30688",
      "AdminNo": "DMTRCS",
      "Description": "MULT-TEMP REFR CONT",
      "Model": "MTRCS02",
      "Equipment": 1017868401,
      "Serial": 9500956,
      "Material": 15929018,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T41036",
      "AdminNo": "E101",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866920,
      "Serial": "M-A114313BGKT",
      "Material": 14473889,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T41995",
      "AdminNo": "E113",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867100,
      "Serial": "L-A115031BGLT",
      "Material": 14473882,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T58318",
      "AdminNo": "E222",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869201,
      "Serial": "10T2K1J28G1027844",
      "Material": 15341117,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T55054",
      "AdminNo": "E232",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869540,
      "Serial": "10T2K1J25F1024625",
      "Material": 15341872,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T93761",
      "AdminNo": "E233T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869794,
      "Serial": "10TMP223081644101",
      "Material": 13035197,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T63093",
      "AdminNo": "E332",
      "Description": "TRK WRECKER M984A2",
      "Model": "M984A2",
      "Equipment": 1017869564,
      "Serial": "10TGJ6Y1X5S083133",
      "Material": 14928224,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T61239",
      "AdminNo": "E341",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868409,
      "Serial": "T-A012319BFAJ",
      "Material": 14473893,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T07679",
      "AdminNo": "E7",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870109,
      "Serial": 212561,
      "Material": 13808604,
      "EQSLOC": "AH88"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "M05029",
      "AdminNo": "EOD29",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1277",
      "Equipment": 1023529557,
      "Serial": "10TBTAX34AX124718",
      "Material": 16230967,
      "EQSLOC": "FK98"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T41036",
      "AdminNo": "F116",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869692,
      "Serial": "M-A114335BGKT",
      "Material": 14473889,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T37588",
      "AdminNo": "F210",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868240,
      "Serial": 332624,
      "Material": 15402007,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T07679",
      "AdminNo": "F211",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869755,
      "Serial": 502497,
      "Material": 13469317,
      "EQSLOC": "DW19"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T94709",
      "AdminNo": "F243",
      "Description": "TRUCK WKR W/W M1089A1",
      "Model": "M1089A1WW",
      "Equipment": 1017869545,
      "Serial": "W-A012297BFAJ",
      "Material": 14473892,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T63161",
      "AdminNo": "F246",
      "Description": "TRK WRECK M984A4 WO/W",
      "Model": "M984A4WO/W",
      "Equipment": 1017867919,
      "Serial": "10TGJAM1X9S103234",
      "Material": 15342245,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T41036",
      "AdminNo": "F262",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868585,
      "Serial": "M-A114644BGKT",
      "Material": 14473889,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T41995",
      "AdminNo": "F265",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869116,
      "Serial": "L-A114995BGLT",
      "Material": 14473882,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "C11280",
      "AdminNo": "F30",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869175,
      "Serial": "88-MY00GS",
      "Material": 12816451,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T55054",
      "AdminNo": "F321",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869414,
      "Serial": "10T2K1J29G1026430",
      "Material": 15341872,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T95555",
      "AdminNo": "F324T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868888,
      "Serial": "TM-204416BGGT",
      "Material": 14491776,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T87243",
      "AdminNo": "F331",
      "Description": "TRK TANK M978A2",
      "Model": "M978A2",
      "Equipment": 1017869211,
      "Serial": "10TGJ6Y158S097056",
      "Material": 14928215,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T07679",
      "AdminNo": "F36",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870510,
      "Serial": 511410,
      "Material": 13469317,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T60149",
      "AdminNo": "FFT-1-102",
      "Description": "TRK CARGO M1078A1 W/W",
      "Model": "M1078A1WW",
      "Equipment": 1017867544,
      "Serial": "A-A109495BGBT",
      "Material": 14473888,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T55054",
      "AdminNo": "G243",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869409,
      "Serial": "10T2K1J20G1027935",
      "Material": 15341872,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T93761",
      "AdminNo": "G245T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869874,
      "Serial": 81828,
      "Material": 13035197,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T55054",
      "AdminNo": "G246",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869418,
      "Serial": "10T2K1J20L1041893",
      "Material": 15341872,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T40090",
      "AdminNo": "GEN04F",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870914,
      "Serial": "A130435423",
      "Material": 15623689,
      "EQSLOC": "GNOU"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "G07461",
      "AdminNo": "GEN08",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870852,
      "Serial": "K120421025",
      "Material": 15617455,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T60081",
      "AdminNo": "H309",
      "Description": "TRK CGO M1078A1 LMTV",
      "Model": "M1078A1",
      "Equipment": 1017868654,
      "Serial": "A-A012622BFDJ",
      "Material": 14476343,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41036",
      "AdminNo": "H313",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869690,
      "Serial": "M-A114682BGKT",
      "Material": 14473889,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "C11280",
      "AdminNo": "H3S-2",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869174,
      "Serial": "88-AFL5646",
      "Material": 12816451,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB211",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870256,
      "Serial": 511301,
      "Material": 13469317,
      "EQSLOC": "DW3A"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB222",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870356,
      "Serial": 510933,
      "Material": 13469317,
      "EQSLOC": "DW38"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB223",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870248,
      "Serial": 511091,
      "Material": 13469317,
      "EQSLOC": "DW38"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB224",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870151,
      "Serial": 511196,
      "Material": 13469317,
      "EQSLOC": "DW38"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB231",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870448,
      "Serial": 511297,
      "Material": 13469317,
      "EQSLOC": "DW39"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T41995",
      "AdminNo": "HHB311",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867007,
      "Serial": "L-A114382BGKT",
      "Material": 14473882,
      "EQSLOC": "EGQS"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T38844",
      "AdminNo": "HHB322",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869012,
      "Serial": 52745,
      "Material": 11112274,
      "EQSLOC": "EGQK"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T34704",
      "AdminNo": "HHC26",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868801,
      "Serial": 300015,
      "Material": 15402038,
      "EQSLOC": "DW3U"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T41995",
      "AdminNo": "HHC5",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867376,
      "Serial": "L-A114410BGKT",
      "Material": 14473882,
      "EQSLOC": "AH3B"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HHC7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870265,
      "Serial": 511357,
      "Material": 13469317,
      "EQSLOC": "DW1P"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T41995",
      "AdminNo": "HHC70",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867390,
      "Serial": "L-T120938EHBW",
      "Material": 14473882,
      "EQSLOC": "EGRU"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "W98825",
      "AdminNo": "HHC92T",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863869,
      "Serial": "A2678",
      "Material": 11087367,
      "EQSLOC": "DW4R"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "M30688",
      "AdminNo": "HMATRIX",
      "Description": "MULT-TEMP REFR CONT",
      "Model": "MTRCS02",
      "Equipment": 1017868402,
      "Serial": "RU9500952",
      "Material": 15929018,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T60081",
      "AdminNo": "HQ34X",
      "Description": "TRK CGO M1078A1 LMTV",
      "Model": "M1078A1",
      "Equipment": 1017868465,
      "Serial": "A-A012467BFCJ",
      "Material": 14476343,
      "EQSLOC": "AH3A"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ37",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870439,
      "Serial": 511192,
      "Material": 13469317,
      "EQSLOC": "AH2I"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T56383",
      "AdminNo": "HQ3C",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868317,
      "Serial": 262318,
      "Material": 15402017,
      "EQSLOC": "EGR3"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ4",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869831,
      "Serial": 502466,
      "Material": 13469317,
      "EQSLOC": "EGR4"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ63",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870494,
      "Serial": 511271,
      "Material": 13469317,
      "EQSLOC": "AH2I"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ66",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869829,
      "Serial": 502496,
      "Material": 13469317,
      "EQSLOC": "AH2I"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ67",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870277,
      "Serial": 511303,
      "Material": 13469317,
      "EQSLOC": "AH2I"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T38844",
      "AdminNo": "MED1",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869001,
      "Serial": 50743,
      "Material": 11112274,
      "EQSLOC": "DW3S"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T41995",
      "AdminNo": "MED3",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869126,
      "Serial": "L-A114442BGKT",
      "Material": 14473882,
      "EQSLOC": "DW3S"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T41995",
      "AdminNo": "R111",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869737,
      "Serial": "L-A115000BGLT",
      "Material": 14473882,
      "EQSLOC": "G4G5"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "G74783",
      "AdminNo": "W92RAA-R071X",
      "Description": "GRADER ROAD CAT 130G",
      "Model": "130G",
      "Equipment": 1017491064,
      "Serial": "7GB00812",
      "Material": 11504795,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "C11280",
      "AdminNo": "WC9TG0-SUSV1",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869179,
      "Serial": "88-AFL6781",
      "Material": 12816451,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "C11280",
      "AdminNo": "WC9TG0-SUSV2",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869182,
      "Serial": "88-AFL7041",
      "Material": 12816451,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T38844",
      "AdminNo": "WH9RT0-HHC82A",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869015,
      "Serial": 53651,
      "Material": 11112274,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC93",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870003,
      "Serial": 511317,
      "Material": 13469317,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC94",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870261,
      "Serial": 511383,
      "Material": 13469317,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ12",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870176,
      "Serial": 511387,
      "Material": 13469317,
      "EQSLOC": "DVZ1"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T41995",
      "AdminNo": "WH9RT0-HQ31",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017866997,
      "Serial": "L-A114994BGLT",
      "Material": 14473882,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "G18358",
      "AdminNo": "WH9RT0-HQ61G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864476,
      "Serial": "FZA02271",
      "Material": 12853012,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A100T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869786,
      "Serial": 82911,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A102R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752818,
      "Serial": "SCO9822",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A115T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869781,
      "Serial": 82898,
      "Material": 13035197,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A11R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752879,
      "Serial": "SCO19741",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A12R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752882,
      "Serial": "SCO19756",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A20R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752887,
      "Serial": "SCO19837",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A22R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752889,
      "Serial": "SCO19851",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A2R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753112,
      "Serial": "999111XXX",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A30R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752892,
      "Serial": "SCO19889",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A31R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752895,
      "Serial": "SCO19910",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A37R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752977,
      "Serial": "SCO19923",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A41R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752979,
      "Serial": "SCO19934",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A43R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752980,
      "Serial": "SCO19935",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A45R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752981,
      "Serial": "SCO19939",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A4R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752821,
      "Serial": "SCO10194",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A50R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752984,
      "Serial": "SCO19948",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A53R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752985,
      "Serial": "SCO19949",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A54R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752986,
      "Serial": "SCO19963",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A55R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752773,
      "Serial": "SCO2170",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A59R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752988,
      "Serial": "SCO37814",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A5R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752822,
      "Serial": "SCO12471",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A60R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752828,
      "Serial": "SCO37833",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A63R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753041,
      "Serial": "SCO37900",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A65R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753048,
      "Serial": "SCO37988",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A66R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753049,
      "Serial": "SCO38006",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A67R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752990,
      "Serial": "SCO38014",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A68R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752992,
      "Serial": "SCO38028",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A7R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752823,
      "Serial": "SCO19737",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A84R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753099,
      "Serial": "SCO38233",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A99R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753108,
      "Serial": "SCO45233",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725270,
      "Serial": "SC010286",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725953,
      "Serial": "SC020066",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725956,
      "Serial": "SC020093",
      "Material": 14422751,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725957,
      "Serial": "SC020098",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725961,
      "Serial": "SC020131",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725962,
      "Serial": "SC020148",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725963,
      "Serial": "SC020181",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008726841,
      "Serial": "SC036459",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008739693,
      "Serial": "SC028004",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009051318,
      "Serial": "SC028144",
      "Material": 14422751,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009114118,
      "Serial": "SC019335",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009123983,
      "Serial": "SC017592",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009140804,
      "Serial": "SC036929",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009145130,
      "Serial": "SC017830",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009147954,
      "Serial": "SCR0035",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009156683,
      "Serial": "SC0414",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009167085,
      "Serial": "SC015754",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009185729,
      "Serial": "SC031752",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009198699,
      "Serial": "SC035970",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009211721,
      "Serial": "SC015092",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009253494,
      "Serial": "SC05645",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009253507,
      "Serial": "SC04826",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009253508,
      "Serial": "SC01449",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009275775,
      "Serial": "SC035993",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009292374,
      "Serial": "SC04510",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009304237,
      "Serial": "SCR0077",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009304267,
      "Serial": "SCR0081",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009334322,
      "Serial": "SCR0041",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009334326,
      "Serial": "SC010075",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009334328,
      "Serial": "SC09119",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009349678,
      "Serial": "SC019294",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019525978,
      "Serial": "H02844",
      "Material": 14505671,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019526058,
      "Serial": "H03372",
      "Material": 14505671,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019526083,
      "Serial": "H03548",
      "Material": 14505671,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019526093,
      "Serial": "H03609",
      "Material": 14505671,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019526168,
      "Serial": "H04188",
      "Material": 14505671,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019526181,
      "Serial": "H04268",
      "Material": 14505671,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019526182,
      "Serial": "H04275",
      "Material": 14505671,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "K57821",
      "AdminNo": "'-",
      "Description": "HOW MED TWD 155MMM198",
      "Model": "M198",
      "Equipment": 1020271610,
      "Serial": 681,
      "Material": 10266648,
      "EQSLOC": "EGS1"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022019892,
      "Serial": "SC01412",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022201828,
      "Serial": "SC031556",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022201829,
      "Serial": "SC031623",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022201834,
      "Serial": "SC0761",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022559307,
      "Serial": "SC015861",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022559340,
      "Serial": "SC02949",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022847634,
      "Serial": "SC011550",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022847643,
      "Serial": "SC023884",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1023512015,
      "Serial": 17859,
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "'-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1023512181,
      "Serial": 9077,
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091496,
      "Serial": "1120180605X1297",
      "Material": 16698480,
      "EQSLOC": "EGQD"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091503,
      "Serial": "1120180613X1297",
      "Material": 16698480,
      "EQSLOC": "EGQD"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091504,
      "Serial": "1120180614X1297",
      "Material": 16698480,
      "EQSLOC": "DW33"
    },
    {
      "UIC": "WG6WA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091505,
      "Serial": "1120180615X1297",
      "Material": 16698480,
      "EQSLOC": "EGPK"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091506,
      "Serial": "1120180616X1297",
      "Material": 16698480,
      "EQSLOC": "DVZK"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091507,
      "Serial": "1120180617X1297",
      "Material": 16698480,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091510,
      "Serial": "1120180620X1297",
      "Material": 16698480,
      "EQSLOC": "AH3R"
    },
    {
      "UIC": "WG6WA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091514,
      "Serial": "1120180624X1297",
      "Material": 16698480,
      "EQSLOC": "EGPK"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091515,
      "Serial": "1120180625X1297",
      "Material": 16698480,
      "EQSLOC": "EGQE"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091516,
      "Serial": "1120180626X1297",
      "Material": 16698480,
      "EQSLOC": "DVZK"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091517,
      "Serial": "1120180627X1297",
      "Material": 16698480,
      "EQSLOC": "EGNH"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091518,
      "Serial": "1120180628X1297",
      "Material": 16698480,
      "EQSLOC": "EGNM"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091519,
      "Serial": "1120180629X1297",
      "Material": 16698480,
      "EQSLOC": "EGNI"
    },
    {
      "UIC": "WG6WA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091520,
      "Serial": "1120180630X1297",
      "Material": 16698480,
      "EQSLOC": "EGPJ"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091522,
      "Serial": "1120180632X1297",
      "Material": 16698480,
      "EQSLOC": "EGNG"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091523,
      "Serial": "1120180633X1297",
      "Material": 16698480,
      "EQSLOC": "EGNH"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091524,
      "Serial": "1120180634X1297",
      "Material": 16698480,
      "EQSLOC": "EGNG"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091526,
      "Serial": "1120180636X1297",
      "Material": 16698480,
      "EQSLOC": "DVZG"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091527,
      "Serial": "1120180637X1297",
      "Material": 16698480,
      "EQSLOC": "DVZG"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091528,
      "Serial": "1120180638X1297",
      "Material": 16698480,
      "EQSLOC": "EGNN"
    },
    {
      "UIC": "WG6WA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091529,
      "Serial": "1120180639X1297",
      "Material": 16698480,
      "EQSLOC": "EGPJ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091531,
      "Serial": "1120180641X1297",
      "Material": 16698480,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091532,
      "Serial": "1120180642X1297",
      "Material": 16698480,
      "EQSLOC": "EGNL"
    },
    {
      "UIC": "WG6WA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091533,
      "Serial": "1120180643X1297",
      "Material": 16698480,
      "EQSLOC": "EGPI"
    },
    {
      "UIC": "WG6WA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091534,
      "Serial": "1120180644X1297",
      "Material": 16698480,
      "EQSLOC": "EGPI"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091535,
      "Serial": "1120180645X1297",
      "Material": 16698480,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091536,
      "Serial": "1120180646X1297",
      "Material": 16698480,
      "EQSLOC": "EGNI"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YF1097",
      "AdminNo": "'-",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033127658,
      "Serial": "1120180607X1297",
      "Material": 16698480,
      "EQSLOC": "EGQE"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T05047",
      "AdminNo": "'-",
      "Description": "TRAILER,TANK",
      "Model": "CZ4A10000",
      "Equipment": 1033614846,
      "Serial": "0052-0456",
      "Material": 15807654,
      "EQSLOC": "DW4R"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "G36237",
      "AdminNo": "10-20G",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1013174884,
      "Serial": "EX00294",
      "Material": 14351565,
      "EQSLOC": "FWDK"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "G36237",
      "AdminNo": "10-30G",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1012967026,
      "Serial": "EX07999",
      "Material": 14351565,
      "EQSLOC": "FNNQ"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "G18358",
      "AdminNo": "A GEN 1",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861485,
      "Serial": "FZA08741",
      "Material": 12853012,
      "EQSLOC": "DW3N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "C16921",
      "AdminNo": "A-1S",
      "Description": "CARRIER CGO FB 2T",
      "Model": "M1067",
      "Equipment": 1017869275,
      "Serial": "88-MY00EG",
      "Material": 12816450,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "C16921",
      "AdminNo": "A-2S",
      "Description": "CARRIER CGO FB 2T",
      "Model": "M1067",
      "Equipment": 1017869276,
      "Serial": "88-AGL6208",
      "Material": 12816450,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "W98825",
      "AdminNo": "A-WT1",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017868875,
      "Serial": 28668,
      "Material": 11087367,
      "EQSLOC": "DW0N"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "H00586",
      "AdminNo": "A01HDP",
      "Description": "HEATER DSL 120000 BTU",
      "Model": "H1201",
      "Equipment": 1017855770,
      "Serial": "H120-1640",
      "Material": 14391682,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WG6WA0",
      "LINNumber": "T95992",
      "AdminNo": "A06T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864868,
      "Serial": 2328,
      "Material": 13875443,
      "EQSLOC": "EGPK"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T95992",
      "AdminNo": "A06T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864929,
      "Serial": 10592,
      "Material": 13875443,
      "EQSLOC": "DW0N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T95992",
      "AdminNo": "A07T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864925,
      "Serial": 10584,
      "Material": 13875443,
      "EQSLOC": "DW0N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "G42488",
      "AdminNo": "A09G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1017870492,
      "Serial": "K120419590",
      "Material": 15617329,
      "EQSLOC": "DW0N"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "T60149",
      "AdminNo": "A1",
      "Description": "TRK CARGO M1078A1 W/W",
      "Model": "M1078A1WW",
      "Equipment": 1017867545,
      "Serial": "A-A109496BGBT",
      "Material": 14473888,
      "EQSLOC": "AH3M"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A10",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870162,
      "Serial": 511348,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A100",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869646,
      "Serial": "10TGJAM178S102945",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A100R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753111,
      "Serial": "SCO37978",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WG6WA0",
      "LINNumber": "W98825",
      "AdminNo": "A100WT",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863693,
      "Serial": "PH0BMW-7042",
      "Material": 11087367,
      "EQSLOC": "EGPJ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A101",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869644,
      "Serial": "10T2K1J20J1034309",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A101R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752817,
      "Serial": "SCO9389",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A101T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869795,
      "Serial": 789133,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T05061",
      "AdminNo": "A102E",
      "Description": "TRUCK TRACTOR",
      "Model": "M1120A4 ECHU",
      "Equipment": 1017870700,
      "Serial": "10TGJAM13AS111552",
      "Material": 16263301,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A102T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869787,
      "Serial": 82912,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T05061",
      "AdminNo": "A103E",
      "Description": "TRUCK TRACTOR",
      "Model": "M1120A4 ECHU",
      "Equipment": 1017870698,
      "Serial": "10TGJAM12AS111574",
      "Material": 16263301,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A103R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752819,
      "Serial": "SCO9853",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A103T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869791,
      "Serial": 92453,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A104",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017867104,
      "Serial": "10TGJAM1X9S103346",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A104R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752820,
      "Serial": "SCO9854",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A104T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869553,
      "Serial": 82900,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A105",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869647,
      "Serial": "10TGJAM108S105394",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "F12581",
      "AdminNo": "A105FR",
      "Description": "FLATRK PALLETZ M1077",
      "Model": "M1077A1",
      "Equipment": 1017866103,
      "Serial": 4883,
      "Material": 13077676,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A105T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869796,
      "Serial": 789366,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A106",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017867110,
      "Serial": "10TGJAM15AS116901",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A107",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017867103,
      "Serial": "10TGJAM149S103326",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A107T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869850,
      "Serial": 755041,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A108",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017867113,
      "Serial": "10TGJAM1XAS116912",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A108T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869789,
      "Serial": 82915,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T05061",
      "AdminNo": "A109E",
      "Description": "TRUCK TRACTOR",
      "Model": "M1120A4 ECHU",
      "Equipment": 1017870701,
      "Serial": "10TGJAM14BS721476",
      "Material": 16263301,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A109T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869788,
      "Serial": 82914,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "G18358",
      "AdminNo": "A10G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864414,
      "Serial": "FZA20297",
      "Material": 12853012,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "L26934",
      "AdminNo": "A10G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870757,
      "Serial": "T15-055-025",
      "Material": 15623992,
      "EQSLOC": "DW0N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A10R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752827,
      "Serial": "SCO19700",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95924",
      "AdminNo": "A10T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865421,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A11",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868937,
      "Serial": 901304,
      "Material": 15402038,
      "EQSLOC": "EGQ9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T07679",
      "AdminNo": "A11",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869989,
      "Serial": 511328,
      "Material": 13469317,
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T37588",
      "AdminNo": "A110",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867753,
      "Serial": 262796,
      "Material": 15402007,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T73347",
      "AdminNo": "A110K",
      "Description": "TRK LFT FK VAR RCH RT",
      "Model": "ATLAS",
      "Equipment": 1017869722,
      "Serial": "10KA1987R",
      "Material": 14172886,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A110T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869790,
      "Serial": 92470,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T41036",
      "AdminNo": "A111",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866921,
      "Serial": "M-A114323BGKT",
      "Material": 14473889,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A111",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017867114,
      "Serial": "10TGJAM13AS116914",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A111T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869785,
      "Serial": 82910,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95555",
      "AdminNo": "A111T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870385,
      "Serial": "TM-016733BFAM",
      "Material": 14491776,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A112",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869643,
      "Serial": "10T2K1J28J1033425",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95555",
      "AdminNo": "A112T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868878,
      "Serial": "TM-203928BGET",
      "Material": 14491776,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A112T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869779,
      "Serial": 82896,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A113",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017867112,
      "Serial": "10TGJAM18AS116911",
      "Material": 15341872,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A113T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869848,
      "Serial": 767179,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95555",
      "AdminNo": "A113T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870387,
      "Serial": "TM-017221BFBM",
      "Material": 14491776,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A114T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869797,
      "Serial": 797014,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A11A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017201242,
      "Serial": 603334,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "H05007",
      "AdminNo": "A11H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059324,
      "Serial": 601,
      "Material": 15984568,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T95924",
      "AdminNo": "A11T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865420,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A11T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869782,
      "Serial": 82899,
      "Material": 13035197,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "W98825",
      "AdminNo": "A11W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863957,
      "Serial": 3359,
      "Material": 11087367,
      "EQSLOC": "DW2X"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A12",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017199130,
      "Serial": 604143,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T41995",
      "AdminNo": "A12",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867458,
      "Serial": "L-T120831EHMV",
      "Material": 14473882,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A12",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868859,
      "Serial": 901153,
      "Material": 15402038,
      "EQSLOC": "EGQ9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T73347",
      "AdminNo": "A120K",
      "Description": "TRK LIFT FORK",
      "Model": "ATLAS II",
      "Equipment": 1021654951,
      "Serial": "10KB0050",
      "Material": 15536676,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A12A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017198923,
      "Serial": 770045,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "H05007",
      "AdminNo": "A12H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059321,
      "Serial": "E029",
      "Material": 15984568,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T95924",
      "AdminNo": "A12T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865647,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A13",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017200528,
      "Serial": 600978,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34840",
      "AdminNo": "A13",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869084,
      "Serial": 313510,
      "Material": 15449638,
      "EQSLOC": "EGQ9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T07679",
      "AdminNo": "A13",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869929,
      "Serial": 502560,
      "Material": 13469317,
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T41995",
      "AdminNo": "A130",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869114,
      "Serial": "L-A114604BGKT",
      "Material": 14473882,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96564",
      "AdminNo": "A131T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870823,
      "Serial": "TL-205172BGLT",
      "Material": 14491775,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96564",
      "AdminNo": "A132T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870871,
      "Serial": "TL-205189BGLT",
      "Material": 14491775,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96564",
      "AdminNo": "A133T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870887,
      "Serial": "TL-205800EGBU",
      "Material": 14491775,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96564",
      "AdminNo": "A135T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870868,
      "Serial": "TL-205178BGLT",
      "Material": 14491775,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96564",
      "AdminNo": "A136T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870884,
      "Serial": "TL-205797EGBU",
      "Material": 14491775,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96564",
      "AdminNo": "A137T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870888,
      "Serial": "TL-205801EGBU",
      "Material": 14491775,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A13A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017197609,
      "Serial": 501402,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "H05007",
      "AdminNo": "A13H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059322,
      "Serial": "E101",
      "Material": 15984568,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A13R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753037,
      "Serial": "SCO38086",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T95924",
      "AdminNo": "A13T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865419,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A14",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868945,
      "Serial": 901418,
      "Material": 15402038,
      "EQSLOC": "EGQ9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T41995",
      "AdminNo": "A142",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869726,
      "Serial": "L-A114711BGKT",
      "Material": 14473882,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96564",
      "AdminNo": "A142T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870885,
      "Serial": "TL-205798EGBU",
      "Material": 14491775,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T49255",
      "AdminNo": "A14K",
      "Description": "TRK LF DD MDL M4K",
      "Model": "M4K",
      "Equipment": 1017869267,
      "Serial": 9144530,
      "Material": 10764237,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A14R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752883,
      "Serial": "SCO19769",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A15",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868944,
      "Serial": 901415,
      "Material": 15402038,
      "EQSLOC": "EGQ9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T61239",
      "AdminNo": "A150",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868973,
      "Serial": "T-A110205BGCT",
      "Material": 14473893,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "S70517",
      "AdminNo": "A150T",
      "Description": "STLR LB 25T M172A1",
      "Model": "M172A1",
      "Equipment": 1017855767,
      "Serial": 195,
      "Material": 3176448,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T61239",
      "AdminNo": "A151",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868410,
      "Serial": "T-A012435BFBJ",
      "Material": 14473893,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T61239",
      "AdminNo": "A152",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868413,
      "Serial": "T-A012310BFAJ",
      "Material": 14473893,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T61239",
      "AdminNo": "A153",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868459,
      "Serial": "T-A012427BFBJ",
      "Material": 14473893,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T61239",
      "AdminNo": "A154",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868415,
      "Serial": "T-A012436BFBJ",
      "Material": 14473893,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T61239",
      "AdminNo": "A155",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868458,
      "Serial": "T-A012572BFDJ",
      "Material": 14473893,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T49255",
      "AdminNo": "A15K",
      "Description": "TRK LF DD MDL M4K",
      "Model": "M4K",
      "Equipment": 1017869269,
      "Serial": 9150584,
      "Material": 10764237,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A15R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752893,
      "Serial": "SCO19901",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34840",
      "AdminNo": "A16",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868951,
      "Serial": 313595,
      "Material": 15449638,
      "EQSLOC": "EGQ9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T07679",
      "AdminNo": "A16",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870449,
      "Serial": 511298,
      "Material": 13469317,
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A16R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752886,
      "Serial": "SCO19827",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T65526",
      "AdminNo": "A17",
      "Description": "TRK DMP MTV LAP M1094",
      "Model": "M1094",
      "Equipment": 1017869270,
      "Serial": "N001418BHC",
      "Material": 13553062,
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A17",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869984,
      "Serial": 511259,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A17R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752832,
      "Serial": "SCO37860",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T95555",
      "AdminNo": "A17T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1002443762,
      "Serial": "TM-015463BFGK",
      "Material": 14491776,
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A18R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752881,
      "Serial": "SCO19746",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95924",
      "AdminNo": "A18T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865387,
      "Serial": 30691,
      "Material": 13875426,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "YF2000",
      "AdminNo": "A19",
      "Description": "LOADER, BOBCAT ALL-WHEEL STEER: S150 BOB",
      "Model": "S150 BOBCAT",
      "Equipment": 1017863082,
      "Serial": "A3L136302",
      "Material": "01V000001",
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A19R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752987,
      "Serial": "SCO37023",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A1R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752772,
      "Serial": "SCO2070",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "T95992",
      "AdminNo": "A1T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865114,
      "Serial": 10658,
      "Material": 13875443,
      "EQSLOC": "EGNF"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "W98825",
      "AdminNo": "A1W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863720,
      "Serial": 3306,
      "Material": 11087367,
      "EQSLOC": "EGNF"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "T41995",
      "AdminNo": "A2",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869128,
      "Serial": "L-A114531BGKT",
      "Material": 14473882,
      "EQSLOC": "DVZ7"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T42063",
      "AdminNo": "A20",
      "Description": "TRUCK CARGO",
      "Model": "M1081A1WW",
      "Equipment": 1017869217,
      "Serial": "L-A114539BGKT",
      "Material": 14473883,
      "EQSLOC": "DW0J"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A20",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870164,
      "Serial": 511385,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T05061",
      "AdminNo": "A201E",
      "Description": "TRUCK TRACTOR",
      "Model": "M1120A4 ECHU",
      "Equipment": 1017870699,
      "Serial": "10TGJAM169S116210",
      "Material": 16263301,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A201T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870186,
      "Serial": "VB116026",
      "Material": 13035197,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A202",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017867111,
      "Serial": "10TGJAM10AS116904",
      "Material": 15341872,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A202T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870191,
      "Serial": 7767178,
      "Material": 13035197,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96496",
      "AdminNo": "A203",
      "Description": "TRK PAL LO M1120A2R1",
      "Model": "M1120A2R1",
      "Equipment": 1017867852,
      "Serial": "10T2K1J22D1020934",
      "Material": 14928230,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A203T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869846,
      "Serial": 857001,
      "Material": 13035197,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A204T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869780,
      "Serial": 82897,
      "Material": 13035197,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96496",
      "AdminNo": "A206",
      "Description": "TRK PAL LO M1120A2R1",
      "Model": "M1120A2R1",
      "Equipment": 1017867854,
      "Serial": "10T2K1J29E1021984",
      "Material": 14928230,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A206T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870189,
      "Serial": 229100069,
      "Material": 13035197,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A207",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869645,
      "Serial": "10TGJAM188S102940",
      "Material": 15341872,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A207T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870185,
      "Serial": "VB116014",
      "Material": 13035197,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96496",
      "AdminNo": "A208",
      "Description": "TRK PAL LO M1120A2",
      "Model": "M1120A2",
      "Equipment": 1017869102,
      "Serial": "10TGJ6Y138S097525",
      "Material": 14928221,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T55054",
      "AdminNo": "A209",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017867115,
      "Serial": "10TGJAM15AS116915",
      "Material": 15341872,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95992",
      "AdminNo": "A20T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865454,
      "Serial": 33952,
      "Material": 13875443,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A21",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868936,
      "Serial": 901263,
      "Material": 15402038,
      "EQSLOC": "EGQ8"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T07679",
      "AdminNo": "A21",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869997,
      "Serial": 511354,
      "Material": 13469317,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T73347",
      "AdminNo": "A210K",
      "Description": "TRK LFT FK VAR RCH RT",
      "Model": "ATLAS",
      "Equipment": 1017869720,
      "Serial": "10KA2479R",
      "Material": 14172886,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T41036",
      "AdminNo": "A211",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866925,
      "Serial": "M-A114356BGKT",
      "Material": 14473889,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95555",
      "AdminNo": "A211T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870386,
      "Serial": "TM-016981BFBM",
      "Material": 14491776,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T41036",
      "AdminNo": "A212",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868641,
      "Serial": "M-A114349BGKT",
      "Material": 14473889,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95555",
      "AdminNo": "A212T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870384,
      "Serial": "TM-016240BFKK",
      "Material": 14491776,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T41104",
      "AdminNo": "A213",
      "Description": "TK CG 5T 6X6 W/E W/W",
      "Model": "M1093A1WW",
      "Equipment": 1017866934,
      "Serial": "M-A114521BGKT",
      "Material": 14476342,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95555",
      "AdminNo": "A213T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868980,
      "Serial": "TM-203930BGET",
      "Material": 14491776,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "H05007",
      "AdminNo": "A21H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059320,
      "Serial": "E153",
      "Material": 15984568,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A21R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752888,
      "Serial": "SCO19839",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T95924",
      "AdminNo": "A21T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865381,
      "Serial": 30701,
      "Material": 13875426,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A22",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017197597,
      "Serial": 501088,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A22",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868942,
      "Serial": 901396,
      "Material": 15402038,
      "EQSLOC": "EGQ8"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T07679",
      "AdminNo": "A22",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870567,
      "Serial": 571410,
      "Material": 13469317,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T37588",
      "AdminNo": "A220",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867754,
      "Serial": 262824,
      "Material": 15402007,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T73347",
      "AdminNo": "A220K",
      "Description": "TRK LFT FK VAR RCH RT",
      "Model": "ATLAS",
      "Equipment": 1017869723,
      "Serial": "10KA0468R1",
      "Material": 14172886,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A22A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017197817,
      "Serial": 601763,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "G18358",
      "AdminNo": "A22G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864399,
      "Serial": "FZA02914",
      "Material": 12853012,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "H05007",
      "AdminNo": "A22H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059319,
      "Serial": "E126",
      "Material": 15984568,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T95924",
      "AdminNo": "A22T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865645,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T07679",
      "AdminNo": "A23",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870269,
      "Serial": 510880,
      "Material": 13469317,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T07679",
      "AdminNo": "A23",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870296,
      "Serial": 213107,
      "Material": 13808604,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A23A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017197828,
      "Serial": 505443,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "G18358",
      "AdminNo": "A23G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861370,
      "Serial": "FZA09185",
      "Material": 12853012,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "H05007",
      "AdminNo": "A23H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059323,
      "Serial": "E106",
      "Material": 15984568,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A23R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753101,
      "Serial": "SCO38596",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T95924",
      "AdminNo": "A23T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865646,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A24",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868940,
      "Serial": 901394,
      "Material": 15402038,
      "EQSLOC": "EGQ8"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T61239",
      "AdminNo": "A245",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868974,
      "Serial": "T-A110206BGCT",
      "Material": 14473893,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A24R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752890,
      "Serial": "SCO19866",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A25",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868939,
      "Serial": 901377,
      "Material": 15402038,
      "EQSLOC": "EGQ8"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T65526",
      "AdminNo": "A25",
      "Description": "TRK DMP MTV LAP M1094",
      "Model": "M1094",
      "Equipment": 1017869274,
      "Serial": "N008293BDBG",
      "Material": 13553062,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T49255",
      "AdminNo": "A25K",
      "Description": "TRK LF DD MDL M4K",
      "Model": "M4K",
      "Equipment": 1017869266,
      "Serial": 9144306,
      "Material": 10764237,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A25R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753102,
      "Serial": "SCO38722",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34840",
      "AdminNo": "A26",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868952,
      "Serial": 315876,
      "Material": 15449638,
      "EQSLOC": "EGQ8"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T07679",
      "AdminNo": "A26",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870271,
      "Serial": 511120,
      "Material": 13469317,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T07679",
      "AdminNo": "A26",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870574,
      "Serial": 571785,
      "Material": 13469317,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A26R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753040,
      "Serial": "SCO37899",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T37588",
      "AdminNo": "A27",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867844,
      "Serial": 262969,
      "Material": 15402007,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A27R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752989,
      "Serial": "SCO37815",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T95555",
      "AdminNo": "A27T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868895,
      "Serial": "TM014744BFDK",
      "Material": 14491776,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A28",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870568,
      "Serial": 571510,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A28R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753104,
      "Serial": "SCO38755",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95992",
      "AdminNo": "A28T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865519,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "YF2000",
      "AdminNo": "A29",
      "Description": "LOADER, BOBCAT ALL-WHEEL STEER: S150 BOB",
      "Model": "S150 BOBCAT",
      "Equipment": 1017863083,
      "Serial": "A3L136304",
      "Material": "01V000001",
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A29R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752891,
      "Serial": "SCO19870",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T95924",
      "AdminNo": "A2T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865258,
      "Serial": 4337,
      "Material": 13875426,
      "EQSLOC": "EGQ8"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T34704",
      "AdminNo": "A3",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017867745,
      "Serial": 301366,
      "Material": 15402038,
      "EQSLOC": "DW3Z"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "YF2000",
      "AdminNo": "A301",
      "Description": "LOADER, BOBCAT ALL-WHEEL STEER: S150 BOB",
      "Model": "S150 BOBCAT",
      "Equipment": 1017863084,
      "Serial": "A3L136307",
      "Material": "01V000001",
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "L77215",
      "AdminNo": "A302",
      "Description": "LOAD SKD STR TYP III",
      "Model": "M400W",
      "Equipment": 1017869979,
      "Serial": "NBM425889",
      "Material": 15524487,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T93761",
      "AdminNo": "A303T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869776,
      "Serial": 82893,
      "Material": 13035197,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "G18358",
      "AdminNo": "A30G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864351,
      "Serial": "FZA21568",
      "Material": 12853012,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T34704",
      "AdminNo": "A31",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017867748,
      "Serial": 300013,
      "Material": 15402038,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A31",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868943,
      "Serial": 901408,
      "Material": 15402038,
      "EQSLOC": "EGQ7"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T58318",
      "AdminNo": "A310",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869199,
      "Serial": "10T2K1J26K1038351",
      "Material": 15341117,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T73347",
      "AdminNo": "A310K",
      "Description": "TRK LIFT FORK",
      "Model": "ATLAS II",
      "Equipment": 1017867917,
      "Serial": "10KB0488",
      "Material": 15536676,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T58318",
      "AdminNo": "A311",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869197,
      "Serial": "10T2K1J23M1042182",
      "Material": 15341117,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T65526",
      "AdminNo": "A311",
      "Description": "TRK DMP MTV LAP M1094",
      "Model": "M1094",
      "Equipment": 1017869273,
      "Serial": "N007679BDMF",
      "Material": 13553062,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T65526",
      "AdminNo": "A312",
      "Description": "TRK DMP MTV LAP M1094",
      "Model": "M1094",
      "Equipment": 1017869272,
      "Serial": "N003041BCAE",
      "Material": 13553062,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T58318",
      "AdminNo": "A313",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869206,
      "Serial": "10TGJAM10AS123478",
      "Material": 15341117,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T65526",
      "AdminNo": "A313",
      "Description": "TRK DMP MTV LAP M1094",
      "Model": "M1094",
      "Equipment": 1017869271,
      "Serial": "N001430BHC",
      "Material": 13553062,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T58318",
      "AdminNo": "A314",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869207,
      "Serial": "10TGJAM18AS123485",
      "Material": 15341117,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T58318",
      "AdminNo": "A315",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869208,
      "Serial": "10TGJAM1XAS123486",
      "Material": 15341117,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "B84404",
      "AdminNo": "A318",
      "Description": "BOAT REC RNEU 3 MAN",
      "Model": "M237",
      "Equipment": 1017868031,
      "Serial": 217,
      "Material": 12493941,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A32",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868941,
      "Serial": 901395,
      "Material": 15402038,
      "EQSLOC": "EGQ7"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T41995",
      "AdminNo": "A321",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869596,
      "Serial": "L-A114912BGKT",
      "Material": 14473882,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T41995",
      "AdminNo": "A322",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017866935,
      "Serial": "L-A114953BGLT",
      "Material": 14473882,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A32R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753036,
      "Serial": "SCO38082",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A330T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869783,
      "Serial": 82902,
      "Material": 13035197,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T61239",
      "AdminNo": "A331",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868414,
      "Serial": "T-A012421BFBJ",
      "Material": 14473893,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96496",
      "AdminNo": "A331",
      "Description": "TRK PAL LO M1120A2",
      "Model": "M1120A2",
      "Equipment": 1017869100,
      "Serial": "10TGJ6Y1X7S095026",
      "Material": 14928221,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "S70517",
      "AdminNo": "A331T",
      "Description": "STLR LB 25T M172A1",
      "Model": "M172A1",
      "Equipment": 1017855658,
      "Serial": 67189,
      "Material": 3176448,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A331T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870188,
      "Serial": 127570021,
      "Material": 13035197,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A332T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870187,
      "Serial": "YB2150035",
      "Material": 13035197,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96496",
      "AdminNo": "A333",
      "Description": "TRK PAL LO M1120A2",
      "Model": "M1120A2",
      "Equipment": 1017869098,
      "Serial": "10TGJ6Y185S085849",
      "Material": 14928221,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A333T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870026,
      "Serial": "RB789055",
      "Material": 13035197,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T96496",
      "AdminNo": "A334",
      "Description": "TRK PAL LO M1120A2",
      "Model": "M1120A2",
      "Equipment": 1017869104,
      "Serial": "10TGJ6Y188S101116",
      "Material": 14928221,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T88983",
      "AdminNo": "A335",
      "Description": "TRK TCTR WO/WINCH",
      "Model": "M1088A1P2WOW",
      "Equipment": 1031488036,
      "Serial": "10TANHFF7JS782380",
      "Material": 15527759,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A335T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870182,
      "Serial": "SB859088",
      "Material": 13035197,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T88983",
      "AdminNo": "A336",
      "Description": "TRK TCTR WO/WINCH",
      "Model": "M1088A1P2WOW",
      "Equipment": 1031488038,
      "Serial": "10TANHFF9JS782381",
      "Material": 15527759,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A336T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870025,
      "Serial": "RB789025",
      "Material": 13035197,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A337T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870179,
      "Serial": "RB789311",
      "Material": 13035197,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A338T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870180,
      "Serial": "TB859271",
      "Material": 13035197,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A339T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870181,
      "Serial": "VB924118",
      "Material": 13035197,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A33R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752976,
      "Serial": "SCO19917",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A34",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868938,
      "Serial": 901319,
      "Material": 15402038,
      "EQSLOC": "EGQ7"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T93761",
      "AdminNo": "A340T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870184,
      "Serial": "VB924092",
      "Material": 13035197,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "L76897",
      "AdminNo": "A342",
      "Description": "LOAD SCP TYP 2.5 CY",
      "Model": "924HLTLDR",
      "Equipment": 1017868778,
      "Serial": "LKW00332",
      "Material": 15706666,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "L76556",
      "AdminNo": "A343",
      "Description": "LOADER SCP 950BNSCE",
      "Model": "950BNSCE",
      "Equipment": 1017869944,
      "Serial": "22Z03324R",
      "Material": 12605163,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A34R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752831,
      "Serial": "SCO37856",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A35",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868858,
      "Serial": 900783,
      "Material": 15402038,
      "EQSLOC": "EGQ7"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "H53576",
      "AdminNo": "A351",
      "Description": "TRACTOR WHEELED IND",
      "Model": "TP I HMEE-I",
      "Equipment": 1017868698,
      "Serial": "GEOHMEE1J41063866",
      "Material": 15354061,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "H53576",
      "AdminNo": "A352",
      "Description": "TRACTOR WHEELED IND",
      "Model": "TP I HMEE-I",
      "Equipment": 1017868697,
      "Serial": "GEOHMEE1K41063865",
      "Material": 15354061,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "H53576",
      "AdminNo": "A353",
      "Description": "TRACTOR WHEELED IND",
      "Model": "TP I HMEE-I",
      "Equipment": 1017868696,
      "Serial": "GEOHMEE1P41063864",
      "Material": 15354061,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A35R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753113,
      "Serial": "SCO19943",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34840",
      "AdminNo": "A36",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868955,
      "Serial": 316048,
      "Material": 15449638,
      "EQSLOC": "EGQ7"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T07679",
      "AdminNo": "A36",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869839,
      "Serial": 502498,
      "Material": 13469317,
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A36R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752816,
      "Serial": "SCO5652",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A38R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752825,
      "Serial": "SCO19651",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A39R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752894,
      "Serial": "SCO19906",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A3R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752878,
      "Serial": "SCO19728",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T41995",
      "AdminNo": "A4",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869122,
      "Serial": "L-A114375BGKT",
      "Material": 14473882,
      "EQSLOC": "DW2X"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A40R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753051,
      "Serial": "SCO38117",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "YF2000",
      "AdminNo": "A42",
      "Description": "LOADER, BOBCAT ALL-WHEEL STEER: S150 BOB",
      "Model": "S150 BOBCAT",
      "Equipment": 1017863095,
      "Serial": "A3L136305",
      "Material": "01V000001",
      "EQSLOC": "DW40"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A42R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752978,
      "Serial": "SCO19930",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A44R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752880,
      "Serial": "SCO19742",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A46R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753045,
      "Serial": "SCO37964",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A47R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752982,
      "Serial": "SCO19941",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A48R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752983,
      "Serial": "SCO19942",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A49R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753044,
      "Serial": "SCO37960",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "G18358",
      "AdminNo": "A4G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1023293383,
      "Serial": "FZA12756",
      "Material": 12853012,
      "EQSLOC": "DW3Z"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "W98825",
      "AdminNo": "A4W",
      "Description": "TRALR WTR M1112 8 WHL",
      "Model": "M1112",
      "Equipment": 1017863872,
      "Serial": "PH0C8E-202",
      "Material": 13899073,
      "EQSLOC": "DW3L"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "A5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869936,
      "Serial": 511125,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T07679",
      "AdminNo": "A5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870080,
      "Serial": 511365,
      "Material": 13469317,
      "EQSLOC": "EGOK"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T07679",
      "AdminNo": "A5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870501,
      "Serial": 511398,
      "Material": 13469317,
      "EQSLOC": "DW2X"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A51R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752829,
      "Serial": "SCO37838",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A52R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752876,
      "Serial": "SCO37884",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A57R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752775,
      "Serial": "SCO3303",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A58R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753114,
      "Serial": "SCO37398",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "G18358",
      "AdminNo": "A5G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866102,
      "Serial": "FZA20964",
      "Material": 12853012,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T95992",
      "AdminNo": "A5T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864993,
      "Serial": 10643,
      "Material": 13875443,
      "EQSLOC": "DW2X"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T56383",
      "AdminNo": "A6",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868329,
      "Serial": 266597,
      "Material": 15402017,
      "EQSLOC": "DW3O"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T34704",
      "AdminNo": "A6",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868946,
      "Serial": 901534,
      "Material": 15402038,
      "EQSLOC": "DW2X"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T07679",
      "AdminNo": "A6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869818,
      "Serial": 502453,
      "Material": 13469317,
      "EQSLOC": "DW3Z"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "T07679",
      "AdminNo": "A6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870450,
      "Serial": 511299,
      "Material": 13469317,
      "EQSLOC": "EGNF"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T07679",
      "AdminNo": "A6",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870512,
      "Serial": 184468,
      "Material": 13808604,
      "EQSLOC": "DW0N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A61R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752835,
      "Serial": "SCO37879",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A62R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752877,
      "Serial": "SCO37886",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A64R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753046,
      "Serial": "SCO37969",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A69R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752991,
      "Serial": "SCO38040",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "L26934",
      "AdminNo": "A6GT",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870756,
      "Serial": "T15-055-014",
      "Material": 15623992,
      "EQSLOC": "DW3Z"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A6R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752884,
      "Serial": "SCO19812",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T95992",
      "AdminNo": "A6T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865535,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "DW3N"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T07679",
      "AdminNo": "A7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870069,
      "Serial": 511234,
      "Material": 13469317,
      "EQSLOC": "DW3Z"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T07679",
      "AdminNo": "A7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870074,
      "Serial": 511272,
      "Material": 13469317,
      "EQSLOC": "DW0N"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T07679",
      "AdminNo": "A7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870564,
      "Serial": 570520,
      "Material": 13469317,
      "EQSLOC": "DW2X"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T41036",
      "AdminNo": "A70",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868636,
      "Serial": "M-A114660BGKT",
      "Material": 14473889,
      "EQSLOC": "DW2W"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A70R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752993,
      "Serial": "SCO38047",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T95555",
      "AdminNo": "A70T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870377,
      "Serial": "TM-016737BFAM",
      "Material": 14491776,
      "EQSLOC": "DW2W"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A71R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752885,
      "Serial": "SCO19816",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A72R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752995,
      "Serial": "SCO38078",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A73R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753039,
      "Serial": "SCO38104",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A74R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753050,
      "Serial": "SCO38113",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A75R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753053,
      "Serial": "SCO38131",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A76R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753054,
      "Serial": "SCO38135",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A77R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752834,
      "Serial": "SCO37877",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A78R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753043,
      "Serial": "SCO37957",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A79R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753047,
      "Serial": "SCO37976",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T41995",
      "AdminNo": "A8",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867097,
      "Serial": "L-A114598BGKT",
      "Material": 14473882,
      "EQSLOC": "DW40"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A80R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753096,
      "Serial": "SCO38139",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A81R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753097,
      "Serial": "SCO38167",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A82R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753042,
      "Serial": "SCO37911",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A83R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753098,
      "Serial": "SCO38168",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A85R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753100,
      "Serial": "SCO38239",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A86R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753103,
      "Serial": "SCO38752",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A87R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753105,
      "Serial": "SCO38864",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A88R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753115,
      "Serial": "SCO38969",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A89R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753106,
      "Serial": "SCO38956",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A8R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752994,
      "Serial": "SCO38076",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "T95555",
      "AdminNo": "A8T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870393,
      "Serial": "TM-017224BFBM",
      "Material": 14491776,
      "EQSLOC": "DW40"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "W98825",
      "AdminNo": "A8WT",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863689,
      "Serial": "7100A",
      "Material": 11087367,
      "EQSLOC": "DW40"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A90R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752830,
      "Serial": "SCO37843",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A91R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752833,
      "Serial": "SCO37875",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T95992",
      "AdminNo": "A91T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865524,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "DW2W"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A92R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752824,
      "Serial": "SCO19568",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T95992",
      "AdminNo": "A92T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865526,
      "Serial": 22820090867,
      "Material": 13875443,
      "EQSLOC": "DW2W"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A93R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753109,
      "Serial": "SCO42634",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A94R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753110,
      "Serial": "SCO42639",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A95R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752826,
      "Serial": "SCO19677",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A96R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753052,
      "Serial": "SCO38124",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A97R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753107,
      "Serial": "SCO45173",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A98R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753038,
      "Serial": "SCO38096",
      "Material": 14422751,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "A9R",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753055,
      "Serial": "SCO38138",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "AE2",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870569,
      "Serial": 571597,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "AE4",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870274,
      "Serial": 511222,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "AE5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870161,
      "Serial": 511344,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "AE6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870264,
      "Serial": 511022,
      "Material": 13469317,
      "EQSLOC": "EGQZ"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "AE7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869742,
      "Serial": 502457,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T07679",
      "AdminNo": "AE7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870346,
      "Serial": 511374,
      "Material": 13469317,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WHBRA0",
      "LINNumber": "T07679",
      "AdminNo": "AE8",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870166,
      "Serial": 511401,
      "Material": 13469317,
      "EQSLOC": "EGQX"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "L05007",
      "AdminNo": "AN-01",
      "Description": "RADAR SET",
      "Model": "AN/TPQ-50",
      "Equipment": 1017866790,
      "Serial": 891,
      "Material": 15784119,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "L05007",
      "AdminNo": "AN-02",
      "Description": "RADAR SET",
      "Model": "AN/TPQ-50",
      "Equipment": 1017866791,
      "Serial": 893,
      "Material": 15784119,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "L05007",
      "AdminNo": "AN-03",
      "Description": "RADAR SET",
      "Model": "AN/TPQ-50",
      "Equipment": 1017866792,
      "Serial": 895,
      "Material": 15784119,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "L05007",
      "AdminNo": "AN-04",
      "Description": "RADAR SET",
      "Model": "AN/TPQ-50",
      "Equipment": 1017866793,
      "Serial": 903,
      "Material": 15784119,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "B84404",
      "AdminNo": "ARP-01",
      "Description": "BOAT REC RNEU 3 MAN",
      "Model": "M237",
      "Equipment": 1017868032,
      "Serial": 222,
      "Material": 12493941,
      "EQSLOC": "EGR8"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "B84404",
      "AdminNo": "ARP-02",
      "Description": "BOAT REC RNEU 3 MAN",
      "Model": "M237",
      "Equipment": 1017868033,
      "Serial": 225,
      "Material": 12493941,
      "EQSLOC": "EGR7"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "C11280",
      "AdminNo": "B-11S",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869172,
      "Serial": "88-AFL5536",
      "Material": 12816451,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "C11280",
      "AdminNo": "B-1S",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869173,
      "Serial": "88-AFL6846",
      "Material": 12816451,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "C11280",
      "AdminNo": "B-2S",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869178,
      "Serial": "88-AFL5573",
      "Material": 12816451,
      "EQSLOC": "DW0G"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "C11280",
      "AdminNo": "B-3S",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869177,
      "Serial": "88-AFL5561",
      "Material": 12816451,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "C11280",
      "AdminNo": "B-4S",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869176,
      "Serial": "88-AFL5556",
      "Material": 12816451,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "C11280",
      "AdminNo": "B-7S",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869181,
      "Serial": "88-AFL6937",
      "Material": 12816451,
      "EQSLOC": "DW0G"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "H00654",
      "AdminNo": "B01H",
      "Description": "HEATER DU TY 350K BTU",
      "Model": "LCFH",
      "Equipment": 1017863081,
      "Serial": 175107000000000000,
      "Material": 15001534,
      "EQSLOC": "DW0G"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "H00654",
      "AdminNo": "B02H",
      "Description": "HEATER DU TY 350K BTU",
      "Model": "LCFH",
      "Equipment": 1017863035,
      "Serial": 175107000000000000,
      "Material": 15001534,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WG6WB0",
      "LINNumber": "T07679",
      "AdminNo": "B06",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869921,
      "Serial": 502537,
      "Material": 13469317,
      "EQSLOC": "DW29"
    },
    {
      "UIC": "WG6WB0",
      "LINNumber": "T95992",
      "AdminNo": "B06T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865639,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "DW29"
    },
    {
      "UIC": "WG6WB0",
      "LINNumber": "W98825",
      "AdminNo": "B07T",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863686,
      "Serial": "2840A",
      "Material": 11087367,
      "EQSLOC": "DW29"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "YF1097",
      "AdminNo": "B1",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1031868024,
      "Serial": "0520180461X1297",
      "Material": 16698480,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG6WB0",
      "LINNumber": "YF1097",
      "AdminNo": "B1-1",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091498,
      "Serial": "1120180608X1297",
      "Material": 16698480,
      "EQSLOC": "EGPP"
    },
    {
      "UIC": "WG6WB0",
      "LINNumber": "YF1097",
      "AdminNo": "B1-2",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1032979010,
      "Serial": "1120180531X1297",
      "Material": 16698480,
      "EQSLOC": "EGPP"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B10",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870370,
      "Serial": 510791,
      "Material": 13469317,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95992",
      "AdminNo": "B10T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864865,
      "Serial": 2951,
      "Material": 13875443,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T07679",
      "AdminNo": "B11",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870253,
      "Serial": 511289,
      "Material": 13469317,
      "EQSLOC": "DVYK"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41995",
      "AdminNo": "B110",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869129,
      "Serial": "L-A114533BGKT",
      "Material": 14473882,
      "EQSLOC": "EGOF"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T41104",
      "AdminNo": "B111",
      "Description": "TK CG 5T 6X6 W/E W/W",
      "Model": "M1093A1WW",
      "Equipment": 1017868768,
      "Serial": "M-A114575BGKT",
      "Material": 14476342,
      "EQSLOC": "DVZT"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95555",
      "AdminNo": "B111T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868979,
      "Serial": "TM-203923BGET",
      "Material": 14491776,
      "EQSLOC": "DVZT"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T41104",
      "AdminNo": "B112",
      "Description": "TK CG 5T 6X6 W/E W/W",
      "Model": "M1093A1WW",
      "Equipment": 1017868767,
      "Serial": "M-A114573BGKT",
      "Material": 14476342,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95555",
      "AdminNo": "B112T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870380,
      "Serial": "TM-017229BFBM",
      "Material": 14491776,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T41036",
      "AdminNo": "B113",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868637,
      "Serial": "M-A114509BGKT",
      "Material": 14473889,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95555",
      "AdminNo": "B113T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870379,
      "Serial": "TM-016736BFAM",
      "Material": 14491776,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "H05007",
      "AdminNo": "B11H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059273,
      "Serial": 226,
      "Material": 15984568,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B11X",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870366,
      "Serial": 511329,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B12",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017198139,
      "Serial": 505422,
      "Material": 13469317,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B12",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868852,
      "Serial": 901409,
      "Material": 15402038,
      "EQSLOC": "AH2F"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T07679",
      "AdminNo": "B12",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870249,
      "Serial": 511098,
      "Material": 13469317,
      "EQSLOC": "DVYK"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B12A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017197826,
      "Serial": 505341,
      "Material": 13469317,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "H05007",
      "AdminNo": "B12H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059274,
      "Serial": 249,
      "Material": 15984568,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B12X",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870300,
      "Serial": 213070,
      "Material": 13808604,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B13",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017197819,
      "Serial": 700365,
      "Material": 13469317,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41135",
      "AdminNo": "B13",
      "Description": "TRK CGO M1083A1 W/W",
      "Model": "M1083A1WW",
      "Equipment": 1017868966,
      "Serial": "B-A110134BGCT",
      "Material": 14473884,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34840",
      "AdminNo": "B13",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869085,
      "Serial": 315819,
      "Material": 15449638,
      "EQSLOC": "AH2F"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B13A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017199484,
      "Serial": 770119,
      "Material": 13469317,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B13X",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870506,
      "Serial": 511377,
      "Material": 13469317,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B14",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868846,
      "Serial": 900250,
      "Material": 15402038,
      "EQSLOC": "AH2F"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T95924",
      "AdminNo": "B14T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865354,
      "Serial": 30692,
      "Material": 13875426,
      "EQSLOC": "AH2F"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B15",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868845,
      "Serial": 900238,
      "Material": 15402038,
      "EQSLOC": "AH2F"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T41995",
      "AdminNo": "B17",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867380,
      "Serial": "L-T120808EHMV",
      "Material": 14473882,
      "EQSLOC": "DVYK"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B17",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869764,
      "Serial": 502337,
      "Material": 13469317,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B18",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870091,
      "Serial": 207181,
      "Material": 13808604,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95924",
      "AdminNo": "B18T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865446,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "G18358",
      "AdminNo": "B1G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861366,
      "Serial": "FZA02603",
      "Material": 12853012,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "G18358",
      "AdminNo": "B1G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861375,
      "Serial": "FZA27471",
      "Material": 12853012,
      "EQSLOC": "EGQQ"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "G18358",
      "AdminNo": "B1G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861480,
      "Serial": "FZA12776",
      "Material": 12853012,
      "EQSLOC": "EGO4"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "G42488",
      "AdminNo": "B1G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1017870428,
      "Serial": "K120419528",
      "Material": 15617329,
      "EQSLOC": "EGMZ"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T95924",
      "AdminNo": "B1T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865057,
      "Serial": 7866,
      "Material": 13875426,
      "EQSLOC": "EGMZ"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "W98825",
      "AdminNo": "B1WT",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863723,
      "Serial": 0.261,
      "Material": 11087367,
      "EQSLOC": "DVYJ"
    },
    {
      "UIC": "WG6WB0",
      "LINNumber": "YF1097",
      "AdminNo": "B2-1",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091521,
      "Serial": "1120180631X1297",
      "Material": 16698480,
      "EQSLOC": "EGPO"
    },
    {
      "UIC": "WG6WB0",
      "LINNumber": "YF1097",
      "AdminNo": "B2-2",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091499,
      "Serial": "1120180609X1297",
      "Material": 16698480,
      "EQSLOC": "EGPO"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B20",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870267,
      "Serial": 511422,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T65526",
      "AdminNo": "B200",
      "Description": "TRK DMP MTV LAP M1094",
      "Model": "M1094",
      "Equipment": 1017869187,
      "Serial": "N001408BHC",
      "Material": 13553062,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T95555",
      "AdminNo": "B200T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1002328370,
      "Serial": "TM-204764EGJT",
      "Material": 14491776,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T65274",
      "AdminNo": "B201",
      "Description": "TRK DUMP 10T W/W",
      "Model": "M1157A1P2WW",
      "Equipment": 1017868786,
      "Serial": "DXD713636EHHW",
      "Material": 15527782,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T65274",
      "AdminNo": "B202",
      "Description": "TRK DUMP 10T W/W",
      "Model": "M1157A1P2WW",
      "Equipment": 1017868838,
      "Serial": "DXD714680EHJW",
      "Material": 15527782,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T65274",
      "AdminNo": "B203",
      "Description": "TRK DUMP 10T W/W",
      "Model": "M1157A1P2WW",
      "Equipment": 1017868792,
      "Serial": "DXD714828EHKW",
      "Material": 15527782,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T61239",
      "AdminNo": "B206",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868970,
      "Serial": "T-A110198BGCT",
      "Material": 14473893,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T61239",
      "AdminNo": "B207",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868971,
      "Serial": "T-A110200BGCT",
      "Material": 14473893,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T88983",
      "AdminNo": "B208",
      "Description": "TRK TCTR WO/WINCH",
      "Model": "M1088A1P2WOW",
      "Equipment": 1031488039,
      "Serial": "10TANHFFXJS782387",
      "Material": 15527759,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T93761",
      "AdminNo": "B208T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869777,
      "Serial": 82894,
      "Material": 13035197,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T61239",
      "AdminNo": "B209",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868969,
      "Serial": "T-A110197BGCT",
      "Material": 14473893,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95992",
      "AdminNo": "B20T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865518,
      "Serial": 33965,
      "Material": 13875443,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B21",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868847,
      "Serial": 901034,
      "Material": 15402038,
      "EQSLOC": "DW4M"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T67136",
      "AdminNo": "B210",
      "Description": "TRK EXP VAN WO/WINCH",
      "Model": "M1087A1P2WOW",
      "Equipment": 1017868842,
      "Serial": "VED709343EHBW",
      "Material": 15527781,
      "EQSLOC": "DW0C"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T61239",
      "AdminNo": "B211",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868411,
      "Serial": "T-A012583BFDJ",
      "Material": 14473893,
      "EQSLOC": "DW0C"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "S75175",
      "AdminNo": "B211T",
      "Description": "STRLR VAN SUP",
      "Model": "M129A3",
      "Equipment": 1017870149,
      "Serial": "1HZV29200E1007218",
      "Material": 11757379,
      "EQSLOC": "DW0C"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95555",
      "AdminNo": "B211T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870381,
      "Serial": "TM-016242BFKK",
      "Material": 14491776,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T05029",
      "AdminNo": "B212",
      "Description": "TRACTOR,FULL TRACKE",
      "Model": "D6K W/WINCH",
      "Equipment": 1017868785,
      "Serial": "HMG00135",
      "Material": 15652600,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41036",
      "AdminNo": "B212",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869685,
      "Serial": "M-A114569BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0C"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95555",
      "AdminNo": "B212T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870383,
      "Serial": "TM-017230BFBM",
      "Material": 14491776,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T05026",
      "AdminNo": "B213",
      "Description": "TRACTOR,FULL TRACKE",
      "Model": "D6K W/RIP",
      "Equipment": 1017868712,
      "Serial": "HMG00136",
      "Material": 15652599,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T41036",
      "AdminNo": "B213",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869681,
      "Serial": "M-A114333BGKT",
      "Material": 14473889,
      "EQSLOC": "DVZT"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95555",
      "AdminNo": "B213T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868877,
      "Serial": "TM-203924BGET",
      "Material": 14491776,
      "EQSLOC": "DVZT"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B21A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017201404,
      "Serial": 503880,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "H05007",
      "AdminNo": "B21H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059316,
      "Serial": 260,
      "Material": 15984568,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B21X",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870443,
      "Serial": 511219,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B22",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017199121,
      "Serial": 604280,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B22",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868850,
      "Serial": 901397,
      "Material": 15402038,
      "EQSLOC": "DW4M"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41036",
      "AdminNo": "B220",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868642,
      "Serial": "M-A114352BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T95555",
      "AdminNo": "B220T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870399,
      "Serial": "TM-204020BGET",
      "Material": 14491776,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T93484",
      "AdminNo": "B221",
      "Description": "TRK VAN M1079A1",
      "Model": "M1079A1",
      "Equipment": 1017867738,
      "Serial": "V-A113004BGGT",
      "Material": 14474938,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T95555",
      "AdminNo": "B221T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868881,
      "Serial": "TM-204388BGGT",
      "Material": 14491776,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T37588",
      "AdminNo": "B222",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868169,
      "Serial": 248309,
      "Material": 15402007,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "L76897",
      "AdminNo": "B222",
      "Description": "LOAD SCP TYP 2.5 CY",
      "Model": "924HLTLDR",
      "Equipment": 1017868777,
      "Serial": "LKW00330",
      "Material": 15706666,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "H53576",
      "AdminNo": "B223",
      "Description": "TRACTOR WHEELED IND",
      "Model": "TP I HMEE-I",
      "Equipment": 1017868699,
      "Serial": "GEOHMEE1C41063867",
      "Material": 15354061,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41995",
      "AdminNo": "B224",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017866918,
      "Serial": "L-A114534BGKT",
      "Material": 14473882,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "H53576",
      "AdminNo": "B224",
      "Description": "TRACTOR WHEELED IND",
      "Model": "TP I HMEE-I",
      "Equipment": 1017868700,
      "Serial": "GEOHMEE1V41063868",
      "Material": 15354061,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T37588",
      "AdminNo": "B225",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868163,
      "Serial": 249816,
      "Material": 15402007,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "H53576",
      "AdminNo": "B225",
      "Description": "TRACTOR WHEELED IND",
      "Model": "TP I HMEE-I",
      "Equipment": 1017868701,
      "Serial": "GEOHMEE1A41063869",
      "Material": 15354061,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "YF2000",
      "AdminNo": "B226",
      "Description": "LOADER, BOBCAT ALL-WHEEL STEER: S150 BOB",
      "Model": "S150 BOBCAT",
      "Equipment": 1017863136,
      "Serial": "A3L136306",
      "Material": "01V000001",
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41995",
      "AdminNo": "B226",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017866919,
      "Serial": "L-A114602BGKT",
      "Material": 14473882,
      "EQSLOC": "DW0G"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T37588",
      "AdminNo": "B227",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868170,
      "Serial": 246050,
      "Material": 15402007,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T94709",
      "AdminNo": "B228",
      "Description": "TRUCK WKR W/W M1089A1",
      "Model": "M1089A1WW",
      "Equipment": 1017869551,
      "Serial": "W-110606EGDT",
      "Material": 14473892,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B22A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017200755,
      "Serial": 602778,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "H05007",
      "AdminNo": "B22H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059317,
      "Serial": 398,
      "Material": 15984568,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34840",
      "AdminNo": "B23",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869091,
      "Serial": 327774,
      "Material": 15449638,
      "EQSLOC": "DW4M"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T55054",
      "AdminNo": "B230",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017867156,
      "Serial": "10TGJAM198S102932",
      "Material": 15341872,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T96564",
      "AdminNo": "B230T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870806,
      "Serial": "TL-201873BGBS",
      "Material": 14491775,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T91656",
      "AdminNo": "B231",
      "Description": "LGHT EQ TRNSP M916A3",
      "Model": "M916A3",
      "Equipment": 1017830584,
      "Serial": "1FULATCG35PN30183",
      "Material": 14886962,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T91656",
      "AdminNo": "B232",
      "Description": "LGHT EQ TRNSP M916A3",
      "Model": "M916A3",
      "Equipment": 1017830581,
      "Serial": "1FULATCG95PN30172",
      "Material": 14886962,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "S70594",
      "AdminNo": "B232T",
      "Description": "STLR LB 40T 6WHL M870",
      "Model": "M870",
      "Equipment": 1017870865,
      "Serial": 9705,
      "Material": 1331731,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B23A",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017199129,
      "Serial": 604136,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "H05007",
      "AdminNo": "B23H",
      "Description": "HOWITZER,LIGHT,TOWED",
      "Model": "M119A3",
      "Equipment": 1017059318,
      "Serial": 425,
      "Material": 15984568,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B23X",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869983,
      "Serial": 511246,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B24",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868856,
      "Serial": 901476,
      "Material": 15402038,
      "EQSLOC": "DW4M"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41036",
      "AdminNo": "B240",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869247,
      "Serial": "M-A114350BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0G"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T95555",
      "AdminNo": "B240T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870378,
      "Serial": "TM-016967BFAM",
      "Material": 14491776,
      "EQSLOC": "DW0G"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B25",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868851,
      "Serial": 901403,
      "Material": 15402038,
      "EQSLOC": "DW4M"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34840",
      "AdminNo": "B26",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869089,
      "Serial": 327576,
      "Material": 15449638,
      "EQSLOC": "DW4M"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T95924",
      "AdminNo": "B26T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865056,
      "Serial": 7860,
      "Material": 13875426,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T07679",
      "AdminNo": "B27",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870165,
      "Serial": 511394,
      "Material": 13469317,
      "EQSLOC": "EGMY"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T07679",
      "AdminNo": "B28",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870174,
      "Serial": 511351,
      "Material": 13469317,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95924",
      "AdminNo": "B28T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865447,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "G18358",
      "AdminNo": "B2G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866072,
      "Serial": "FZA06162",
      "Material": 12853012,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "T60081",
      "AdminNo": "B3",
      "Description": "TRK CGO M1078A1 LMTV",
      "Model": "M1078A1",
      "Equipment": 1017868468,
      "Serial": "A-A012639BFDJ",
      "Material": 14476343,
      "EQSLOC": "EGNM"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "YF2021",
      "AdminNo": "B3",
      "Description": "TRUCK,UTILITY",
      "Model": "M1121",
      "Equipment": 1017870956,
      "Serial": 15933,
      "Material": 14561282,
      "EQSLOC": "AH2E"
    },
    {
      "UIC": "WG6WB0",
      "LINNumber": "YF1097",
      "AdminNo": "B3-1",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091512,
      "Serial": "1120180622X1297",
      "Material": 16698480,
      "EQSLOC": "DW26"
    },
    {
      "UIC": "WG6WB0",
      "LINNumber": "YF1097",
      "AdminNo": "B3-2",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM197",
      "Equipment": 1032979009,
      "Serial": "1120180530X1297",
      "Material": 16698480,
      "EQSLOC": "DW26"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B31",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868849,
      "Serial": 901305,
      "Material": 15402038,
      "EQSLOC": "DW4N"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "M05044",
      "AdminNo": "B31",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1270",
      "Equipment": 1032473067,
      "Serial": "FF440550",
      "Material": 16169288,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41036",
      "AdminNo": "B310",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868769,
      "Serial": "M-T120399EHGV",
      "Material": 14473889,
      "EQSLOC": "AH2P"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "A05031",
      "AdminNo": "B310T",
      "Description": "ARMAMENT REPAIR SHO",
      "Model": "ARSS",
      "Equipment": 1023310772,
      "Serial": "ARSS0078",
      "Material": 16190916,
      "EQSLOC": "AH2P"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T62359",
      "AdminNo": "B311",
      "Description": "TR VAN M1079A1P2 WO/W",
      "Model": "M1079A1P2WOW",
      "Equipment": 1017868793,
      "Serial": "V-D708236EHMV",
      "Material": 15527745,
      "EQSLOC": "AH2P"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "V05001",
      "AdminNo": "B31Y",
      "Description": "VEHICLE MINE MOUNTE",
      "Model": "HUSKY MK3",
      "Equipment": 1017866836,
      "Serial": "3452B",
      "Material": 15815174,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B32",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868855,
      "Serial": 901463,
      "Material": 15402038,
      "EQSLOC": "DW4N"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "M05044",
      "AdminNo": "B32",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1270",
      "Equipment": 1024038625,
      "Serial": "FF630589",
      "Material": 16169288,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T93271",
      "AdminNo": "B321",
      "Description": "TRK CGO LWB WO/WINCH",
      "Model": "M1085A1P2WOW",
      "Equipment": 1017868831,
      "Serial": "P-D713086EHGW",
      "Material": 15527773,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41036",
      "AdminNo": "B322",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868770,
      "Serial": "M-T120581EHJV",
      "Material": 14473889,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T61704",
      "AdminNo": "B324",
      "Description": "TRK CGO LWB M1085A1",
      "Model": "M1085A1",
      "Equipment": 1017868460,
      "Serial": "P-A012509BFCJ",
      "Material": 14473891,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T39954",
      "AdminNo": "B324TG",
      "Description": "GENERAT SE DIE",
      "Model": "PU-2102",
      "Equipment": 1017869772,
      "Serial": "C150808398",
      "Material": 15624106,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T61704",
      "AdminNo": "B325",
      "Description": "TRK CGO LWB M1085A1",
      "Model": "M1085A1",
      "Equipment": 1017868975,
      "Serial": "P-T108049BGLS",
      "Material": 14473891,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T39954",
      "AdminNo": "B326TG",
      "Description": "GENERAT SE DIE",
      "Model": "PU-2102",
      "Equipment": 1017869775,
      "Serial": "L120431103",
      "Material": 15624106,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "M05004",
      "AdminNo": "B32B",
      "Description": "TRUCK,BOMB SERVICE",
      "Model": "BUFFALO MK3",
      "Equipment": 1017867168,
      "Serial": "5ZSB6EAG1DA106511",
      "Material": 15674930,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "V05001",
      "AdminNo": "B32Y",
      "Description": "VEHICLE MINE MOUNTE",
      "Model": "HUSKY MK3",
      "Equipment": 1017866837,
      "Serial": "3453A",
      "Material": 15815174,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T07679",
      "AdminNo": "B330",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870167,
      "Serial": 511414,
      "Material": 13469317,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T07679",
      "AdminNo": "B331",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869835,
      "Serial": 502456,
      "Material": 13469317,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T93271",
      "AdminNo": "B332",
      "Description": "TRK CGO LWB WO/WINCH",
      "Model": "M1085A1P2WOW",
      "Equipment": 1017868839,
      "Serial": "P-D712991EHGW",
      "Material": 15527773,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T39954",
      "AdminNo": "B332TG",
      "Description": "GENERAT SE DIE",
      "Model": "PU-2102",
      "Equipment": 1017869774,
      "Serial": "C150808402",
      "Material": 15624106,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B34",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868857,
      "Serial": 901541,
      "Material": 15402038,
      "EQSLOC": "DW4N"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T34704",
      "AdminNo": "B35",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868782,
      "Serial": 300014,
      "Material": 15402038,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B35",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868854,
      "Serial": 901450,
      "Material": 15402038,
      "EQSLOC": "DW4N"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T94671",
      "AdminNo": "B350",
      "Description": "TRUCK,WRECKER",
      "Model": "M1089A1P2",
      "Equipment": 1031487787,
      "Serial": "10TANHFF4JS782515",
      "Material": 15953994,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "G18358",
      "AdminNo": "B350G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864480,
      "Serial": "FZA06458",
      "Material": 12853012,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T95555",
      "AdminNo": "B350T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868965,
      "Serial": "TM-204005BGET",
      "Material": 14491776,
      "EQSLOC": "DW0G"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T94671",
      "AdminNo": "B351",
      "Description": "TRUCK,WRECKER",
      "Model": "M1089A1P2",
      "Equipment": 1031487785,
      "Serial": "10TANHFF2JS782514",
      "Material": 15953994,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T63161",
      "AdminNo": "B353",
      "Description": "TRK WRECK M984A4 WO/W",
      "Model": "M984A4WO/W",
      "Equipment": 1017866784,
      "Serial": "10T2K1J27K1039492",
      "Material": 15342245,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41995",
      "AdminNo": "B354",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869115,
      "Serial": "L-A114957BGLT",
      "Material": 14473882,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41995",
      "AdminNo": "B356",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867003,
      "Serial": "L-A115048BGLT",
      "Material": 14473882,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41995",
      "AdminNo": "B357",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867378,
      "Serial": "L-A114951BGLT",
      "Material": 14473882,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T41036",
      "AdminNo": "B358",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869684,
      "Serial": "M-A114568BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T94709",
      "AdminNo": "B359",
      "Description": "TRUCK WKR W/W M1089A1",
      "Model": "M1089A1WW",
      "Equipment": 1017869549,
      "Serial": "W-A012323BFAJ",
      "Material": 14473892,
      "EQSLOC": "DW0E"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34840",
      "AdminNo": "B36",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869090,
      "Serial": 327621,
      "Material": 15449638,
      "EQSLOC": "DW4N"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "M05044",
      "AdminNo": "B36",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1270",
      "Equipment": 1032473068,
      "Serial": "FF440269",
      "Material": 16169288,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T93484",
      "AdminNo": "B360",
      "Description": "TRK VAN M1079A1",
      "Model": "M1079A1",
      "Equipment": 1017867737,
      "Serial": "V-A113002BGGT",
      "Material": 14474938,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T95924",
      "AdminNo": "B36T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865376,
      "Serial": 30694,
      "Material": 13875426,
      "EQSLOC": "G4G5"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "M74226",
      "AdminNo": "B37",
      "Description": "MINE RESIS VEHI M1227",
      "Model": "M1227",
      "Equipment": 1032280317,
      "Serial": "MMPVR00063",
      "Material": 15590791,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T95924",
      "AdminNo": "B37T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865111,
      "Serial": 7869,
      "Material": 13875426,
      "EQSLOC": "EGMX"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T95555",
      "AdminNo": "B40T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868891,
      "Serial": "TM-016731BFAM",
      "Material": 14491776,
      "EQSLOC": "DW4O"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T37588",
      "AdminNo": "B41 (B220 AA)",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867462,
      "Serial": 263183,
      "Material": 15402007,
      "EQSLOC": "EGO3"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "W98825",
      "AdminNo": "B41W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863961,
      "Serial": "PH0BWC-7340",
      "Material": 11087367,
      "EQSLOC": "DW4O"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "W98825",
      "AdminNo": "B4W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863958,
      "Serial": 3702,
      "Material": 11087367,
      "EQSLOC": "DVZT"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "T41995",
      "AdminNo": "B5",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867004,
      "Serial": "L-A115052BGLT",
      "Material": 14473882,
      "EQSLOC": "EGNN"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T41995",
      "AdminNo": "B5",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869134,
      "Serial": "L-A114910BGKT",
      "Material": 14473882,
      "EQSLOC": "DVZT"
    },
    {
      "UIC": "WG6WB0",
      "LINNumber": "T41995",
      "AdminNo": "B5",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869727,
      "Serial": "L-A114955BGLT",
      "Material": 14473882,
      "EQSLOC": "DW29"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T07679",
      "AdminNo": "B5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870172,
      "Serial": 511346,
      "Material": 13469317,
      "EQSLOC": "EGOG"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T07679",
      "AdminNo": "B5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870573,
      "Serial": 571783,
      "Material": 13469317,
      "EQSLOC": "DW4O"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T95924",
      "AdminNo": "B5T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865267,
      "Serial": 43020090968,
      "Material": 13875426,
      "EQSLOC": "EGOG"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "W98825",
      "AdminNo": "B5W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017868872,
      "Serial": 654,
      "Material": 11087367,
      "EQSLOC": "EGNN"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T56383",
      "AdminNo": "B6",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868335,
      "Serial": 258903,
      "Material": 15402017,
      "EQSLOC": "EGO6"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T34704",
      "AdminNo": "B6",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868853,
      "Serial": 901411,
      "Material": 15402038,
      "EQSLOC": "DW4O"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T07679",
      "AdminNo": "B6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869823,
      "Serial": 502577,
      "Material": 13469317,
      "EQSLOC": "EGOG"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "T07679",
      "AdminNo": "B6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870452,
      "Serial": 511333,
      "Material": 13469317,
      "EQSLOC": "EGNL"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "G18358",
      "AdminNo": "B6G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864410,
      "Serial": "FZA13133",
      "Material": 12853012,
      "EQSLOC": "DVZU"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T95992",
      "AdminNo": "B6T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865516,
      "Serial": 33962,
      "Material": 13875443,
      "EQSLOC": "DVZU"
    },
    {
      "UIC": "WH9RB0",
      "LINNumber": "T95992",
      "AdminNo": "B6T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865529,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGNL"
    },
    {
      "UIC": "WHBRB0",
      "LINNumber": "T37588",
      "AdminNo": "B7",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867744,
      "Serial": 263047,
      "Material": 15402007,
      "EQSLOC": "DVZT"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T07679",
      "AdminNo": "B7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869828,
      "Serial": 502591,
      "Material": 13469317,
      "EQSLOC": "EGOG"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T07679",
      "AdminNo": "B7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869998,
      "Serial": 511144,
      "Material": 13469317,
      "EQSLOC": "DW4O"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T95924",
      "AdminNo": "B7T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865268,
      "Serial": 43020090970,
      "Material": 13875426,
      "EQSLOC": "EGOG"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T07679",
      "AdminNo": "B91",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869928,
      "Serial": 502395,
      "Material": 13469317,
      "EQSLOC": "EGRP"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T07679",
      "AdminNo": "B92",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869754,
      "Serial": 502309,
      "Material": 13469317,
      "EQSLOC": "AH2E"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "G42488",
      "AdminNo": "B9485",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1017870427,
      "Serial": "K120419485",
      "Material": 15617329,
      "EQSLOC": "DW4O"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T95992",
      "AdminNo": "B94T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865273,
      "Serial": 35337,
      "Material": 13875443,
      "EQSLOC": "EGRP"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T07679",
      "AdminNo": "B95",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869995,
      "Serial": 511201,
      "Material": 13469317,
      "EQSLOC": "EGRP"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T95992",
      "AdminNo": "B95T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865522,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGRP"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T41036",
      "AdminNo": "B96",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868595,
      "Serial": "M-A114315BGKT",
      "Material": 14473889,
      "EQSLOC": "EGRP"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YB057P",
      "AdminNo": "C025",
      "Description": "OUTBOARD MOTOR,GASOLINE",
      "Model": "",
      "Equipment": 1017829595,
      "Serial": 5102025,
      "Material": 12675047,
      "EQSLOC": "EGQE"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "T60081",
      "AdminNo": "C1",
      "Description": "TRK CGO M1078A1 LMTV",
      "Model": "M1078A1",
      "Equipment": 1017868467,
      "Serial": "A-A012629BFDJ",
      "Material": 14476343,
      "EQSLOC": "AH3R"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T37588",
      "AdminNo": "C10",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867837,
      "Serial": 262862,
      "Material": 15402007,
      "EQSLOC": "EGMR"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T07679",
      "AdminNo": "C10",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870068,
      "Serial": 511233,
      "Material": 13469317,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "G18358",
      "AdminNo": "C10G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866099,
      "Serial": "FZA14848",
      "Material": 12853012,
      "EQSLOC": "DVYE"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95992",
      "AdminNo": "C10T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864987,
      "Serial": 11974,
      "Material": 13875443,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95992",
      "AdminNo": "C10T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864995,
      "Serial": 12001,
      "Material": 13875443,
      "EQSLOC": "EGMR"
    },
    {
      "UIC": "WG6WC0",
      "LINNumber": "YF1097",
      "AdminNo": "C11",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091497,
      "Serial": "1120180606X1297",
      "Material": 16698480,
      "EQSLOC": "EGPU"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G07461",
      "AdminNo": "C110G",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1031879840,
      "Serial": "E170182950",
      "Material": 15617455,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C111",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870583,
      "Serial": 573356,
      "Material": 13469317,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T37588",
      "AdminNo": "C112",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868164,
      "Serial": 247625,
      "Material": 15402007,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "C112",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868647,
      "Serial": "M-A114567BGKT",
      "Material": 14473889,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T95992",
      "AdminNo": "C112T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865151,
      "Serial": 11986,
      "Material": 13875443,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "L26934",
      "AdminNo": "C113G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870758,
      "Serial": "T14-342-012",
      "Material": 15623992,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T59584",
      "AdminNo": "C11A",
      "Description": "TK CAR M1084A1P2 WO/W",
      "Model": "M1084A1P2WOW",
      "Equipment": 1017188590,
      "Serial": "C-D707294EHLV",
      "Material": 15527739,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "W98825",
      "AdminNo": "C11T",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863962,
      "Serial": 2926,
      "Material": 11087367,
      "EQSLOC": "DW0X"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95555",
      "AdminNo": "C11T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868976,
      "Serial": "TM-203806BGAT",
      "Material": 14491776,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41515",
      "AdminNo": "C12",
      "Description": "TRK CGO 5 TON WO/W",
      "Model": "M1083A1P2WOW",
      "Equipment": 1017189557,
      "Serial": "10TANHFF7DS754857",
      "Material": 15498610,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T37588",
      "AdminNo": "C120",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867751,
      "Serial": 262756,
      "Material": 15402007,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "L84622",
      "AdminNo": "C120G",
      "Description": "GENERATO SE DIE",
      "Model": "PU-2002",
      "Equipment": 1017870901,
      "Serial": "L120434654",
      "Material": 15624010,
      "EQSLOC": "AH36"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G07461",
      "AdminNo": "C120G",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1031879839,
      "Serial": "E170187429",
      "Material": 15617455,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C121",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869992,
      "Serial": 511347,
      "Material": 13469317,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T37588",
      "AdminNo": "C122",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868165,
      "Serial": 247667,
      "Material": 15402007,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T95992",
      "AdminNo": "C122T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865154,
      "Serial": 11990,
      "Material": 13875443,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C123",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869990,
      "Serial": 511340,
      "Material": 13469317,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "L26934",
      "AdminNo": "C123G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870759,
      "Serial": "T14-342-013",
      "Material": 15623992,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95555",
      "AdminNo": "C12T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870389,
      "Serial": "TM016237BFKK",
      "Material": 14491776,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T11588",
      "AdminNo": "C130",
      "Description": "TRUCK UTILITY M1152",
      "Model": "M1152",
      "Equipment": 1017870116,
      "Serial": 224283,
      "Material": 15187332,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G18358",
      "AdminNo": "C130R",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1031879368,
      "Serial": "FZA06607",
      "Material": 12853012,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95555",
      "AdminNo": "C13T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870392,
      "Serial": "TM016750BFAM",
      "Material": 14491776,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95555",
      "AdminNo": "C14T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868884,
      "Serial": "TM-204401BGGT",
      "Material": 14491776,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95555",
      "AdminNo": "C15T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017190437,
      "Serial": "TM-203543EGAT",
      "Material": 14491776,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C16",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870177,
      "Serial": 511390,
      "Material": 13469317,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T07679",
      "AdminNo": "C16",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870354,
      "Serial": 511335,
      "Material": 13469317,
      "EQSLOC": "EGQE"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T95992",
      "AdminNo": "C16T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865147,
      "Serial": 11970,
      "Material": 13875443,
      "EQSLOC": "EGQE"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "C18",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869933,
      "Serial": 510301,
      "Material": 13469317,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95992",
      "AdminNo": "C18T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865176,
      "Serial": 11993,
      "Material": 13875443,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "T41995",
      "AdminNo": "C2",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869135,
      "Serial": "L-A114911BGKT",
      "Material": 14473882,
      "EQSLOC": "DVZK"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T37588",
      "AdminNo": "C20",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867749,
      "Serial": 263172,
      "Material": 15402007,
      "EQSLOC": "EGMQ"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T07679",
      "AdminNo": "C20",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870062,
      "Serial": 511198,
      "Material": 13469317,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C200",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870572,
      "Serial": 571672,
      "Material": 13469317,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C201",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870004,
      "Serial": 511332,
      "Material": 13469317,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "G18358",
      "AdminNo": "C20G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866074,
      "Serial": "FZA11523",
      "Material": 12853012,
      "EQSLOC": "EGMR"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95924",
      "AdminNo": "C20T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865110,
      "Serial": 7867,
      "Material": 13875426,
      "EQSLOC": "EGMQ"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "C21",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866930,
      "Serial": "M-A114512BGKT",
      "Material": 14473889,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T41036",
      "AdminNo": "C21",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868643,
      "Serial": "M-A114353BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T37588",
      "AdminNo": "C218",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867741,
      "Serial": 262806,
      "Material": 15402007,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G07461",
      "AdminNo": "C218G",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1031879841,
      "Serial": "I160992945",
      "Material": 15617455,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C219",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869752,
      "Serial": 502556,
      "Material": 13469317,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95555",
      "AdminNo": "C21T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1002443765,
      "Serial": "TM-204596EGHT",
      "Material": 14491776,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95555",
      "AdminNo": "C21T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868977,
      "Serial": "TM-203809BGAT",
      "Material": 14491776,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T41036",
      "AdminNo": "C22",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869689,
      "Serial": "M-A114666BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WG6WC0",
      "LINNumber": "YF1097",
      "AdminNo": "C22",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091508,
      "Serial": "1120180618X1297",
      "Material": 16698480,
      "EQSLOC": "EGPT"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41104",
      "AdminNo": "C222",
      "Description": "TK CG 5T 6X6 W/E W/W",
      "Model": "M1093A1WW",
      "Equipment": 1017869245,
      "Serial": "M-A114519BGKT",
      "Material": 14476342,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T59584",
      "AdminNo": "C22A",
      "Description": "TK CAR M1084A1P2 WO/W",
      "Model": "M1084A1P2WOW",
      "Equipment": 1017188592,
      "Serial": "C-D707300EHLV",
      "Material": 15527739,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95555",
      "AdminNo": "C22T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868894,
      "Serial": "TM-204754EGJT",
      "Material": 14491776,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95555",
      "AdminNo": "C22T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868978,
      "Serial": "TM-203814BGCT",
      "Material": 14491776,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T41036",
      "AdminNo": "C23",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868638,
      "Serial": "M-A114249BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "C23",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869333,
      "Serial": "M-A114514BGKT",
      "Material": 14473889,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C230",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870578,
      "Serial": 572246,
      "Material": 13469317,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "L26934",
      "AdminNo": "C230G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870752,
      "Serial": "T15-009-044",
      "Material": 15623992,
      "EQSLOC": "EGRJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C231",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869982,
      "Serial": 511197,
      "Material": 13469317,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C232",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870581,
      "Serial": 573291,
      "Material": 13469317,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C233",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870350,
      "Serial": 511247,
      "Material": 13469317,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95555",
      "AdminNo": "C23T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868981,
      "Serial": "TM-204009BGET",
      "Material": 14491776,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41135",
      "AdminNo": "C24",
      "Description": "TRK CGO M1083A1 W/W",
      "Model": "M1083A1WW",
      "Equipment": 1017196802,
      "Serial": "B-T108109EGMS",
      "Material": 14473884,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T41036",
      "AdminNo": "C24",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869682,
      "Serial": "M-A114489BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95555",
      "AdminNo": "C24T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1002443763,
      "Serial": "TM-204561EGHT",
      "Material": 14491776,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95555",
      "AdminNo": "C24T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868883,
      "Serial": "TM-204400BGGT",
      "Material": 14491776,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T07679",
      "AdminNo": "C25",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870275,
      "Serial": 511237,
      "Material": 13469317,
      "EQSLOC": "DW0X"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95992",
      "AdminNo": "C25T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864992,
      "Serial": 11994,
      "Material": 13875443,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95555",
      "AdminNo": "C25T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868892,
      "Serial": "TM-204414BGGT",
      "Material": 14491776,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T41036",
      "AdminNo": "C26",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869687,
      "Serial": "M-A114650BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C26",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869821,
      "Serial": 502531,
      "Material": 13469317,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T95992",
      "AdminNo": "C26T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865141,
      "Serial": 10725,
      "Material": 13875443,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "C27",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869756,
      "Serial": 501914,
      "Material": 13469317,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C270",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870152,
      "Serial": 511199,
      "Material": 13469317,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T56383",
      "AdminNo": "C280",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868322,
      "Serial": 258916,
      "Material": 15402017,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "L26934",
      "AdminNo": "C280G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870723,
      "Serial": "T15-009-031",
      "Material": 15623992,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T95992",
      "AdminNo": "C280T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865153,
      "Serial": 11988,
      "Material": 13875443,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "L26934",
      "AdminNo": "C285G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870751,
      "Serial": "T15-009-038",
      "Material": 15623992,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T95992",
      "AdminNo": "C28T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865225,
      "Serial": 12006,
      "Material": 13875443,
      "EQSLOC": "EGQD"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95992",
      "AdminNo": "C28T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865228,
      "Serial": 7857,
      "Material": 13875443,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "L26934",
      "AdminNo": "C290G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870750,
      "Serial": "T15-009-032",
      "Material": 15623992,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T95992",
      "AdminNo": "C290T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865155,
      "Serial": 11991,
      "Material": 13875443,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T07679",
      "AdminNo": "C30",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870067,
      "Serial": 511227,
      "Material": 13469317,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95992",
      "AdminNo": "C30T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864871,
      "Serial": 10569,
      "Material": 13875443,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WG6WC0",
      "LINNumber": "YF1097",
      "AdminNo": "C31",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091530,
      "Serial": "1120180640X1297",
      "Material": 16698480,
      "EQSLOC": "EGPS"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T38844",
      "AdminNo": "C32",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869007,
      "Serial": 54559,
      "Material": 11112274,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WG6WC0",
      "LINNumber": "YF1097",
      "AdminNo": "C32",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091511,
      "Serial": "1120180621X1297",
      "Material": 16698480,
      "EQSLOC": "EGPT"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T38844",
      "AdminNo": "C33",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869039,
      "Serial": 48320,
      "Material": 11112274,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T38844",
      "AdminNo": "C34",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869011,
      "Serial": 52138,
      "Material": 11112274,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T38844",
      "AdminNo": "C35",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869040,
      "Serial": 48247,
      "Material": 11112274,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95992",
      "AdminNo": "C35T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864983,
      "Serial": 10729,
      "Material": 13875443,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T38844",
      "AdminNo": "C36",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869013,
      "Serial": 53284,
      "Material": 11112274,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95992",
      "AdminNo": "C36T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864988,
      "Serial": 11976,
      "Material": 13875443,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T38844",
      "AdminNo": "C37",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869041,
      "Serial": 53846,
      "Material": 11112274,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95992",
      "AdminNo": "C37T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864985,
      "Serial": 11963,
      "Material": 13875443,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95992",
      "AdminNo": "C38T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864990,
      "Serial": 11978,
      "Material": 13875443,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T38844",
      "AdminNo": "C39",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017870893,
      "Serial": 51156,
      "Material": 11112274,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T41995",
      "AdminNo": "C4",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867000,
      "Serial": "L-A115034BGLT",
      "Material": 14473882,
      "EQSLOC": "DW33"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41995",
      "AdminNo": "C4",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867386,
      "Serial": "L-T120899EHAW",
      "Material": 14473882,
      "EQSLOC": "DVYD"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T41036",
      "AdminNo": "C4",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869221,
      "Serial": "M-A114247BGKT",
      "Material": 14473889,
      "EQSLOC": "EGRI"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T07679",
      "AdminNo": "C4",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870293,
      "Serial": 193395,
      "Material": 13808604,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T38844",
      "AdminNo": "C40",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869005,
      "Serial": 51969,
      "Material": 11112274,
      "EQSLOC": "DW0W"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "G18358",
      "AdminNo": "C4G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866073,
      "Serial": "FZA11209",
      "Material": 12853012,
      "EQSLOC": "EGMQ"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "W98825",
      "AdminNo": "C4W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863716,
      "Serial": "2221/PH07T8",
      "Material": 11087367,
      "EQSLOC": "DVYD"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "W98825",
      "AdminNo": "C4W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863871,
      "Serial": 2878,
      "Material": 11087367,
      "EQSLOC": "EGRI"
    },
    {
      "UIC": "WG6WC0",
      "LINNumber": "T41995",
      "AdminNo": "C5",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867006,
      "Serial": "L-A114381BGKT",
      "Material": 14473882,
      "EQSLOC": "EGPU"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YB057P",
      "AdminNo": "C502",
      "Description": "OUTBOARD MOTOR,GASOLINE",
      "Model": "",
      "Equipment": 1017829593,
      "Serial": 5091502,
      "Material": 12675047,
      "EQSLOC": "EGQE"
    },
    {
      "UIC": "WG6WC0",
      "LINNumber": "W98825",
      "AdminNo": "C5T",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863690,
      "Serial": "3266A",
      "Material": 11087367,
      "EQSLOC": "EGPS"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T95992",
      "AdminNo": "C5T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864926,
      "Serial": 10588,
      "Material": 13875443,
      "EQSLOC": "DW33"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "G42170",
      "AdminNo": "C5T",
      "Description": "GEN SET HMT PU-798A",
      "Model": "PU798A",
      "Equipment": 1017869914,
      "Serial": "T06317183",
      "Material": 14133818,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "W98825",
      "AdminNo": "C5W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863960,
      "Serial": "97-35333-555",
      "Material": 11087367,
      "EQSLOC": "DVZK"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T56383",
      "AdminNo": "C6",
      "Description": "TRK UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868072,
      "Serial": 258897,
      "Material": 15402017,
      "EQSLOC": "EGMQ"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T07679",
      "AdminNo": "C6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869832,
      "Serial": 502593,
      "Material": 13469317,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "T07679",
      "AdminNo": "C6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869917,
      "Serial": 502533,
      "Material": 13469317,
      "EQSLOC": "DVZQ"
    },
    {
      "UIC": "WG6WC0",
      "LINNumber": "T07679",
      "AdminNo": "C6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869920,
      "Serial": 502437,
      "Material": 13469317,
      "EQSLOC": "EGPT"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T07679",
      "AdminNo": "C6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870456,
      "Serial": 510036,
      "Material": 13469317,
      "EQSLOC": "EGRI"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "T95992",
      "AdminNo": "C6T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865144,
      "Serial": 11964,
      "Material": 13875443,
      "EQSLOC": "EGRI"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "T95992",
      "AdminNo": "C6T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865533,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "AH3R"
    },
    {
      "UIC": "WG6WC0",
      "LINNumber": "T95992",
      "AdminNo": "C6T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865640,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGPS"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "C7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870580,
      "Serial": 573279,
      "Material": 13469317,
      "EQSLOC": "DVYE"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95992",
      "AdminNo": "C7T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864982,
      "Serial": 10722,
      "Material": 13875443,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T95924",
      "AdminNo": "C7T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865388,
      "Serial": 30699,
      "Material": 13875426,
      "EQSLOC": "DVYE"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T41036",
      "AdminNo": "C8",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868639,
      "Serial": "M-A114312BGKT",
      "Material": 14473889,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T95992",
      "AdminNo": "C8T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864978,
      "Serial": 10663,
      "Material": 13875443,
      "EQSLOC": "DW33"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T95555",
      "AdminNo": "C8T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868882,
      "Serial": "TM-204397BGGT",
      "Material": 14491776,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T07679",
      "AdminNo": "C9",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870434,
      "Serial": 511117,
      "Material": 13469317,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "CE10",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870097,
      "Serial": 212560,
      "Material": 13808604,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "CE12",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870113,
      "Serial": 213666,
      "Material": 13808604,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "CE2",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870079,
      "Serial": 511353,
      "Material": 13469317,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "CE3",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869932,
      "Serial": 510246,
      "Material": 13469317,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "CE4",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870163,
      "Serial": 511358,
      "Material": 13469317,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "CE6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870347,
      "Serial": 511386,
      "Material": 13469317,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "CE7",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870099,
      "Serial": 184462,
      "Material": 13808604,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "CE8",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870101,
      "Serial": 199305,
      "Material": 13808604,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T07679",
      "AdminNo": "CE9",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870102,
      "Serial": 199328,
      "Material": 13808604,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "CEA1",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866923,
      "Serial": "M-A114348BGKT",
      "Material": 14473889,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "CEA12",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868648,
      "Serial": "M-A114640BGKT",
      "Material": 14473889,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "CEA5",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868771,
      "Serial": "M-T120788EHMV",
      "Material": 14473889,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41036",
      "AdminNo": "CEA7",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869683,
      "Serial": "M-A114511BGKT",
      "Material": 14473889,
      "EQSLOC": "DW11"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "T41036",
      "AdminNo": "CEA9",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866933,
      "Serial": "M-A114667BGKT",
      "Material": 14473889,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "G18358",
      "AdminNo": "CG1",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861369,
      "Serial": "FZA17586",
      "Material": 12853012,
      "EQSLOC": "DW0X"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "G42488",
      "AdminNo": "CG10",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1017870431,
      "Serial": "K120419579",
      "Material": 15617329,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "L84622",
      "AdminNo": "CG11",
      "Description": "GENERATO SE DIE",
      "Model": "PU-2002",
      "Equipment": 1017870904,
      "Serial": "C150810716",
      "Material": 15624010,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "G18358",
      "AdminNo": "CG2",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861368,
      "Serial": "FZA13274",
      "Material": 12853012,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "T39954",
      "AdminNo": "CG20T",
      "Description": "GENERAT SE DIE",
      "Model": "PU-2102",
      "Equipment": 1017869769,
      "Serial": "C150808397",
      "Material": 15624106,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "G18358",
      "AdminNo": "CG3",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861364,
      "Serial": "FZA00646",
      "Material": 12853012,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "G18358",
      "AdminNo": "CG4",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861365,
      "Serial": "FZA02375",
      "Material": 12853012,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "G18358",
      "AdminNo": "CG8",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861478,
      "Serial": "FZA27540",
      "Material": 12853012,
      "EQSLOC": "DW0V"
    },
    {
      "UIC": "WC9TC0",
      "LINNumber": "G42488",
      "AdminNo": "CG9",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1017870430,
      "Serial": "K120419575",
      "Material": 15617329,
      "EQSLOC": "DW0R"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G18358",
      "AdminNo": "CGEN80",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864408,
      "Serial": "FZA12784",
      "Material": 12853012,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G18358",
      "AdminNo": "CGEN90",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864409,
      "Serial": "FZA12830",
      "Material": 12853012,
      "EQSLOC": "DW4H"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T37588",
      "AdminNo": "CH1",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868058,
      "Serial": 263109,
      "Material": 15402007,
      "EQSLOC": "DW2T"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "CH1",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870251,
      "Serial": 511262,
      "Material": 13469317,
      "EQSLOC": "EGP7"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "CH1",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870457,
      "Serial": 510045,
      "Material": 13469317,
      "EQSLOC": "AH2I"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "H57916",
      "AdminNo": "CH12",
      "Description": "HOWIT MED TWD M777",
      "Model": "M777A2",
      "Equipment": 1009906652,
      "Serial": 420,
      "Material": 994637551,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "H57916",
      "AdminNo": "CH13",
      "Description": "HOWIT MED TWD M777",
      "Model": "M777A2",
      "Equipment": 1009906563,
      "Serial": 364,
      "Material": 994637551,
      "EQSLOC": "AH45"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "H57916",
      "AdminNo": "CH21",
      "Description": "HOWIT MED TWD M777",
      "Model": "M777A2",
      "Equipment": 1009906620,
      "Serial": 374,
      "Material": 994637551,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "H57916",
      "AdminNo": "CH22",
      "Description": "HOWIT MED TWD M777",
      "Model": "M777A2",
      "Equipment": 1009906873,
      "Serial": 403,
      "Material": 994637551,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WHBRC0",
      "LINNumber": "H57916",
      "AdminNo": "CH23",
      "Description": "HOWIT MED TWD M777",
      "Model": "M777A2",
      "Equipment": 1009906666,
      "Serial": 186,
      "Material": 994637551,
      "EQSLOC": "DVYG"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "G07461",
      "AdminNo": "CK1-1G",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870854,
      "Serial": "K120421028",
      "Material": 15617455,
      "EQSLOC": "DW4R"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "YF1097",
      "AdminNo": "CMV-1",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091525,
      "Serial": "1120180635X1297",
      "Material": 16698480,
      "EQSLOC": "DVZL"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "YF1097",
      "AdminNo": "CMV-2",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1032979011,
      "Serial": "1120180534X1297",
      "Material": 16698480,
      "EQSLOC": "DVZL"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "UB304A",
      "AdminNo": "CSW01",
      "Description": "SNOWMACHINE MOBILE: VK10 YAMAHA",
      "Model": "",
      "Equipment": 1011524489,
      "Serial": "JYE8GS0038A008958",
      "Material": "01C106139",
      "EQSLOC": "EGQE"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "UB304A",
      "AdminNo": "CSW02",
      "Description": "SNOWMACHINE MOBILE: VK10 YAMAHA",
      "Model": "",
      "Equipment": 1011524497,
      "Serial": "JYE8GS00X8A008147",
      "Material": "01C106139",
      "EQSLOC": "EGQD"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "L26934",
      "AdminNo": "D007",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870754,
      "Serial": "T15-055-007",
      "Material": 15623992,
      "EQSLOC": "EGP5"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "H00586",
      "AdminNo": "D03324",
      "Description": "HEATER D 120000BTU/HR",
      "Model": "H140",
      "Equipment": 1017862742,
      "Serial": "H1403324",
      "Material": 14770568,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T41036",
      "AdminNo": "D101",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869335,
      "Serial": "M-A114570BGKT",
      "Material": 14473889,
      "EQSLOC": "EGRB"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "G07461",
      "AdminNo": "D1029",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870855,
      "Serial": "K120421029",
      "Material": 15617455,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T61630",
      "AdminNo": "D103",
      "Description": "TRUCK UTILITY M1113",
      "Model": "M1113",
      "Equipment": 1017870206,
      "Serial": 174743,
      "Material": 14120143,
      "EQSLOC": "EGRB"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95924",
      "AdminNo": "D103T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865261,
      "Serial": 13009,
      "Material": 13875426,
      "EQSLOC": "EGRB"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T61630",
      "AdminNo": "D104",
      "Description": "TRUCK UTILITY M1113",
      "Model": "M1113",
      "Equipment": 1017870278,
      "Serial": 222462,
      "Material": 14120143,
      "EQSLOC": "EGRB"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G36237",
      "AdminNo": "D104G2K",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855192,
      "Serial": 13988,
      "Material": 14351565,
      "EQSLOC": "EGRD"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G36237",
      "AdminNo": "D105G2K",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855194,
      "Serial": 14004,
      "Material": 14351565,
      "EQSLOC": "EGRD"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D107",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869766,
      "Serial": 502376,
      "Material": 13469317,
      "EQSLOC": "EGRB"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34840",
      "AdminNo": "D11",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868959,
      "Serial": 328106,
      "Material": 15449638,
      "EQSLOC": "EGO8"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T07679",
      "AdminNo": "D11",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870363,
      "Serial": 511257,
      "Material": 13469317,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34704",
      "AdminNo": "D11H",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868805,
      "Serial": 325360,
      "Material": 15402038,
      "EQSLOC": "AH3J"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T95924",
      "AdminNo": "D11T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865654,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34840",
      "AdminNo": "D12",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868953,
      "Serial": 315936,
      "Material": 15449638,
      "EQSLOC": "EGO8"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T07679",
      "AdminNo": "D12",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870010,
      "Serial": 511375,
      "Material": 13469317,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34840",
      "AdminNo": "D12H",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868963,
      "Serial": 316060,
      "Material": 15449638,
      "EQSLOC": "AH3J"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T95924",
      "AdminNo": "D12T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865655,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "W98825",
      "AdminNo": "D12WT",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863964,
      "Serial": "A3509",
      "Material": 11087367,
      "EQSLOC": "EGP5"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T07679",
      "AdminNo": "D13",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870295,
      "Serial": 213101,
      "Material": 13808604,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34840",
      "AdminNo": "D13H",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868964,
      "Serial": 316098,
      "Material": 15449638,
      "EQSLOC": "AH3J"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T95924",
      "AdminNo": "D13T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865696,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "W98825",
      "AdminNo": "D13WT",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863717,
      "Serial": 2785,
      "Material": 11087367,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41995",
      "AdminNo": "D14",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869224,
      "Serial": "L-A114907BGKT",
      "Material": 14473882,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T96564",
      "AdminNo": "D14T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870883,
      "Serial": "TL-205791EGBU",
      "Material": 14491775,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "W98825",
      "AdminNo": "D14WT",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017868871,
      "Serial": "3552A",
      "Material": 11087367,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34704",
      "AdminNo": "D16",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868808,
      "Serial": 325417,
      "Material": 15402038,
      "EQSLOC": "EGO8"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34704",
      "AdminNo": "D17",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868816,
      "Serial": 325583,
      "Material": 15402038,
      "EQSLOC": "EGO8"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T07679",
      "AdminNo": "D17",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870349,
      "Serial": 511207,
      "Material": 13469317,
      "EQSLOC": "AH3J"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T95992",
      "AdminNo": "D17T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864931,
      "Serial": 10639,
      "Material": 13875443,
      "EQSLOC": "EGP5"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T95992",
      "AdminNo": "D17T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864935,
      "Serial": 10659,
      "Material": 13875443,
      "EQSLOC": "AH3J"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T95992",
      "AdminNo": "D17T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865530,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGO8"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T34704",
      "AdminNo": "D201",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868781,
      "Serial": 300012,
      "Material": 15402038,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G18358",
      "AdminNo": "D201G3K",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861482,
      "Serial": "FZA06532",
      "Material": 12853012,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95924",
      "AdminNo": "D201T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865649,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T34704",
      "AdminNo": "D202",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868783,
      "Serial": 300017,
      "Material": 15402038,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95992",
      "AdminNo": "D202T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865226,
      "Serial": 12009,
      "Material": 13875443,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T34704",
      "AdminNo": "D203",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868779,
      "Serial": 300003,
      "Material": 15402038,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G18358",
      "AdminNo": "D203G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861481,
      "Serial": "FZA00651",
      "Material": 12853012,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95992",
      "AdminNo": "D203T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865641,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D204",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869817,
      "Serial": 502443,
      "Material": 13469317,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D205",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869824,
      "Serial": 502458,
      "Material": 13469317,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D206",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870585,
      "Serial": 573370,
      "Material": 13469317,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D207",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869816,
      "Serial": 502398,
      "Material": 13469317,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95992",
      "AdminNo": "D207T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865177,
      "Serial": 11998,
      "Material": 13875443,
      "EQSLOC": "DW4D"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T37588",
      "AdminNo": "D21",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867842,
      "Serial": 262913,
      "Material": 15402007,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34704",
      "AdminNo": "D21",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868817,
      "Serial": 325597,
      "Material": 15402038,
      "EQSLOC": "DW0B"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41995",
      "AdminNo": "D210",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869222,
      "Serial": "L-A114707BGKT",
      "Material": 14473882,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T95555",
      "AdminNo": "D210T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868886,
      "Serial": "TM-204410BGGT",
      "Material": 14491776,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41036",
      "AdminNo": "D211",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868992,
      "Serial": "M-A114248BGKT",
      "Material": 14473889,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41036",
      "AdminNo": "D212",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866924,
      "Serial": "M-A114351BGKT",
      "Material": 14473889,
      "EQSLOC": "AH2S"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T95555",
      "AdminNo": "D212T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868887,
      "Serial": "TM-204413BGGT",
      "Material": 14491776,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41036",
      "AdminNo": "D213",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869686,
      "Serial": "M-A114641BGKT",
      "Material": 14473889,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T93271",
      "AdminNo": "D215",
      "Description": "TRK CGO LWB WO/WINCH",
      "Model": "M1085A1P2WOW",
      "Equipment": 1017868834,
      "Serial": "P-D712891EHGW",
      "Material": 15527773,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T05047",
      "AdminNo": "D215C",
      "Description": "TRAILER,TANK",
      "Model": "CZ4A10000",
      "Equipment": 1033614920,
      "Serial": "0052-0441",
      "Material": 15807654,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41036",
      "AdminNo": "D216",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866932,
      "Serial": "M-A114571BGKT",
      "Material": 14473889,
      "EQSLOC": "AH2S"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34704",
      "AdminNo": "D21H",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868814,
      "Serial": 325513,
      "Material": 15402038,
      "EQSLOC": "EGPY"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T93761",
      "AdminNo": "D220T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869862,
      "Serial": "YB2150072",
      "Material": 13035197,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T55054",
      "AdminNo": "D221",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869429,
      "Serial": "10T2K1J29F1026183",
      "Material": 15341872,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T93761",
      "AdminNo": "D221T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869861,
      "Serial": "VB059041",
      "Material": 13035197,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T93761",
      "AdminNo": "D222T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869784,
      "Serial": 82905,
      "Material": 13035197,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T55054",
      "AdminNo": "D223",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869423,
      "Serial": "10T2K1J2XF1025463",
      "Material": 15341872,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T93761",
      "AdminNo": "D223T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869852,
      "Serial": 127506,
      "Material": 13035197,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T93761",
      "AdminNo": "D224T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869860,
      "Serial": 327767180,
      "Material": 13035197,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T55054",
      "AdminNo": "D225",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869417,
      "Serial": "10T2K1J2XJ1034494",
      "Material": 15341872,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T93761",
      "AdminNo": "D225T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869863,
      "Serial": 107528,
      "Material": 13035197,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T96496",
      "AdminNo": "D226",
      "Description": "TRK PAL LO M1120A2R1",
      "Model": "M1120A2R1",
      "Equipment": 1017867851,
      "Serial": "10T2K1J2XE1022853",
      "Material": 14928230,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T93761",
      "AdminNo": "D226T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869854,
      "Serial": 127515,
      "Material": 13035197,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34840",
      "AdminNo": "D22H",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869079,
      "Serial": 316158,
      "Material": 15449638,
      "EQSLOC": "EGPY"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34840",
      "AdminNo": "D23",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868960,
      "Serial": 328116,
      "Material": 15449638,
      "EQSLOC": "DW0B"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T87243",
      "AdminNo": "D231",
      "Description": "TRK TANK M978A2",
      "Model": "M978A2",
      "Equipment": 1017869210,
      "Serial": "10TGJ6Y118S097054",
      "Material": 14928215,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T20131",
      "AdminNo": "D232TRM",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1033966883,
      "Serial": 1115,
      "Material": 15176939,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T20131",
      "AdminNo": "D233TRM",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1034010589,
      "Serial": 1127,
      "Material": 15176939,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T20131",
      "AdminNo": "D235TRM",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1034000366,
      "Serial": 1132,
      "Material": 15176939,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41036",
      "AdminNo": "D242",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868586,
      "Serial": "M-A114646BGKT",
      "Material": 14473889,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T20131",
      "AdminNo": "D243TRM",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1034000367,
      "Serial": 1134,
      "Material": 15176939,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41203",
      "AdminNo": "D244",
      "Description": "TRK CGO W/MHE M1084A1",
      "Model": "M1084A1MHE",
      "Equipment": 1017868947,
      "Serial": "C-A021714BFKN",
      "Material": 14473887,
      "EQSLOC": "AH2S"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T07679",
      "AdminNo": "D26",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870001,
      "Serial": 511269,
      "Material": 13469317,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34704",
      "AdminNo": "D26H",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868811,
      "Serial": 325450,
      "Material": 15402038,
      "EQSLOC": "EGPY"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T95992",
      "AdminNo": "D26T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864930,
      "Serial": 10634,
      "Material": 13875443,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34840",
      "AdminNo": "D27",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868954,
      "Serial": 315964,
      "Material": 15449638,
      "EQSLOC": "DW0B"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T07679",
      "AdminNo": "D27",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870446,
      "Serial": 511287,
      "Material": 13469317,
      "EQSLOC": "EGPY"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T95992",
      "AdminNo": "D27T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865642,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGPY"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T37588",
      "AdminNo": "D300",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868066,
      "Serial": 332351,
      "Material": 15402007,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T37588",
      "AdminNo": "D301",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868065,
      "Serial": 332297,
      "Material": 15402007,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T37588",
      "AdminNo": "D301",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868161,
      "Serial": 255737,
      "Material": 15402007,
      "EQSLOC": "EGRC"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "L84690",
      "AdminNo": "D301G10K",
      "Description": "GENERA ST DIE",
      "Model": "PU-2003",
      "Equipment": 1017870923,
      "Serial": "D150815019",
      "Material": 15623721,
      "EQSLOC": "EGRC"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T37588",
      "AdminNo": "D302",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868171,
      "Serial": 332355,
      "Material": 15402007,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "L84690",
      "AdminNo": "D302G15K",
      "Description": "GENERA ST DIE",
      "Model": "PU-2003",
      "Equipment": 1017870924,
      "Serial": "E130502408",
      "Material": 15623721,
      "EQSLOC": "EGRC"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T41036",
      "AdminNo": "D305",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868582,
      "Serial": "M-A114649BGKT",
      "Material": 14473889,
      "EQSLOC": "EGRC"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T07679",
      "AdminNo": "D305",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870344,
      "Serial": 511339,
      "Material": 13469317,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T39954",
      "AdminNo": "D305G30K",
      "Description": "GENERAT SE DIE",
      "Model": "PU-2102",
      "Equipment": 1017869770,
      "Serial": "C150808400",
      "Material": 15624106,
      "EQSLOC": "EGRC"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T07679",
      "AdminNo": "D306",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869762,
      "Serial": 502521,
      "Material": 13469317,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T07679",
      "AdminNo": "D307",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870437,
      "Serial": 511146,
      "Material": 13469317,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T37588",
      "AdminNo": "D308",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868162,
      "Serial": 311688,
      "Material": 15402007,
      "EQSLOC": "EGRC"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T56383",
      "AdminNo": "D309",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1020359269,
      "Serial": 332913,
      "Material": 15402017,
      "EQSLOC": "EGRC"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95924",
      "AdminNo": "D309T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017864866,
      "Serial": 550,
      "Material": 13875426,
      "EQSLOC": "EGRC"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T95992",
      "AdminNo": "D309T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864872,
      "Serial": 10576,
      "Material": 13875443,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34704",
      "AdminNo": "D31",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868809,
      "Serial": 325430,
      "Material": 15402038,
      "EQSLOC": "AH3T"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41995",
      "AdminNo": "D310",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869732,
      "Serial": "L-A114439BGKT",
      "Material": 14473882,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T95555",
      "AdminNo": "D310T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868885,
      "Serial": "TM-204409BGGT",
      "Material": 14491776,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41995",
      "AdminNo": "D311",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869223,
      "Serial": "L-A114906BGKT",
      "Material": 14473882,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D311",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869819,
      "Serial": 502490,
      "Material": 13469317,
      "EQSLOC": "EGRC"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T93484",
      "AdminNo": "D312",
      "Description": "TRK VAN M1079A1",
      "Model": "M1079A1",
      "Equipment": 1017869107,
      "Serial": "V-A012292BFAJ",
      "Material": 14474938,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T41271",
      "AdminNo": "D313",
      "Description": "TRK CARGO M1087A1",
      "Model": "M1087A1",
      "Equipment": 1017871012,
      "Serial": "VEA114232BGJT",
      "Material": 15303843,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "G07461",
      "AdminNo": "D318G",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870858,
      "Serial": "L120427299",
      "Material": 15617455,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "G07461",
      "AdminNo": "D319G10K",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870860,
      "Serial": "L120427309",
      "Material": 15617455,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34704",
      "AdminNo": "D31H",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868804,
      "Serial": 325348,
      "Material": 15402038,
      "EQSLOC": "EGPX"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T63161",
      "AdminNo": "D320",
      "Description": "TRK WRECK M984A4 WO/W",
      "Model": "M984A4WO/W",
      "Equipment": 1017867920,
      "Serial": "10TGJ9Y1X1S070149",
      "Material": 15342245,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T94709",
      "AdminNo": "D322",
      "Description": "TRUCK WKR W/W M1089A1",
      "Model": "M1089A1WW",
      "Equipment": 1017869550,
      "Serial": "W-A012466BFCJ",
      "Material": 14473892,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T55054",
      "AdminNo": "D323",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869422,
      "Serial": "10T2K1J2XF1025298",
      "Material": 15341872,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T94671",
      "AdminNo": "D324",
      "Description": "TRUCK,WRECKER",
      "Model": "M1089A1P2",
      "Equipment": 1024487731,
      "Serial": "10TANHFF9JS782395",
      "Material": 15953994,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T94671",
      "AdminNo": "D325",
      "Description": "TRUCK,WRECKER",
      "Model": "M1089A1P2",
      "Equipment": 1024487728,
      "Serial": "10TANHFF4JS782174",
      "Material": 15953994,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "L84622",
      "AdminNo": "D32GT",
      "Description": "GENERATO SE DIE",
      "Model": "PU-2002",
      "Equipment": 1017870906,
      "Serial": "C150810721",
      "Material": 15624010,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34840",
      "AdminNo": "D32H",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869081,
      "Serial": 327736,
      "Material": 15449638,
      "EQSLOC": "EGPX"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34840",
      "AdminNo": "D33H",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869080,
      "Serial": 326884,
      "Material": 15449638,
      "EQSLOC": "EGPX"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34704",
      "AdminNo": "D36H",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868806,
      "Serial": 325387,
      "Material": 15402038,
      "EQSLOC": "EGPX"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34840",
      "AdminNo": "D37",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868961,
      "Serial": 328141,
      "Material": 15449638,
      "EQSLOC": "AH3T"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T07679",
      "AdminNo": "D37",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870497,
      "Serial": 511309,
      "Material": 13469317,
      "EQSLOC": "EGPX"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T95992",
      "AdminNo": "D37T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865643,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGPX"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T07679",
      "AdminNo": "D38",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870496,
      "Serial": 511288,
      "Material": 13469317,
      "EQSLOC": "AH3T"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T95992",
      "AdminNo": "D38T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865532,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "AH3T"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T41036",
      "AdminNo": "D4",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868762,
      "Serial": "M-A114688BGKT",
      "Material": 14473889,
      "EQSLOC": "DW4B"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D400",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870369,
      "Serial": 510061,
      "Material": 13469317,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "G36237",
      "AdminNo": "D4007",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855191,
      "Serial": 14007,
      "Material": 14351565,
      "EQSLOC": "EGP5"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95924",
      "AdminNo": "D400T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865418,
      "Serial": 545,
      "Material": 13875426,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T61630",
      "AdminNo": "D401",
      "Description": "TRUCK UTILITY M1113",
      "Model": "M1113",
      "Equipment": 1017870281,
      "Serial": 222242,
      "Material": 14120143,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T61630",
      "AdminNo": "D402",
      "Description": "TRUCK UTILITY M1113",
      "Model": "M1113",
      "Equipment": 1017870282,
      "Serial": 222312,
      "Material": 14120143,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G36237",
      "AdminNo": "D402G2K",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855276,
      "Serial": 7140,
      "Material": 14351565,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G49966",
      "AdminNo": "D403G15K",
      "Description": "GENERATOR ST D",
      "Model": "MEP-1050",
      "Equipment": 1032246303,
      "Serial": "G170214327",
      "Material": 15617634,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G36237",
      "AdminNo": "D403G2K",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855187,
      "Serial": 7066,
      "Material": 14351565,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T61630",
      "AdminNo": "D404",
      "Description": "TRUCK UTILITY M1113",
      "Model": "M1113",
      "Equipment": 1017870280,
      "Serial": 222230,
      "Material": 14120143,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G36237",
      "AdminNo": "D404G2K",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855195,
      "Serial": 14005,
      "Material": 14351565,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T61630",
      "AdminNo": "D405",
      "Description": "TRUCK UTILITY M1113",
      "Model": "M1113",
      "Equipment": 1020359282,
      "Serial": 205628,
      "Material": 14120143,
      "EQSLOC": "AH38"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95924",
      "AdminNo": "D405T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1021141650,
      "Serial": 1071,
      "Material": 13875426,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D407",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870299,
      "Serial": 222268,
      "Material": 13808604,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95924",
      "AdminNo": "D407T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865259,
      "Serial": 4144,
      "Material": 13875426,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95924",
      "AdminNo": "D408T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865260,
      "Serial": 4426,
      "Material": 13875426,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T37588",
      "AdminNo": "D409",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1032246308,
      "Serial": 213066,
      "Material": 15402007,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G49966",
      "AdminNo": "D409G15K",
      "Description": "GENERATOR ST D",
      "Model": "MEP-1050",
      "Equipment": 1032246302,
      "Serial": "G170214336",
      "Material": 15617634,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34704",
      "AdminNo": "D41",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868813,
      "Serial": 325503,
      "Material": 15402038,
      "EQSLOC": "EGOB"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34704",
      "AdminNo": "D41H",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868812,
      "Serial": 325460,
      "Material": 15402038,
      "EQSLOC": "EGPW"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34704",
      "AdminNo": "D42",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868803,
      "Serial": 325340,
      "Material": 15402038,
      "EQSLOC": "EGOB"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G07461",
      "AdminNo": "D420G10K",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870857,
      "Serial": "L120427298",
      "Material": 15617455,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G07461",
      "AdminNo": "D421G10K",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870856,
      "Serial": "K120421030",
      "Material": 15617455,
      "EQSLOC": "DW4A"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34840",
      "AdminNo": "D42H",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869082,
      "Serial": 327756,
      "Material": 15449638,
      "EQSLOC": "EGPW"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T34840",
      "AdminNo": "D43",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017868957,
      "Serial": 327661,
      "Material": 15449638,
      "EQSLOC": "EGOB"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T34840",
      "AdminNo": "D43H",
      "Description": "TRUCK UTILITY M1167",
      "Model": "M1167",
      "Equipment": 1017869083,
      "Serial": 328099,
      "Material": 15449638,
      "EQSLOC": "EGPW"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T07679",
      "AdminNo": "D47",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870357,
      "Serial": 510988,
      "Material": 13469317,
      "EQSLOC": "EGPW"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T95992",
      "AdminNo": "D47T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865644,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGPW"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T07679",
      "AdminNo": "D48",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869761,
      "Serial": 502509,
      "Material": 13469317,
      "EQSLOC": "EGOB"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T95992",
      "AdminNo": "D48T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865534,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGOB"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "W98825",
      "AdminNo": "D4WT",
      "Description": "TRALR WTR M1112 8 WHL",
      "Model": "M1112",
      "Equipment": 1017863873,
      "Serial": "PH0022-400",
      "Material": 13899073,
      "EQSLOC": "DW4B"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T41995",
      "AdminNo": "D5",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869730,
      "Serial": "L-A115002BGLT",
      "Material": 14473882,
      "EQSLOC": "EVCT"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T41995",
      "AdminNo": "D5",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869734,
      "Serial": "L-A114599BGKT",
      "Material": 14473882,
      "EQSLOC": "EGPZ"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T07679",
      "AdminNo": "D5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869822,
      "Serial": 502451,
      "Material": 13469317,
      "EQSLOC": "EGP5"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T56383",
      "AdminNo": "D501",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868708,
      "Serial": 333169,
      "Material": 15402017,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T37588",
      "AdminNo": "D502",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868157,
      "Serial": 263130,
      "Material": 15402007,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95992",
      "AdminNo": "D503T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864986,
      "Serial": 11972,
      "Material": 13875443,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D504",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870566,
      "Serial": 570726,
      "Material": 13469317,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D505",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870154,
      "Serial": 511221,
      "Material": 13469317,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95924",
      "AdminNo": "D505T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865416,
      "Serial": 9380,
      "Material": 13875426,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T56383",
      "AdminNo": "D506",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868706,
      "Serial": 301367,
      "Material": 15402017,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T56383",
      "AdminNo": "D507",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868705,
      "Serial": 301333,
      "Material": 15402017,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95924",
      "AdminNo": "D507T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865395,
      "Serial": 4333,
      "Material": 13875426,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T56383",
      "AdminNo": "D508",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868707,
      "Serial": 301385,
      "Material": 15402017,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95924",
      "AdminNo": "D508T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865648,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T56383",
      "AdminNo": "D509",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868704,
      "Serial": 235321,
      "Material": 15402017,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T95992",
      "AdminNo": "D509T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865227,
      "Serial": 12010,
      "Material": 13875443,
      "EQSLOC": "DW41"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T40090",
      "AdminNo": "D5405",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870919,
      "Serial": "A130435405",
      "Material": 15623689,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T40090",
      "AdminNo": "D5407",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870922,
      "Serial": "A130435407",
      "Material": 15623689,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "G36237",
      "AdminNo": "D5G2K",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855193,
      "Serial": 14002,
      "Material": 14351565,
      "EQSLOC": "EGRD"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T95992",
      "AdminNo": "D5T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864980,
      "Serial": 10673,
      "Material": 13875443,
      "EQSLOC": "EGP5"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T95992",
      "AdminNo": "D5T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865451,
      "Serial": 33949,
      "Material": 13875443,
      "EQSLOC": "EVCT"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "W98825",
      "AdminNo": "D5W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863687,
      "Serial": 6547,
      "Material": 11087367,
      "EQSLOC": "EVCT"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "T07679",
      "AdminNo": "D6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869747,
      "Serial": 502520,
      "Material": 13469317,
      "EQSLOC": "EGPZ"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "T07679",
      "AdminNo": "D6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870158,
      "Serial": 511253,
      "Material": 13469317,
      "EQSLOC": "EVCT"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "T07679",
      "AdminNo": "D7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869994,
      "Serial": 511378,
      "Material": 13469317,
      "EQSLOC": "EGP5"
    },
    {
      "UIC": "WG24D0",
      "LINNumber": "T07679",
      "AdminNo": "D7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870591,
      "Serial": 573434,
      "Material": 13469317,
      "EQSLOC": "EGRD"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "G07461",
      "AdminNo": "D7314",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870863,
      "Serial": "L120427314",
      "Material": 15617455,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "M30688",
      "AdminNo": "DFAC1",
      "Description": "MULT-TEMP REFR CONT",
      "Model": "MTRCS02",
      "Equipment": 1017868400,
      "Serial": 9500953,
      "Material": 15929018,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "F64544",
      "AdminNo": "DFRS",
      "Description": "FORWD REP SYS (FRS)",
      "Model": "M7FRS",
      "Equipment": 1017869213,
      "Serial": "2163-3",
      "Material": 15331621,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "S33399",
      "AdminNo": "DFSC01",
      "Description": "FOOD SANITATION CN",
      "Model": "FSC-2",
      "Equipment": 1015737115,
      "Serial": 1015737115,
      "Material": 14962112,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WG6WD0",
      "LINNumber": "G18358",
      "AdminNo": "DMEP831",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017868869,
      "Serial": "FZA12562",
      "Material": 12853012,
      "EQSLOC": "EGPZ"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "H00586",
      "AdminNo": "E-HTR-1",
      "Description": "HEATER D 120000BTU/HR",
      "Model": "H140",
      "Equipment": 1011784165,
      "Serial": "H140_3659",
      "Material": 14770568,
      "EQSLOC": "G4G5"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "G18358",
      "AdminNo": "E10G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866098,
      "Serial": "FZA15002",
      "Material": 12853012,
      "EQSLOC": "AH88"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T37588",
      "AdminNo": "E11",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867755,
      "Serial": 262834,
      "Material": 15402007,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T41995",
      "AdminNo": "E111",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867382,
      "Serial": "L-T120829EHMV",
      "Material": 14473882,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T95992",
      "AdminNo": "E11KT",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865652,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T37588",
      "AdminNo": "E12",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868057,
      "Serial": 263097,
      "Material": 15402007,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T95924",
      "AdminNo": "E12KT",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865742,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T37588",
      "AdminNo": "E13",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867845,
      "Serial": 262977,
      "Material": 15402007,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T95992",
      "AdminNo": "E13KT",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865653,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T07679",
      "AdminNo": "E14",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870106,
      "Serial": 203759,
      "Material": 13808604,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T07679",
      "AdminNo": "E15",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870107,
      "Serial": 203799,
      "Material": 13808604,
      "EQSLOC": "AH88"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-01C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725118,
      "Serial": "QC1102071A",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-02C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725358,
      "Serial": "SC010978",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-03C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725954,
      "Serial": "SC020085",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-04C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008726872,
      "Serial": "SC036925",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-05C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008728319,
      "Serial": "SC05992",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-06C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008748797,
      "Serial": "SC034514",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-07C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009032479,
      "Serial": 10487,
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-08C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009053342,
      "Serial": "SC020046",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-09C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009089542,
      "Serial": "SC0797",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-10C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009169350,
      "Serial": "AWRDS1938081",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-11C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009233799,
      "Serial": "SC023333",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-12C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009255678,
      "Serial": "SC031289",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-13C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009277254,
      "Serial": "SC016872",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-14C",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866529,
      "Serial": "SC03304",
      "Material": 14422751,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-15C",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019525933,
      "Serial": "H02662",
      "Material": 14505671,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-16C",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019525948,
      "Serial": "H02699",
      "Material": 14505671,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-17C",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019525963,
      "Serial": "H02744",
      "Material": 14505671,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-18C",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019547633,
      "Serial": "H03799",
      "Material": 14505671,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-19C",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1019547650,
      "Serial": "H04127",
      "Material": 14505671,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "B83002",
      "AdminNo": "E2-20C",
      "Description": "FLATRACK PALLETIZED",
      "Model": "M3A1 CROP",
      "Equipment": 1023665689,
      "Serial": "H02740",
      "Material": 14505671,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T49255",
      "AdminNo": "E201FK",
      "Description": "TRK LF FK 4K W/O CAB",
      "Model": "MHE270",
      "Equipment": 1017869160,
      "Serial": 8909634,
      "Material": 13308907,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "C16921",
      "AdminNo": "E21",
      "Description": "CARRIER CGO FB 2T",
      "Model": "M1067",
      "Equipment": 1017869277,
      "Serial": "88-AGL6068",
      "Material": 12816450,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T41036",
      "AdminNo": "E211",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868640,
      "Serial": "M-A114324BGKT",
      "Material": 14473889,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T05047",
      "AdminNo": "E211WT",
      "Description": "TRAILER,TANK",
      "Model": "Camel II",
      "Equipment": 1017869605,
      "Serial": "0327-0246",
      "Material": 15807654,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T58318",
      "AdminNo": "E221",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869198,
      "Serial": "10TGJ9Y15WS065173",
      "Material": 15341117,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T93761",
      "AdminNo": "E221T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869792,
      "Serial": "10TMP223481789139",
      "Material": 13035197,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T20131",
      "AdminNo": "E221TRM",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1033966886,
      "Serial": 1122,
      "Material": 15176939,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T93761",
      "AdminNo": "E222T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869869,
      "Serial": 81814,
      "Material": 13035197,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T20131",
      "AdminNo": "E222TRM",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1033966885,
      "Serial": 1120,
      "Material": 15176939,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T58318",
      "AdminNo": "E223",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869200,
      "Serial": "10T2K1J29T1052519",
      "Material": 15341117,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T93761",
      "AdminNo": "E223T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870190,
      "Serial": 91163,
      "Material": 13035197,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T20131",
      "AdminNo": "E223TRM",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1034000371,
      "Serial": 1090,
      "Material": 15176939,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T55054",
      "AdminNo": "E231",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869410,
      "Serial": "10T2K1J27F1026148",
      "Material": 15341872,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T93761",
      "AdminNo": "E231T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869859,
      "Serial": "10TMP2235B1127528",
      "Material": 13035197,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T93761",
      "AdminNo": "E232T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869793,
      "Serial": "10TMP223281081343",
      "Material": 13035197,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T55054",
      "AdminNo": "E233",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869419,
      "Serial": "10T2K1J25L1042098",
      "Material": 15341872,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T56383",
      "AdminNo": "E26",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868397,
      "Serial": 330902,
      "Material": 15402017,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "L84622",
      "AdminNo": "E26GT",
      "Description": "GENERATO SE DIE",
      "Model": "PU-2002",
      "Equipment": 1017870905,
      "Serial": "C150810720",
      "Material": 15624010,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T07679",
      "AdminNo": "E27",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870112,
      "Serial": 213641,
      "Material": 13808604,
      "EQSLOC": "AH88"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "G36237",
      "AdminNo": "E300G",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855182,
      "Serial": "EX08064",
      "Material": 14351565,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T67136",
      "AdminNo": "E310",
      "Description": "TRK EXP VAN WO/WINCH",
      "Model": "M1087A1P2WOW",
      "Equipment": 1017868836,
      "Serial": "VED709342EHBW",
      "Material": 15527781,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T40090",
      "AdminNo": "E312GT",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870916,
      "Serial": "A130435396",
      "Material": 15623689,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T62359",
      "AdminNo": "E313",
      "Description": "TR VAN M1079A1P2 WO/W",
      "Model": "M1079A1P2WOW",
      "Equipment": 1011606236,
      "Serial": "V-D708238EHMV",
      "Material": 15527745,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T41995",
      "AdminNo": "E314",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867381,
      "Serial": "L-T120828EHMV",
      "Material": 14473882,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T40090",
      "AdminNo": "E314GT",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870921,
      "Serial": "A130435415",
      "Material": 15623689,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93484",
      "AdminNo": "E315",
      "Description": "TRK VAN M1079A1",
      "Model": "M1079A1",
      "Equipment": 1017869191,
      "Serial": "V-A113003BGGT",
      "Material": 14474938,
      "EQSLOC": "EGP4"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T95555",
      "AdminNo": "E315T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870395,
      "Serial": "TM-203954BGET",
      "Material": 14491776,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T41036",
      "AdminNo": "E316",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868591,
      "Serial": "M-A114664BGKT",
      "Material": 14473889,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T95555",
      "AdminNo": "E316T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868879,
      "Serial": "TM-203934BGET",
      "Material": 14491776,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T41995",
      "AdminNo": "E317",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867459,
      "Serial": "L-T120833EHMV",
      "Material": 14473882,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "G07461",
      "AdminNo": "E31G",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870859,
      "Serial": "L120427308",
      "Material": 15617455,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T07679",
      "AdminNo": "E32",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870100,
      "Serial": 188775,
      "Material": 13808604,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T94671",
      "AdminNo": "E322",
      "Description": "TRUCK,WRECKER",
      "Model": "M1089A1P2",
      "Equipment": 1024487730,
      "Serial": "10TANHFF6JS782175",
      "Material": 15953994,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T63093",
      "AdminNo": "E331",
      "Description": "TRK WRECKER M984A2",
      "Model": "M984A2",
      "Equipment": 1017869563,
      "Serial": "10TGJ6Y185S083132",
      "Material": 14928224,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T63161",
      "AdminNo": "E333",
      "Description": "TRK WRECK M984A4 WO/W",
      "Model": "M984A4WO/W",
      "Equipment": 1017866783,
      "Serial": "10TGJ9Y14VS062439",
      "Material": 15342245,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T55054",
      "AdminNo": "E334",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869411,
      "Serial": "10TGJ6Y1X5S086100",
      "Material": 15341872,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "F64544",
      "AdminNo": "E334F",
      "Description": "FORWD REP SYS (FRS)",
      "Model": "M7FRS",
      "Equipment": 1017869212,
      "Serial": "1066-3",
      "Material": 15331621,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T93761",
      "AdminNo": "E334T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869864,
      "Serial": 88631,
      "Material": 13035197,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T37588",
      "AdminNo": "E35",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867750,
      "Serial": 246142,
      "Material": 15402007,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T07679",
      "AdminNo": "E36",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870110,
      "Serial": 213239,
      "Material": 13808604,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T95992",
      "AdminNo": "E36T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865180,
      "Serial": 12004,
      "Material": 13875443,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T07679",
      "AdminNo": "E37",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870108,
      "Serial": 206706,
      "Material": 13808604,
      "EQSLOC": "AH88"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T95992",
      "AdminNo": "E37T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865143,
      "Serial": 11955,
      "Material": 13875443,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T37588",
      "AdminNo": "E38",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868159,
      "Serial": 333339,
      "Material": 15402007,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T37588",
      "AdminNo": "E39",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868158,
      "Serial": 333295,
      "Material": 15402007,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T41036",
      "AdminNo": "E4",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868593,
      "Serial": "M-A114574BGKT",
      "Material": 14473889,
      "EQSLOC": "EGNT"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "W98825",
      "AdminNo": "E4WT",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863718,
      "Serial": "3660A",
      "Material": 11087367,
      "EQSLOC": "EGNU"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "C16921",
      "AdminNo": "E5",
      "Description": "CARRIER CGO FB 2T",
      "Model": "M1067 SUSV",
      "Equipment": 1017869278,
      "Serial": "88-AGL7010",
      "Material": 12816450,
      "EQSLOC": "EGNU"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T07679",
      "AdminNo": "E6",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870114,
      "Serial": 213689,
      "Material": 13808604,
      "EQSLOC": "EGNU"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "L26934",
      "AdminNo": "E6GT",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870755,
      "Serial": "T15-055-009",
      "Material": 15623992,
      "EQSLOC": "EGNU"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "T95992",
      "AdminNo": "E7T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865150,
      "Serial": 11981,
      "Material": 13875443,
      "EQSLOC": "EGNU"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T95992",
      "AdminNo": "E7T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865272,
      "Serial": 22820090645,
      "Material": 13875443,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "G07461",
      "AdminNo": "ECKG",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870848,
      "Serial": "K120421015",
      "Material": 15617455,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "M05030",
      "AdminNo": "EOD17",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1240A1",
      "Equipment": 1020323822,
      "Serial": "10TBTAX32AS123547",
      "Material": 15961330,
      "EQSLOC": "ERFX"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "M05030",
      "AdminNo": "EOD18",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1240A1",
      "Equipment": 1023529657,
      "Serial": "10TBTAX35AX124422",
      "Material": 15961330,
      "EQSLOC": "ERFW"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "M05029",
      "AdminNo": "EOD19",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1277",
      "Equipment": 1023529574,
      "Serial": "10TBTAX39AS119351",
      "Material": 16230967,
      "EQSLOC": "FK97"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "M05030",
      "AdminNo": "EOD27",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1240A1",
      "Equipment": 1023529647,
      "Serial": "10TBTAX33AS120897",
      "Material": 15961330,
      "EQSLOC": "FK9B"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "M74226",
      "AdminNo": "EOD31",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1227A1",
      "Equipment": 1019573508,
      "Serial": "MMPVR00027",
      "Material": 16096047,
      "EQSLOC": "ERFW"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "M74226",
      "AdminNo": "EOD32",
      "Description": "MINE RESISTANT VEHICLE",
      "Model": "M1227A1",
      "Equipment": 1019576882,
      "Serial": "MMPVR00105",
      "Material": 16096047,
      "EQSLOC": "FK98"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T60081",
      "AdminNo": "EOD8",
      "Description": "TRK CGO M1078A1 LMTV",
      "Model": "M1078A1",
      "Equipment": 1017775101,
      "Serial": "A-A012651BFDJ",
      "Material": 14476343,
      "EQSLOC": "ERFV"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "H00586",
      "AdminNo": "EZ140H",
      "Description": "HEATER D 120000BTU/HR",
      "Model": "H140",
      "Equipment": 1017862739,
      "Serial": "H1403117",
      "Material": 14770568,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T41995",
      "AdminNo": "F101",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867387,
      "Serial": "L-T120901EHAW",
      "Material": 14473882,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T37588",
      "AdminNo": "F111",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868056,
      "Serial": 263065,
      "Material": 15402007,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T95992",
      "AdminNo": "F111T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864984,
      "Serial": 11961,
      "Material": 13875443,
      "EQSLOC": "EGP4"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T37588",
      "AdminNo": "F112",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867846,
      "Serial": 262986,
      "Material": 15402007,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T07679",
      "AdminNo": "F112 (OLD)",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870006,
      "Serial": 511363,
      "Material": 13469317,
      "EQSLOC": "DW19"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T95992",
      "AdminNo": "F112T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865152,
      "Serial": 11987,
      "Material": 13875443,
      "EQSLOC": "EGP4"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T37588",
      "AdminNo": "F113",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867740,
      "Serial": 263086,
      "Material": 15402007,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T95992",
      "AdminNo": "F113T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864976,
      "Serial": 10661,
      "Material": 13875443,
      "EQSLOC": "EGP4"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T41036",
      "AdminNo": "F115",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868763,
      "Serial": "M-A114689BGKT",
      "Material": 14473889,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T41036",
      "AdminNo": "F202",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869219,
      "Serial": "L-A114409BGKT",
      "Material": 14473889,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T67136",
      "AdminNo": "F203",
      "Description": "TRK EXP VAN WO/WINCH",
      "Model": "M1087A1P2WOW",
      "Equipment": 1017868835,
      "Serial": "VED708810EHAW",
      "Material": 15527781,
      "EQSLOC": "DW19"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T37588",
      "AdminNo": "F208",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868167,
      "Serial": 248279,
      "Material": 15402007,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T37588",
      "AdminNo": "F209",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868239,
      "Serial": 254813,
      "Material": 15402007,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T60081",
      "AdminNo": "F215",
      "Description": "TRK CGO M1078A1 LMTV",
      "Model": "M1078A1",
      "Equipment": 1017868469,
      "Serial": "A-A012270BFAJ",
      "Material": 14476343,
      "EQSLOC": "EGP0"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93484",
      "AdminNo": "F217",
      "Description": "TRK VAN M1079A1",
      "Model": "M1079A1",
      "Equipment": 1017869190,
      "Serial": "V-A012306BFAJ",
      "Material": 14474938,
      "EQSLOC": "EGP4"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T41995",
      "AdminNo": "F222",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869735,
      "Serial": "L-A114710BGKT",
      "Material": 14473882,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93271",
      "AdminNo": "F223",
      "Description": "TRK CGO LWB WO/WINCH",
      "Model": "M1085A1P2WOW",
      "Equipment": 1017868841,
      "Serial": "P-D713220EHGW",
      "Material": 15527773,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "F64544",
      "AdminNo": "F223F",
      "Description": "FORWD REP SYS (FRS)",
      "Model": "M7FRS",
      "Equipment": 1017869301,
      "Serial": "2166-3",
      "Material": 15331621,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T40090",
      "AdminNo": "F224G",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870913,
      "Serial": "A130435435",
      "Material": 15623689,
      "EQSLOC": "GNOU"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T37588",
      "AdminNo": "F230",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868166,
      "Serial": 329082,
      "Material": 15402007,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T94671",
      "AdminNo": "F241",
      "Description": "TRUCK,WRECKER",
      "Model": "M1089A1P2",
      "Equipment": 1031487786,
      "Serial": "10TANHFF3JS782215",
      "Material": 15953994,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T41036",
      "AdminNo": "F252",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868584,
      "Serial": "M-A114336BGKT",
      "Material": 14473889,
      "EQSLOC": "AH2V"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T95555",
      "AdminNo": "F252T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870391,
      "Serial": "TM-016728BFMK",
      "Material": 14491776,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T95555",
      "AdminNo": "F262T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868889,
      "Serial": "TM-204418BGGT",
      "Material": 14491776,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T55054",
      "AdminNo": "F310",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869413,
      "Serial": "10T2K1J28G1027956",
      "Material": 15341872,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93761",
      "AdminNo": "F310T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869847,
      "Serial": 924131,
      "Material": 13035197,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93271",
      "AdminNo": "F311",
      "Description": "TRK CGO LWB WO/WINCH",
      "Model": "M1085A1P2WOW",
      "Equipment": 1017868832,
      "Serial": "P-D713087EHGW",
      "Material": 15527773,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T41036",
      "AdminNo": "F312",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868993,
      "Serial": "M-A114495BGKT",
      "Material": 14473889,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T95555",
      "AdminNo": "F312T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868890,
      "Serial": "TM-204419BGGT",
      "Material": 14491776,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T96496",
      "AdminNo": "F313",
      "Description": "TRK PAL LO M1120A2",
      "Model": "M1120A2",
      "Equipment": 1017869101,
      "Serial": "10TGJ6Y118S097524",
      "Material": 14928221,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93761",
      "AdminNo": "F313T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869866,
      "Serial": 127624039,
      "Material": 13035197,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93761",
      "AdminNo": "F314T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869867,
      "Serial": 229100046,
      "Material": 13035197,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T96496",
      "AdminNo": "F315",
      "Description": "TRK PAL LO M1120A2R1",
      "Model": "M1120A2R1",
      "Equipment": 1017867850,
      "Serial": "10T2K1J24F1025359",
      "Material": 14928230,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T95555",
      "AdminNo": "F319T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1002328362,
      "Serial": "TM-204752EGJT",
      "Material": 14491776,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93761",
      "AdminNo": "F321T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869851,
      "Serial": 127464,
      "Material": 13035197,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T55054",
      "AdminNo": "F322",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869412,
      "Serial": "10T2K1J28G1026676",
      "Material": 15341872,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93761",
      "AdminNo": "F322T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869868,
      "Serial": 81335,
      "Material": 13035197,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T55054",
      "AdminNo": "F323",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869408,
      "Serial": "10T2K1J2XF1024636",
      "Material": 15341872,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93761",
      "AdminNo": "F323T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869856,
      "Serial": 127518,
      "Material": 13035197,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T41036",
      "AdminNo": "F324",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866931,
      "Serial": "M-A114515BGKT",
      "Material": 14473889,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T93761",
      "AdminNo": "F325T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869865,
      "Serial": "RB789158",
      "Material": 13035197,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T58318",
      "AdminNo": "F333",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869203,
      "Serial": "10TGJAM13AS114435",
      "Material": 15341117,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T56383",
      "AdminNo": "F37",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868334,
      "Serial": 258884,
      "Material": 15402017,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T49255",
      "AdminNo": "F4K",
      "Description": "TRK LF DD MDL M4K",
      "Model": "M4K",
      "Equipment": 1017869268,
      "Serial": 9150225,
      "Material": 10764237,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T07679",
      "AdminNo": "F6",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870089,
      "Serial": 206793,
      "Material": 13808604,
      "EQSLOC": "EGP4"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T07679",
      "AdminNo": "F7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870000,
      "Serial": 511263,
      "Material": 13469317,
      "EQSLOC": "EGP4"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "A94943",
      "AdminNo": "FAK1",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870703,
      "Serial": "RSBT061023",
      "Material": 15583100,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "A94943",
      "AdminNo": "FAK2",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870704,
      "Serial": "RSBT060932",
      "Material": 15583100,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-1",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008747441,
      "Serial": "SC027887",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-10",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866557,
      "Serial": "SCO45124",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-11",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866558,
      "Serial": "SCO45172",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-12",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866559,
      "Serial": "SCO45187",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-13",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866560,
      "Serial": "SCO45224",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-14",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866561,
      "Serial": "SCO45226",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-15",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866562,
      "Serial": "SCO45236",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-16",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009010544,
      "Serial": "QC71324",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-17",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009231876,
      "Serial": "SC09125",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-18",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009144707,
      "Serial": "SC010642",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-19",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009144708,
      "Serial": "SC023120",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-2",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008728103,
      "Serial": "SC04444",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-20",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009258480,
      "Serial": "SC027977",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-21",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009259461,
      "Serial": "SC010038",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-22",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009276606,
      "Serial": "SC023250",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-23",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009276614,
      "Serial": "SC022995",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-24",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009304268,
      "Serial": "SCR0084",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-25",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009304271,
      "Serial": "SCR0086",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-26",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009305165,
      "Serial": "SCR0067",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-27",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009363708,
      "Serial": 10271,
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-28",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009364457,
      "Serial": "SC032571",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-29",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022201833,
      "Serial": "SC04081",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-3",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008728484,
      "Serial": "SC09900",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-30",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022559305,
      "Serial": "SC015671",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-31",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1022559309,
      "Serial": "SC015950",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-4",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866526,
      "Serial": "SC03230",
      "Material": 14422751,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-5",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866532,
      "Serial": "SCO019888",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-6",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866533,
      "Serial": "SCO19960",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-7",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866534,
      "Serial": "SCO37991",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-8",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866535,
      "Serial": "SCO45098",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "B83002",
      "AdminNo": "FCROP-9",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866556,
      "Serial": "SCO45104",
      "Material": 14422751,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "H00654",
      "AdminNo": "FHEAT2",
      "Description": "HEATER DU TY 350K BTU",
      "Model": "LCFH",
      "Equipment": 1017863076,
      "Serial": 175107000000000000,
      "Material": 15001534,
      "EQSLOC": "DW18"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "H00586",
      "AdminNo": "FHEAT3",
      "Description": "HEATER DSL 120000 BTU",
      "Model": "H1201",
      "Equipment": 1017855771,
      "Serial": "H120-1707",
      "Material": 14391682,
      "EQSLOC": "EGP0"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T73347",
      "AdminNo": "FL1",
      "Description": "TRK LFT FK VAR RCH RT",
      "Model": "ATLAS",
      "Equipment": 1017869719,
      "Serial": "10KA2476R",
      "Material": 14172886,
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "K28601",
      "AdminNo": "FMKT1",
      "Description": "KITCHN CO LVL FEEDTY2",
      "Model": "MKT95",
      "Equipment": 1017753336,
      "Serial": 1017753336,
      "Material": 13741980,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "F64544",
      "AdminNo": "FRS1",
      "Description": "FORWD REP SYS (FRS)",
      "Model": "M7FRS",
      "Equipment": 1017869302,
      "Serial": "930-3",
      "Material": 15331621,
      "EQSLOC": "DW0H"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "S33399",
      "AdminNo": "FSC1",
      "Description": "FOOD SANITATION CN",
      "Model": "FSC-2",
      "Equipment": 1017758842,
      "Serial": 1017758842,
      "Material": 14962112,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "W98825",
      "AdminNo": "FWB0",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863963,
      "Serial": 7096,
      "Material": 11087367,
      "EQSLOC": "DW17"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "W98825",
      "AdminNo": "FWB1",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863692,
      "Serial": 7064,
      "Material": 11087367,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T05047",
      "AdminNo": "FWB2",
      "Description": "TRAILER,TANK",
      "Model": "Camel II",
      "Equipment": 1017869608,
      "Serial": "0327-0273",
      "Material": 15807654,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41036",
      "AdminNo": "G112",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017866926,
      "Serial": "M-A114486BGKT",
      "Material": 14473889,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T07679",
      "AdminNo": "G130",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869743,
      "Serial": 502493,
      "Material": 13469317,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "W98825",
      "AdminNo": "G1W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863695,
      "Serial": 3727,
      "Material": 11087367,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41995",
      "AdminNo": "G211E",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017866855,
      "Serial": "L-A114971BGLT",
      "Material": 14473882,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41995",
      "AdminNo": "G213",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017871011,
      "Serial": "L-A115049BGLT",
      "Material": 14473882,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41995",
      "AdminNo": "G214",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1032621184,
      "Serial": "L-A114412BGKT",
      "Material": 14473882,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41036",
      "AdminNo": "G215",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868761,
      "Serial": "M-A114684BGKT",
      "Material": 14473889,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41995",
      "AdminNo": "G217E",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869123,
      "Serial": "L-A114379BGKT",
      "Material": 14473882,
      "EQSLOC": "AH2W"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T95992",
      "AdminNo": "G219T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865517,
      "Serial": 33963,
      "Material": 13875443,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41995",
      "AdminNo": "G221E",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867008,
      "Serial": "L-A114384BGKT",
      "Material": 14473882,
      "EQSLOC": "AH2W"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T55054",
      "AdminNo": "G223",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869415,
      "Serial": "10T2K1J23H1031673",
      "Material": 15341872,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T93761",
      "AdminNo": "G223T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869871,
      "Serial": 127624002,
      "Material": 13035197,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T55054",
      "AdminNo": "G224",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869421,
      "Serial": "10T2K1J23F1024803",
      "Material": 15341872,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T93761",
      "AdminNo": "G224T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869872,
      "Serial": 327767136,
      "Material": 13035197,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T96496",
      "AdminNo": "G225",
      "Description": "TRK PAL LO M1120A2R1",
      "Model": "M1120A2R1",
      "Equipment": 1017867853,
      "Serial": "10T2K1J25F1025239",
      "Material": 14928230,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T93761",
      "AdminNo": "G225T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869870,
      "Serial": "TB859356",
      "Material": 13035197,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T95992",
      "AdminNo": "G226T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865636,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T93761",
      "AdminNo": "G243T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869873,
      "Serial": 81402,
      "Material": 13035197,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T93761",
      "AdminNo": "G244T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869855,
      "Serial": 127516,
      "Material": 13035197,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T55054",
      "AdminNo": "G245",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869424,
      "Serial": "10T2K1J22F1025845",
      "Material": 15341872,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T93761",
      "AdminNo": "G246T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869853,
      "Serial": 127510,
      "Material": 13035197,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T55054",
      "AdminNo": "G247",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869430,
      "Serial": "10T2K1J25F1025404",
      "Material": 15341872,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T93761",
      "AdminNo": "G247T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869778,
      "Serial": 82895,
      "Material": 13035197,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T58161",
      "AdminNo": "G250",
      "Description": "TRUCK TANK M978A2",
      "Model": "M978A2WW",
      "Equipment": 1017869305,
      "Serial": "10TGJ6Y134S081870",
      "Material": 14928216,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T95992",
      "AdminNo": "G253T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865637,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T95555",
      "AdminNo": "G27T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017868893,
      "Serial": "TM-204415BGGT",
      "Material": 14491776,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T95992",
      "AdminNo": "G28T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865455,
      "Serial": 33953,
      "Material": 13875443,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T95555",
      "AdminNo": "G311T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870388,
      "Serial": "TM-017228BFBM",
      "Material": 14491776,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41104",
      "AdminNo": "G313",
      "Description": "TK CG 5T 6X6 W/E W/W",
      "Model": "M1093A1WW",
      "Equipment": 1017868766,
      "Serial": "M-A114572BGKT",
      "Material": 14476342,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T37588",
      "AdminNo": "G317",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868242,
      "Serial": 332367,
      "Material": 15402007,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T93271",
      "AdminNo": "G323",
      "Description": "TRK CGO LWB WO/WINCH",
      "Model": "M1085A1P2WOW",
      "Equipment": 1017868789,
      "Serial": "P-D712894EHGW",
      "Material": 15527773,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T96496",
      "AdminNo": "G325",
      "Description": "TRK PAL LO M1120A2",
      "Model": "M1120A2",
      "Equipment": 1017869099,
      "Serial": "10TGJ6Y138S097024",
      "Material": 14928221,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T93484",
      "AdminNo": "G326",
      "Description": "TRK VAN M1079A1",
      "Model": "M1079A1",
      "Equipment": 1017869188,
      "Serial": "V-A012293BFAJ",
      "Material": 14474938,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T63161",
      "AdminNo": "G331",
      "Description": "TRK WRECK M984A4 WO/W",
      "Model": "M984A4WO/W",
      "Equipment": 1017867921,
      "Serial": "10TGJ9Y111S070153",
      "Material": 15342245,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T94709",
      "AdminNo": "G332",
      "Description": "TRUCK WKR W/W M1089A1",
      "Model": "M1089A1WW",
      "Equipment": 1017869543,
      "Serial": "W-A012276BFAJ",
      "Material": 14473892,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T94709",
      "AdminNo": "G333",
      "Description": "TRUCK WKR W/W M1089A1",
      "Model": "M1089A1WW",
      "Equipment": 1017869544,
      "Serial": "W-A012277BFAJ",
      "Material": 14473892,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T94671",
      "AdminNo": "G334",
      "Description": "TRUCK,WRECKER",
      "Model": "M1089A1P2",
      "Equipment": 1031487784,
      "Serial": "10TANHFF1JS782214",
      "Material": 15953994,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T41995",
      "AdminNo": "G342E",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867014,
      "Serial": "L-A114605BGKT",
      "Material": 14473882,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T67136",
      "AdminNo": "G35",
      "Description": "TRK EXP VAN WO/WINCH",
      "Model": "M1087A1P2WOW",
      "Equipment": 1017868837,
      "Serial": "VED709344EHBW",
      "Material": 15527781,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T07679",
      "AdminNo": "G351",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869836,
      "Serial": "502406X6",
      "Material": 13469317,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T37588",
      "AdminNo": "G39",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868168,
      "Serial": 248299,
      "Material": 15402007,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "W98825",
      "AdminNo": "G4W",
      "Description": "TRALR WTR M1112 8 WHL",
      "Model": "M1112",
      "Equipment": 1017863956,
      "Serial": "PH0C9N-169",
      "Material": 13899073,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T05047",
      "AdminNo": "G5W",
      "Description": "TRAILER,TANK",
      "Model": "Camel II",
      "Equipment": 1017869606,
      "Serial": "0327-0271",
      "Material": 15807654,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T07679",
      "AdminNo": "G7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870502,
      "Serial": 511276,
      "Material": 13469317,
      "EQSLOC": "DW11"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T95992",
      "AdminNo": "G7T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865638,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "G42238",
      "AdminNo": "GEN",
      "Description": "GENERATOR SET,DIESE",
      "Model": "MEP-802A",
      "Equipment": 1017869812,
      "Serial": "A-11-020",
      "Material": 15873878,
      "EQSLOC": "DW35"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "G07461",
      "AdminNo": "GEN01",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870851,
      "Serial": "K120421023",
      "Material": 15617455,
      "EQSLOC": "DW0G"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "G07461",
      "AdminNo": "GEN01",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870862,
      "Serial": "L120427313",
      "Material": 15617455,
      "EQSLOC": "GNOU"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "G36237",
      "AdminNo": "GEN02",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855185,
      "Serial": "EX03341",
      "Material": 14351565,
      "EQSLOC": "DW0G"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "G18358",
      "AdminNo": "GEN02",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864412,
      "Serial": "FZA15428",
      "Material": 12853012,
      "EQSLOC": "EGQT"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "G42488",
      "AdminNo": "GEN02F",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1017870491,
      "Serial": "K120419586",
      "Material": 15617329,
      "EQSLOC": "GNOU"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "G18358",
      "AdminNo": "GEN03",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864400,
      "Serial": "FZA03463",
      "Material": 12853012,
      "EQSLOC": "EGQI"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "L26934",
      "AdminNo": "GEN03",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870721,
      "Serial": "T15-055-010",
      "Material": 15623992,
      "EQSLOC": "GNOU"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "G18358",
      "AdminNo": "GEN04",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864406,
      "Serial": "FZA11250",
      "Material": 12853012,
      "EQSLOC": "DW35"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T40090",
      "AdminNo": "GEN05",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870915,
      "Serial": "A130435433",
      "Material": 15623689,
      "EQSLOC": "GNOU"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "L84622",
      "AdminNo": "GEN07",
      "Description": "GENERATO SE DIE",
      "Model": "PU-2002",
      "Equipment": 1017870908,
      "Serial": "C150810717",
      "Material": 15624010,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "G18358",
      "AdminNo": "GEN08",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866096,
      "Serial": "FZA15972",
      "Material": 12853012,
      "EQSLOC": "DW35"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "G36237",
      "AdminNo": "GEN09",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855190,
      "Serial": 6828,
      "Material": 14351565,
      "EQSLOC": "EGP0"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "G36237",
      "AdminNo": "GEN10",
      "Description": "GEN SET MEP MOD 501-A",
      "Model": "MEP MOD 501A",
      "Equipment": 1017855186,
      "Serial": "27B7357V2",
      "Material": 219120393,
      "EQSLOC": "GNOU"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "G18358",
      "AdminNo": "GEN304",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861479,
      "Serial": "FZA27392",
      "Material": 12853012,
      "EQSLOC": "EGP0"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "G05005",
      "AdminNo": "GS1",
      "Description": "GENERATOR,SIGNAL",
      "Model": "SG-1366/U",
      "Equipment": 1017843794,
      "Serial": "SG51030649",
      "Material": 15658789,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "G18358",
      "AdminNo": "GSD2",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864404,
      "Serial": "FZA10194",
      "Material": 12853012,
      "EQSLOC": "EGOG"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T95992",
      "AdminNo": "H101T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865527,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T95992",
      "AdminNo": "H103T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864991,
      "Serial": 11989,
      "Material": 13875443,
      "EQSLOC": "AH2Y"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H106",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869130,
      "Serial": "L-A114596BGKT",
      "Material": 14473882,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T95992",
      "AdminNo": "H106T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864981,
      "Serial": 10715,
      "Material": 13875443,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T95992",
      "AdminNo": "H107T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865651,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41036",
      "AdminNo": "H108",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869108,
      "Serial": "M-A114507BGKT",
      "Material": 14473889,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "L84622",
      "AdminNo": "H10K1",
      "Description": "GENERATO SE DIE",
      "Model": "PU-2002",
      "Equipment": 1017870907,
      "Serial": "C150810719",
      "Material": 15624010,
      "EQSLOC": "DW16"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T07679",
      "AdminNo": "H114",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869925,
      "Serial": 502400,
      "Material": 13469317,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "W98825",
      "AdminNo": "H201WT",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017868873,
      "Serial": "PH01J2-M149-0059",
      "Material": 11087367,
      "EQSLOC": "DW16"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T93271",
      "AdminNo": "H210",
      "Description": "TRK CGO LWB WO/WINCH",
      "Model": "M1085A1P2WOW",
      "Equipment": 1017868790,
      "Serial": "P-D713025EHGW",
      "Material": 15527773,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T96496",
      "AdminNo": "H220",
      "Description": "TRK PAL LO M1120A2",
      "Model": "M1120A2",
      "Equipment": 1017869105,
      "Serial": "10TGJ6Y138S101119",
      "Material": 14928221,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H250",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017866917,
      "Serial": "L-A114532BGKT",
      "Material": 14473882,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H251",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869729,
      "Serial": "L-A114996BGLT",
      "Material": 14473882,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T60081",
      "AdminNo": "H252",
      "Description": "TRK CGO M1078A1 LMTV",
      "Model": "M1078A1",
      "Equipment": 1017868650,
      "Serial": "A-A012462BFBJ",
      "Material": 14476343,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "G07461",
      "AdminNo": "H252G",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870861,
      "Serial": "L120427311",
      "Material": 15617455,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T07679",
      "AdminNo": "H26",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869758,
      "Serial": 502289,
      "Material": 13469317,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "L26934",
      "AdminNo": "H26G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870722,
      "Serial": "T15-055-022",
      "Material": 15623992,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T95992",
      "AdminNo": "H26T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864977,
      "Serial": 10662,
      "Material": 13875443,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T07679",
      "AdminNo": "H27",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869844,
      "Serial": 502516,
      "Material": 13469317,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T95992",
      "AdminNo": "H27T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864934,
      "Serial": 10645,
      "Material": 13875443,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T94671",
      "AdminNo": "H280",
      "Description": "TRUCK,WRECKER",
      "Model": "M1089A1P2",
      "Equipment": 1024487727,
      "Serial": "10TANHFF3JS781923",
      "Material": 15953994,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T94709",
      "AdminNo": "H281",
      "Description": "TRUCK WKR W/W M1089A1",
      "Model": "M1089A1WW",
      "Equipment": 1017869548,
      "Serial": "W-A012552BFDJ",
      "Material": 14473892,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T94709",
      "AdminNo": "H282",
      "Description": "TRUCK WKR W/W M1089A1",
      "Model": "M1089A1WW",
      "Equipment": 1017869547,
      "Serial": "W-A012278BFAJ",
      "Material": 14473892,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T62359",
      "AdminNo": "H283",
      "Description": "TR VAN M1079A1P2 WO/W",
      "Model": "M1079A1P2WOW",
      "Equipment": 1017868833,
      "Serial": "V-D708235EHMV",
      "Material": 15527745,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T63161",
      "AdminNo": "H285",
      "Description": "TRK WRECK M984A4 WO/W",
      "Model": "M984A4WO/W",
      "Equipment": 1017867918,
      "Serial": "10TGJAM189S103183",
      "Material": 15342245,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T37588",
      "AdminNo": "H286",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867536,
      "Serial": 248291,
      "Material": 15402007,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T37588",
      "AdminNo": "H288",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868237,
      "Serial": 332344,
      "Material": 15402007,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T95555",
      "AdminNo": "H298T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870397,
      "Serial": "TM-016980BFBM",
      "Material": 14491776,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T95555",
      "AdminNo": "H299T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870396,
      "Serial": "TM-016969BFAM",
      "Material": 14491776,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "G36237",
      "AdminNo": "H2K230",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855183,
      "Serial": "EX01837",
      "Material": 14351565,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "C11280",
      "AdminNo": "H2S",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869186,
      "Serial": "88-AFL7034",
      "Material": 12816451,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H303",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867005,
      "Serial": "L-A114378BGKT",
      "Material": 14473882,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H304",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017866916,
      "Serial": "L-A115046BGLT",
      "Material": 14473882,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H306",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017866996,
      "Serial": "L-A114956BGLT",
      "Material": 14473882,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T96564",
      "AdminNo": "H306T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870877,
      "Serial": "TL-205186BGLT",
      "Material": 14491775,
      "EQSLOC": "EGRX"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H307",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869216,
      "Serial": "L-A114377BGKT",
      "Material": 14473882,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H308",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869120,
      "Serial": "L-A115036BGLT",
      "Material": 14473882,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T96564",
      "AdminNo": "H309T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870812,
      "Serial": "TL-201869BGBS",
      "Material": 14491775,
      "EQSLOC": "EGRX"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T96564",
      "AdminNo": "H310T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870817,
      "Serial": "TL-201986BGCS",
      "Material": 14491775,
      "EQSLOC": "EGRX"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H311",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867101,
      "Serial": "L-A115037BGLT",
      "Material": 14473882,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T05047",
      "AdminNo": "H313T",
      "Description": "TRAILER,TANK",
      "Model": "Camel II",
      "Equipment": 1017869607,
      "Serial": "0327-0272",
      "Material": 15807654,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T55054",
      "AdminNo": "H314",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869416,
      "Serial": "10T2K1J25M1042135",
      "Material": 15341872,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T93761",
      "AdminNo": "H314T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869858,
      "Serial": "10TMP2234B1127519",
      "Material": 13035197,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T55054",
      "AdminNo": "H315",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869427,
      "Serial": "10T2K1J26J1034394",
      "Material": 15341872,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T93761",
      "AdminNo": "H315T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869857,
      "Serial": "10TMP223XB1127539",
      "Material": 13035197,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T55054",
      "AdminNo": "H316",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869431,
      "Serial": "10T2K1J27G1028385",
      "Material": 15341872,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T93761",
      "AdminNo": "H316T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017869849,
      "Serial": 755034,
      "Material": 13035197,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T55054",
      "AdminNo": "H317",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869425,
      "Serial": "10T2K1J26F1024861",
      "Material": 15341872,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T93761",
      "AdminNo": "H317T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870196,
      "Serial": "WB1556039",
      "Material": 13035197,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T93761",
      "AdminNo": "H318T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870195,
      "Serial": 91181,
      "Material": 13035197,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T55054",
      "AdminNo": "H319",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869420,
      "Serial": "10T2K1J28F1025803",
      "Material": 15341872,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T93761",
      "AdminNo": "H319T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870193,
      "Serial": "VB11628",
      "Material": 13035197,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T55054",
      "AdminNo": "H320",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869538,
      "Serial": "10T2K1J26H1029996",
      "Material": 15341872,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T93761",
      "AdminNo": "H320T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870194,
      "Serial": "XB82006030",
      "Material": 13035197,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T55054",
      "AdminNo": "H321",
      "Description": "TRK PALLETIZE M1120A4",
      "Model": "M1120A4WOW",
      "Equipment": 1017869541,
      "Serial": "10T2K1J27F1026117",
      "Material": 15341872,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T93761",
      "AdminNo": "H321T",
      "Description": "TLR PLS 8X20 M1076",
      "Model": "M1076",
      "Equipment": 1017870192,
      "Serial": "RB789309",
      "Material": 13035197,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T58318",
      "AdminNo": "H340",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869196,
      "Serial": "10T2K1J29D1020672",
      "Material": 15341117,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T58318",
      "AdminNo": "H343",
      "Description": "TRK TANK W/O WINCH",
      "Model": "M978A4WOW",
      "Equipment": 1017869204,
      "Serial": "10TGJAM19AS123477",
      "Material": 15341117,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T56383",
      "AdminNo": "H36",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868333,
      "Serial": 258877,
      "Material": 15402017,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T07679",
      "AdminNo": "H37",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870342,
      "Serial": 511310,
      "Material": 13469317,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "G18358",
      "AdminNo": "H3K230",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861367,
      "Serial": "FZA06155",
      "Material": 12853012,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "C11280",
      "AdminNo": "H3S-1",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869185,
      "Serial": "88-AFL6786",
      "Material": 12816451,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41995",
      "AdminNo": "H4",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869225,
      "Serial": "L-A114908BGKT",
      "Material": 14473882,
      "EQSLOC": "DW13"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T41271",
      "AdminNo": "H5",
      "Description": "TRK CARGO M1087A1",
      "Model": "M1087A1",
      "Equipment": 1017867739,
      "Serial": "VEA114233BGJT",
      "Material": 15303843,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T56383",
      "AdminNo": "H6",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868331,
      "Serial": 258851,
      "Material": 15402017,
      "EQSLOC": "DW16"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T56383",
      "AdminNo": "H7",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868332,
      "Serial": 258871,
      "Material": 15402017,
      "EQSLOC": "DW16"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "A94943",
      "AdminNo": "HAK1",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870709,
      "Serial": "RSB-T06-2895",
      "Material": 15583100,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "A94943",
      "AdminNo": "HAK2",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870711,
      "Serial": "RSB-T06-2908",
      "Material": 15583100,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "A94943",
      "AdminNo": "HAK3",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870710,
      "Serial": "RSB-T06-2906",
      "Material": 15583100,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T40090",
      "AdminNo": "HAMP1",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870912,
      "Serial": "A130435404",
      "Material": 15623689,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T40090",
      "AdminNo": "HAMP2",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870911,
      "Serial": "A130435417",
      "Material": 15623689,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "K28601",
      "AdminNo": "HCK3",
      "Description": "KITCHN CO LVL FEEDTY2",
      "Model": "MKT95",
      "Equipment": 1017753565,
      "Serial": 1017753565,
      "Material": 13741980,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP1",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725324,
      "Serial": "SC010558",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP10",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752521,
      "Serial": "SC044780",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP11",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752522,
      "Serial": "SC045001",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP12",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752523,
      "Serial": "SC044522",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP13",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752524,
      "Serial": "SC045080",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP14",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752525,
      "Serial": "SC045026",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP15",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752526,
      "Serial": "SC045241",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP16",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752527,
      "Serial": "SC042825",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP17",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752528,
      "Serial": "SC019886",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP18",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752529,
      "Serial": "SC043400",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP19",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752530,
      "Serial": "SC019952",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP2",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008725366,
      "Serial": "SC01131",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP20",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752531,
      "Serial": "SC042632",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP21",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017752532,
      "Serial": "SC045088",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP22",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866528,
      "Serial": "SC03233",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP23",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1019578465,
      "Serial": "SC015956",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP24",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1023512162,
      "Serial": 5950,
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP4",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008728151,
      "Serial": "SC0497",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP5",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1008747442,
      "Serial": "SC037128",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP6",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009050865,
      "Serial": "SC012430",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP7",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009211718,
      "Serial": "SC011081",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP8",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009276610,
      "Serial": "SC023230",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "B83002",
      "AdminNo": "HCROP9",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1009349093,
      "Serial": "SCR0073",
      "Material": 14422751,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T95924",
      "AdminNo": "HDEFAC1",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865741,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T95924",
      "AdminNo": "HDEFAC2",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865697,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "H00654",
      "AdminNo": "HEATER1",
      "Description": "HEATER DU TY 350K BTU",
      "Model": "LCFH",
      "Equipment": 1017863077,
      "Serial": 175107000000000000,
      "Material": 15001534,
      "EQSLOC": "EGNV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "H00586",
      "AdminNo": "HEATER1",
      "Description": "HEATER D 140000BTU/HR",
      "Model": "H140",
      "Equipment": 1017870845,
      "Serial": "H14001423",
      "Material": 14770568,
      "EQSLOC": "AH2Y"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "H00586",
      "AdminNo": "HEATER4",
      "Description": "HEATER D 120000BTU/HR",
      "Model": "H140",
      "Equipment": 1017868799,
      "Serial": "H14002911",
      "Material": 14770568,
      "EQSLOC": "AH2Y"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "G42170",
      "AdminNo": "HEGEN1",
      "Description": "GEN SET HMT PU-798A",
      "Model": "PU798A",
      "Equipment": 1017869916,
      "Serial": "T06318191",
      "Material": 14133818,
      "EQSLOC": "EGOV"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "F64544",
      "AdminNo": "HFRS1",
      "Description": "FORWD REP SYS (FRS)",
      "Model": "M7FRS",
      "Equipment": 1017869215,
      "Serial": "2165-3",
      "Material": 15331621,
      "EQSLOC": "DW15"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "S33399",
      "AdminNo": "HFSC1",
      "Description": "FOOD SANITATION CN",
      "Model": "FSC-2",
      "Equipment": 1017758841,
      "Serial": 41877,
      "Material": 14962112,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "G07461",
      "AdminNo": "HG31",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870849,
      "Serial": "K120421016",
      "Material": 15617455,
      "EQSLOC": "EGOW"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T41995",
      "AdminNo": "HHB110",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869597,
      "Serial": "L-A114999BGLT",
      "Material": 14473882,
      "EQSLOC": "EGQO"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T96564",
      "AdminNo": "HHB110T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870807,
      "Serial": "TL-201994BGCS",
      "Material": 14491775,
      "EQSLOC": "EGQO"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB111",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870441,
      "Serial": 511214,
      "Material": 13469317,
      "EQSLOC": "EGQO"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T41995",
      "AdminNo": "HHB120",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017866998,
      "Serial": "L-A114998BGLT",
      "Material": 14473882,
      "EQSLOC": "EGQP"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T96564",
      "AdminNo": "HHB120T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870802,
      "Serial": "TL-201865BGBS",
      "Material": 14491775,
      "EQSLOC": "EGQP"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB121",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870078,
      "Serial": 511324,
      "Material": 13469317,
      "EQSLOC": "EGQP"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T56383",
      "AdminNo": "HHB130",
      "Description": "TRK UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868074,
      "Serial": 262814,
      "Material": 15402017,
      "EQSLOC": "EGQQ"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T37588",
      "AdminNo": "HHB131",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867839,
      "Serial": 262883,
      "Material": 15402007,
      "EQSLOC": "EGQQ"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB132",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869919,
      "Serial": 502542,
      "Material": 13469317,
      "EQSLOC": "EGQQ"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T41995",
      "AdminNo": "HHB140",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869127,
      "Serial": "L-A114529BGKT",
      "Material": 14473882,
      "EQSLOC": "EGQR"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T96564",
      "AdminNo": "HHB140T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870801,
      "Serial": "TL-201862BGBS",
      "Material": 14491775,
      "EQSLOC": "EGQR"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB150",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870093,
      "Serial": 212027,
      "Material": 13808604,
      "EQSLOC": "EGQI"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T37588",
      "AdminNo": "HHB151",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868060,
      "Serial": 263160,
      "Material": 15402007,
      "EQSLOC": "EGQI"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95992",
      "AdminNo": "HHB151T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864933,
      "Serial": 10644,
      "Material": 13875443,
      "EQSLOC": "EGQI"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T41995",
      "AdminNo": "HHB152",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867098,
      "Serial": "L-A114376BGKT",
      "Material": 14473882,
      "EQSLOC": "EGQI"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T96564",
      "AdminNo": "HHB152T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870803,
      "Serial": "TL-201866BGBS",
      "Material": 14491775,
      "EQSLOC": "EGQI"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB160",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870076,
      "Serial": 511281,
      "Material": 13469317,
      "EQSLOC": "EGQT"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB161",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870458,
      "Serial": 510863,
      "Material": 13469317,
      "EQSLOC": "EGQT"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95992",
      "AdminNo": "HHB161T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865256,
      "Serial": 12012,
      "Material": 13875443,
      "EQSLOC": "EGQT"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T37588",
      "AdminNo": "HHB162",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867840,
      "Serial": 262898,
      "Material": 15402007,
      "EQSLOC": "EGQT"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "G07461",
      "AdminNo": "HHB162T",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1031883549,
      "Serial": "H160990335",
      "Material": 15617455,
      "EQSLOC": "EGQT"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95992",
      "AdminNo": "HHB163T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865257,
      "Serial": 12014,
      "Material": 13875443,
      "EQSLOC": "EGQT"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB164",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870075,
      "Serial": 511273,
      "Material": 13469317,
      "EQSLOC": "EGQT"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95924",
      "AdminNo": "HHB164T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017864867,
      "Serial": "00900A",
      "Material": 13875426,
      "EQSLOC": "EGQT"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB210",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870522,
      "Serial": 570508,
      "Material": 13469317,
      "EQSLOC": "DW3A"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95992",
      "AdminNo": "HHB210T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865234,
      "Serial": 11958,
      "Material": 13875443,
      "EQSLOC": "DW3A"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB212",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869765,
      "Serial": 502348,
      "Material": 13469317,
      "EQSLOC": "DW3A"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB213",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869827,
      "Serial": 502555,
      "Material": 13469317,
      "EQSLOC": "DW3A"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95992",
      "AdminNo": "HHB213T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865591,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "DW3A"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB220",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870085,
      "Serial": 510140,
      "Material": 13469317,
      "EQSLOC": "DW38"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB221",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869981,
      "Serial": 511156,
      "Material": 13469317,
      "EQSLOC": "DW38"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB225",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870060,
      "Serial": 510047,
      "Material": 13469317,
      "EQSLOC": "DW38"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB230",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870153,
      "Serial": 511210,
      "Material": 13469317,
      "EQSLOC": "DW39"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95924",
      "AdminNo": "HHB231T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865353,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "DW39"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB232",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870294,
      "Serial": 193928,
      "Material": 13808604,
      "EQSLOC": "DW39"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB233",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870367,
      "Serial": 511372,
      "Material": 13469317,
      "EQSLOC": "DW39"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB234",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870565,
      "Serial": 570690,
      "Material": 13469317,
      "EQSLOC": "DW39"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB235",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870173,
      "Serial": 511349,
      "Material": 13469317,
      "EQSLOC": "DW39"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB240",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869753,
      "Serial": 502258,
      "Material": 13469317,
      "EQSLOC": "DW37"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95924",
      "AdminNo": "HHB240T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865266,
      "Serial": 43020090967,
      "Material": 13875426,
      "EQSLOC": "DW37"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB241",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870007,
      "Serial": 511364,
      "Material": 13469317,
      "EQSLOC": "DW37"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95992",
      "AdminNo": "HHB241T",
      "Description": "TRL CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864979,
      "Serial": 10671,
      "Material": 13875443,
      "EQSLOC": "DW37"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "W98825",
      "AdminNo": "HHB311W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863691,
      "Serial": "2549A",
      "Material": 11087367,
      "EQSLOC": "EGQS"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T38844",
      "AdminNo": "HHB320",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869002,
      "Serial": 70784,
      "Material": 11112274,
      "EQSLOC": "EGQK"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95992",
      "AdminNo": "HHB321T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865453,
      "Serial": 33951,
      "Material": 13875443,
      "EQSLOC": "EGQK"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95924",
      "AdminNo": "HHB322T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865269,
      "Serial": 43020090981,
      "Material": 13875426,
      "EQSLOC": "EGQK"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB323",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870171,
      "Serial": 511343,
      "Material": 13469317,
      "EQSLOC": "EGQK"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95992",
      "AdminNo": "HHB323T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865452,
      "Serial": 33950,
      "Material": 13875443,
      "EQSLOC": "EGQK"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB324",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869987,
      "Serial": 511316,
      "Material": 13469317,
      "EQSLOC": "EGQK"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB325",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870058,
      "Serial": 511379,
      "Material": 13469317,
      "EQSLOC": "EGQK"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T01691",
      "AdminNo": "HHB330",
      "Description": "TRK CHASS MTV",
      "Model": "M1092A1P2",
      "Equipment": 1031775757,
      "Serial": "10TANNFF1HS780701",
      "Material": 15527793,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "R05016",
      "AdminNo": "HHB330R",
      "Description": "RADAR SYSTEM,COUNTER FIRE TARGET ACQUI",
      "Model": "AN/TPQ-53",
      "Equipment": 1031774011,
      "Serial": "D81",
      "Material": 16017155,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T01691",
      "AdminNo": "HHB331",
      "Description": "TRK CHASS MTV",
      "Model": "M1092A1P2",
      "Equipment": 1031775758,
      "Serial": "10TANNFF4HS780904",
      "Material": 15527793,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T37588",
      "AdminNo": "HHB332",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867838,
      "Serial": 262872,
      "Material": 15402007,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "L26934",
      "AdminNo": "HHB332G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870717,
      "Serial": "T14-311-009",
      "Material": 15623992,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T37588",
      "AdminNo": "HHB333",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867743,
      "Serial": 263019,
      "Material": 15402007,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "L26934",
      "AdminNo": "HHB333G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870718,
      "Serial": "T14-311-004",
      "Material": 15623992,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T37588",
      "AdminNo": "HHB334",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867742,
      "Serial": 263054,
      "Material": 15402007,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T37588",
      "AdminNo": "HHB335",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868061,
      "Serial": 263204,
      "Material": 15402007,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "L26934",
      "AdminNo": "HHB335G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870719,
      "Serial": "T14-311-012",
      "Material": 15623992,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB336",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870521,
      "Serial": 573301,
      "Material": 13469317,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB337",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870587,
      "Serial": 573377,
      "Material": 13469317,
      "EQSLOC": "DW35"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95924",
      "AdminNo": "HHB337T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865528,
      "Serial": 12993,
      "Material": 13875426,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869745,
      "Serial": 502469,
      "Material": 13469317,
      "EQSLOC": "DW35"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HHB7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870649,
      "Serial": 511255,
      "Material": 13469317,
      "EQSLOC": "EGQL"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T95992",
      "AdminNo": "HHB7T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865590,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "DW35"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "WE5000",
      "AdminNo": "HHC",
      "Description": "HHC",
      "Model": "",
      "Equipment": 1017827294,
      "Serial": "USAU000514-0",
      "Material": 15272506,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "KA2506",
      "AdminNo": "HHC",
      "Description": "HHC",
      "Model": "",
      "Equipment": 1017832038,
      "Serial": 10113,
      "Material": "01C050251",
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "J03261",
      "AdminNo": "HHC",
      "Description": "HHC",
      "Model": "",
      "Equipment": 1017840955,
      "Serial": 435489,
      "Material": 15777174,
      "EQSLOC": "EGPF"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "N07848",
      "AdminNo": "HHC",
      "Description": "HHC",
      "Model": "",
      "Equipment": 1017844012,
      "Serial": 89004868,
      "Material": 16030489,
      "EQSLOC": "EGPF"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "YF4000",
      "AdminNo": "HHC1",
      "Description": "VEHICLE ALL TERRAIN: RANGER 4X4 700 XP P",
      "Model": "",
      "Equipment": 1017861176,
      "Serial": "4XARH68AX84404421",
      "Material": "01C056922",
      "EQSLOC": "DW1P"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "G18358",
      "AdminNo": "HHC1G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864411,
      "Serial": "FZA15231",
      "Material": 12853012,
      "EQSLOC": "AH49"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T34704",
      "AdminNo": "HHC25",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017868780,
      "Serial": 300008,
      "Material": 15402038,
      "EQSLOC": "DW3U"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T95992",
      "AdminNo": "HHC26T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865148,
      "Serial": 11973,
      "Material": 13875443,
      "EQSLOC": "DW3U"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T34704",
      "AdminNo": "HHC27",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1017867747,
      "Serial": 300009,
      "Material": 15402038,
      "EQSLOC": "DW3U"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T34704",
      "AdminNo": "HHC3",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1011559884,
      "Serial": 300642,
      "Material": 15402038,
      "EQSLOC": "DW3T"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T48944",
      "AdminNo": "HHC322",
      "Description": "TRK LF 6000LB RT",
      "Model": "RTFL",
      "Equipment": 1017869150,
      "Serial": "6000M1B0718R1",
      "Material": 11580849,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T48944",
      "AdminNo": "HHC323",
      "Description": "TRK LF 6000LB RT",
      "Model": "RTFL",
      "Equipment": 1017869149,
      "Serial": "6000M0C0222R",
      "Material": 11580849,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "LF309C",
      "AdminNo": "HHC32FL",
      "Description": "TRK FL ELE",
      "Model": "E25XLMIL",
      "Equipment": 1017870843,
      "Serial": "C114G06334P",
      "Material": 13441088,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "G18358",
      "AdminNo": "HHC3K1G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864398,
      "Serial": "FZA02598",
      "Material": 12853012,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "G18358",
      "AdminNo": "HHC3K2G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861476,
      "Serial": "FZA27542",
      "Material": 12853012,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "G18358",
      "AdminNo": "HHC3K3G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864353,
      "Serial": "FZA08932",
      "Material": 12853012,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T41036",
      "AdminNo": "HHC4",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868644,
      "Serial": "M-A114513BGKT",
      "Material": 14473889,
      "EQSLOC": "EGRS"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "YF2000",
      "AdminNo": "HHC40",
      "Description": "LOADER, BOBCAT ALL-WHEEL STEER: S150 BOB",
      "Model": "S150",
      "Equipment": 1017863094,
      "Serial": "A3L136303",
      "Material": "01V000001",
      "EQSLOC": "AH49"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "W98825",
      "AdminNo": "HHC4T",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863870,
      "Serial": "A3488",
      "Material": 11087367,
      "EQSLOC": "AH30"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T41036",
      "AdminNo": "HHC500",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868404,
      "Serial": "M-A114643BGKT",
      "Material": 14473889,
      "EQSLOC": "DVZV"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "W98825",
      "AdminNo": "HHC500WT",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863721,
      "Serial": 2718,
      "Material": 11087367,
      "EQSLOC": "AH49"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "M30688",
      "AdminNo": "HHC504C",
      "Description": "MULT-TEMP REFR CONT",
      "Model": "MTRCS02",
      "Equipment": 1017868403,
      "Serial": 9500955,
      "Material": 15929018,
      "EQSLOC": "DW4R"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "B83002",
      "AdminNo": "HHC504T",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866531,
      "Serial": "SC03303",
      "Material": 14422751,
      "EQSLOC": "DW4R"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "G18358",
      "AdminNo": "HHC5G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864396,
      "Serial": "FZA02318",
      "Material": 12853012,
      "EQSLOC": "DW3T"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "W98825",
      "AdminNo": "HHC5WT",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863688,
      "Serial": 3245,
      "Material": 11087367,
      "EQSLOC": "DW3T"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HHC6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869834,
      "Serial": 502519,
      "Material": 13469317,
      "EQSLOC": "EGRR"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HHC6",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870092,
      "Serial": 207208,
      "Material": 13808604,
      "EQSLOC": "DW3T"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HHC6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870436,
      "Serial": 511138,
      "Material": 13469317,
      "EQSLOC": "DW1P"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HHC60",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869924,
      "Serial": 502523,
      "Material": 13469317,
      "EQSLOC": "AH49"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T95992",
      "AdminNo": "HHC60T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865270,
      "Serial": 22820090643,
      "Material": 13875443,
      "EQSLOC": "AH49"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HHC7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869840,
      "Serial": 502500,
      "Material": 13469317,
      "EQSLOC": "DW3T"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HHC7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870178,
      "Serial": 511397,
      "Material": 13469317,
      "EQSLOC": "EGRR"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T37588",
      "AdminNo": "HHC70",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868703,
      "Serial": 262948,
      "Material": 15402007,
      "EQSLOC": "AH49"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T95992",
      "AdminNo": "HHC70T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865593,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "AH49"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T96564",
      "AdminNo": "HHC70T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870820,
      "Serial": "TL-201997BGCS",
      "Material": 14491775,
      "EQSLOC": "EGRU"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T41271",
      "AdminNo": "HHC71",
      "Description": "TRK CARGO M1087A1",
      "Model": "M1087A1",
      "Equipment": 1017868950,
      "Serial": "VEA114230BGJT",
      "Material": 15303843,
      "EQSLOC": "EGRU"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T95924",
      "AdminNo": "HHC7T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865448,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "AH2O"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HHC80",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870444,
      "Serial": 511226,
      "Material": 13469317,
      "EQSLOC": "EGRT"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T41995",
      "AdminNo": "HHC81",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867389,
      "Serial": "L-T120937EHBW",
      "Material": 14473882,
      "EQSLOC": "EGRT"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T96564",
      "AdminNo": "HHC81T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870869,
      "Serial": "TL-205179BGLT",
      "Material": 14491775,
      "EQSLOC": "EGRU"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HHC82",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870008,
      "Serial": 511366,
      "Material": 13469317,
      "EQSLOC": "EGRT"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T41036",
      "AdminNo": "HHC90",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868645,
      "Serial": "M-A114516BGKT",
      "Material": 14473889,
      "EQSLOC": "AH30"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T41995",
      "AdminNo": "HHC91",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867002,
      "Serial": "L-A115045BGLT",
      "Material": 14473882,
      "EQSLOC": "DW4R"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "W98825",
      "AdminNo": "HHC91T",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863725,
      "Serial": 2805,
      "Material": 11087367,
      "EQSLOC": "DW4R"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T41995",
      "AdminNo": "HHC92",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869121,
      "Serial": "L-A115050BGLT",
      "Material": 14473882,
      "EQSLOC": "DW4R"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "W98825",
      "AdminNo": "HHT1B",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863724,
      "Serial": 4884,
      "Material": 11087367,
      "EQSLOC": "EGQ2"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "G18358",
      "AdminNo": "HHT1G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861371,
      "Serial": "FZA01583",
      "Material": 12853012,
      "EQSLOC": "EGQ2"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "G18358",
      "AdminNo": "HHT2G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861372,
      "Serial": "FZA02279",
      "Material": 12853012,
      "EQSLOC": "EGQ2"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "G18358",
      "AdminNo": "HHT3G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861374,
      "Serial": "FZA21705",
      "Material": 12853012,
      "EQSLOC": "EGQ2"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "G18358",
      "AdminNo": "HHT4G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861486,
      "Serial": "FZA27433",
      "Material": 12853012,
      "EQSLOC": "DW2M"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T41995",
      "AdminNo": "HHT5",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869598,
      "Serial": "L-A114414BGKT",
      "Material": 14473882,
      "EQSLOC": "DW2M"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "G18358",
      "AdminNo": "HHT5G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864352,
      "Serial": "FZA00936",
      "Material": 12853012,
      "EQSLOC": "EGQ2"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T96564",
      "AdminNo": "HHT5T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870814,
      "Serial": "TL-201734BGAS",
      "Material": 14491775,
      "EQSLOC": "EGQ2"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HHT6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869930,
      "Serial": 502502,
      "Material": 13469317,
      "EQSLOC": "EGQ2"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "G18358",
      "AdminNo": "HHT6G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861373,
      "Serial": "FZA03847",
      "Material": 12853012,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T95555",
      "AdminNo": "HHT6T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870382,
      "Serial": "TM017222BFAM",
      "Material": 14491776,
      "EQSLOC": "EGQ2"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HHT7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869988,
      "Serial": 511318,
      "Material": 13469317,
      "EQSLOC": "EGQ2"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HHT7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870273,
      "Serial": 511195,
      "Material": 13469317,
      "EQSLOC": "DW2N"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T95992",
      "AdminNo": "HHT7T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865594,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "DW2M"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "K57392",
      "AdminNo": "HLT1",
      "Description": "HOW LT TWD M101",
      "Model": "M101LT",
      "Equipment": 1017870615,
      "Serial": 5823,
      "Material": 3229728,
      "EQSLOC": "EGQQ"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T41995",
      "AdminNo": "HQ1",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867009,
      "Serial": "L-A114436BGKT",
      "Material": 14473882,
      "EQSLOC": "EGR1"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T41995",
      "AdminNo": "HQ1",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867013,
      "Serial": "L-A114603BGKT",
      "Material": 14473882,
      "EQSLOC": "EGP7"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T41995",
      "AdminNo": "HQ11",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867011,
      "Serial": "L-A114441BGKT",
      "Material": 14473882,
      "EQSLOC": "DW4T"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T41995",
      "AdminNo": "HQ11",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867393,
      "Serial": "L-T120964EHBW",
      "Material": 14473882,
      "EQSLOC": "DW2L"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ11",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869746,
      "Serial": 502495,
      "Material": 13469317,
      "EQSLOC": "DVZZ"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T95924",
      "AdminNo": "HQ11T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865389,
      "Serial": 30703,
      "Material": 13875426,
      "EQSLOC": "DVZZ"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T96564",
      "AdminNo": "HQ11T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870818,
      "Serial": "TL-201730BGAS",
      "Material": 14491775,
      "EQSLOC": "DW4T"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ13",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870061,
      "Serial": 511136,
      "Material": 13469317,
      "EQSLOC": "DW4T"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ17X",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870435,
      "Serial": 511134,
      "Material": 13469317,
      "EQSLOC": "DW3R"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T96564",
      "AdminNo": "HQ1T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870748,
      "Serial": "TL-201727BGAS",
      "Material": 14491775,
      "EQSLOC": "EGR1"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T96564",
      "AdminNo": "HQ1T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870749,
      "Serial": "TL-201732BGAS",
      "Material": 14491775,
      "EQSLOC": "EGP7"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ2",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870263,
      "Serial": 510955,
      "Material": 13469317,
      "EQSLOC": "EGR2"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ2",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870507,
      "Serial": 511388,
      "Material": 13469317,
      "EQSLOC": "DW1V"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ20",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870576,
      "Serial": 572157,
      "Material": 13469317,
      "EQSLOC": "DVZY"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T42063",
      "AdminNo": "HQ200",
      "Description": "TRUCK CARGO",
      "Model": "M1081A1WW",
      "Equipment": 1017869218,
      "Serial": "L-A114373BGKT",
      "Material": 14473883,
      "EQSLOC": "DVZY"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T96564",
      "AdminNo": "HQ200T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870822,
      "Serial": "TL-205168BGLT",
      "Material": 14491775,
      "EQSLOC": "DVZY"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T41995",
      "AdminNo": "HQ21",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867015,
      "Serial": "L-A114705BGKT",
      "Material": 14473882,
      "EQSLOC": "DW1V"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T41036",
      "AdminNo": "HQ21",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868589,
      "Serial": "M-A114668BGKT",
      "Material": 14473889,
      "EQSLOC": "EGR2"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ21",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870266,
      "Serial": 511402,
      "Material": 13469317,
      "EQSLOC": "DVZY"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ21",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870648,
      "Serial": 573392,
      "Material": 13469317,
      "EQSLOC": "DW2S"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T60081",
      "AdminNo": "HQ210",
      "Description": "TRK CGO M1078A1 LMTV",
      "Model": "M1078A1",
      "Equipment": 1017868653,
      "Serial": "A-A012291BFAJ",
      "Material": 14476343,
      "EQSLOC": "AH48"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T95992",
      "AdminNo": "HQ21T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864869,
      "Serial": "02335A",
      "Material": 13875443,
      "EQSLOC": "DW2S"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T95555",
      "AdminNo": "HQ21T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870390,
      "Serial": "TM-016243BFKK",
      "Material": 14491776,
      "EQSLOC": "EGR2"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T96564",
      "AdminNo": "HQ21T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870819,
      "Serial": "TL-201993BGCS",
      "Material": 14491775,
      "EQSLOC": "DW1V"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T95992",
      "AdminNo": "HQ2T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865179,
      "Serial": 12003,
      "Material": 13875443,
      "EQSLOC": "EGR2"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T34704",
      "AdminNo": "HQ3",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1011560114,
      "Serial": 321108,
      "Material": 15402038,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T56383",
      "AdminNo": "HQ3",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1014516288,
      "Serial": 322384,
      "Material": 15402017,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T56383",
      "AdminNo": "HQ3",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868324,
      "Serial": 258936,
      "Material": 15402017,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ3",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869760,
      "Serial": 502424,
      "Material": 13469317,
      "EQSLOC": "EGR3"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ3",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870066,
      "Serial": 511225,
      "Material": 13469317,
      "EQSLOC": "EGQQ"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ30",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870362,
      "Serial": 511206,
      "Material": 13469317,
      "EQSLOC": "DW01"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T95992",
      "AdminNo": "HQ30T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865230,
      "Serial": 10732,
      "Material": 13875443,
      "EQSLOC": "DW01"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T61704",
      "AdminNo": "HQ31",
      "Description": "TRK CGO LWB M1085A1",
      "Model": "M1085A1",
      "Equipment": 1017868461,
      "Serial": "P-A012507BFCJ",
      "Material": 14473891,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ31",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870355,
      "Serial": 510877,
      "Material": 13469317,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ31",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870503,
      "Serial": 511345,
      "Material": 13469317,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ31",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870570,
      "Serial": 571602,
      "Material": 13469317,
      "EQSLOC": "EGR3"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T41995",
      "AdminNo": "HQ310",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869731,
      "Serial": "L-A114408BGKT",
      "Material": 14473882,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T96564",
      "AdminNo": "HQ310T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870882,
      "Serial": "TL-205781EGBU",
      "Material": 14491775,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T41995",
      "AdminNo": "HQ311",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867456,
      "Serial": "L-T120967EHBW",
      "Material": 14473882,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T41995",
      "AdminNo": "HQ312",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867394,
      "Serial": "L-T120965EHBW",
      "Material": 14473882,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "L84622",
      "AdminNo": "HQ313GT",
      "Description": "GENERATO SE DIE",
      "Model": "PU-2002",
      "Equipment": 1017870837,
      "Serial": "L120434640",
      "Material": 15624010,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "G18358",
      "AdminNo": "HQ31G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864407,
      "Serial": "FZA11553",
      "Material": 12853012,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "G12170",
      "AdminNo": "HQ31G",
      "Description": "GEN ST DSL MEP-804B",
      "Model": "MEP804B",
      "Equipment": 1017870864,
      "Serial": "FZ61870",
      "Material": 15301458,
      "EQSLOC": "DW4X"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "HQ31T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864994,
      "Serial": 11967,
      "Material": 13875443,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T95924",
      "AdminNo": "HQ31T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865112,
      "Serial": "07868A",
      "Material": 13875426,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T95992",
      "AdminNo": "HQ31T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865145,
      "Serial": 11966,
      "Material": 13875443,
      "EQSLOC": "EGR3"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T41995",
      "AdminNo": "HQ32",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867388,
      "Serial": "L-T120936EHBW",
      "Material": 14473882,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T41036",
      "AdminNo": "HQ32",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868594,
      "Serial": "M-A114314BGKT",
      "Material": 14473889,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ32",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870254,
      "Serial": 511290,
      "Material": 13469317,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ32",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870258,
      "Serial": 511325,
      "Material": 13469317,
      "EQSLOC": "EGR3"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ32",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870348,
      "Serial": 511081,
      "Material": 13469317,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T39954",
      "AdminNo": "HQ32G",
      "Description": "GENERAT SE DIE",
      "Model": "PU-2102",
      "Equipment": 1017869771,
      "Serial": "C150808401",
      "Material": 15624106,
      "EQSLOC": "DW2S"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T95992",
      "AdminNo": "HQ32T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865178,
      "Serial": 11999,
      "Material": 13875443,
      "EQSLOC": "AH3A"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T95924",
      "AdminNo": "HQ32T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865377,
      "Serial": 30695,
      "Material": 13875426,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T95924",
      "AdminNo": "HQ32T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865379,
      "Serial": 30698,
      "Material": 13875426,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T96564",
      "AdminNo": "HQ32T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870821,
      "Serial": "TL-201998BGCS",
      "Material": 14491775,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T34704",
      "AdminNo": "HQ33",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1011559916,
      "Serial": 300909,
      "Material": 15402038,
      "EQSLOC": "EGR3"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ33",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869996,
      "Serial": 511350,
      "Material": 13469317,
      "EQSLOC": "DW00"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ33",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870359,
      "Serial": 511116,
      "Material": 13469317,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "G18358",
      "AdminNo": "HQ33G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866101,
      "Serial": "FZA15076",
      "Material": 12853012,
      "EQSLOC": "EGR3"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95924",
      "AdminNo": "HQ33T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017870994,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T41036",
      "AdminNo": "HQ34",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017868764,
      "Serial": "M-A114690BGKT",
      "Material": 14473889,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ34",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870252,
      "Serial": 511285,
      "Material": 13469317,
      "EQSLOC": "DW05"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ35",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870577,
      "Serial": 572235,
      "Material": 13469317,
      "EQSLOC": "DW04"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "G18358",
      "AdminNo": "HQ35G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864405,
      "Serial": "FZA10272",
      "Material": 12853012,
      "EQSLOC": "DW04"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T95992",
      "AdminNo": "HQ35T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865233,
      "Serial": 11957,
      "Material": 13875443,
      "EQSLOC": "DW04"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T56383",
      "AdminNo": "HQ37",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1011557199,
      "Serial": 330868,
      "Material": 15402017,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T56383",
      "AdminNo": "HQ37",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868325,
      "Serial": 258949,
      "Material": 15402017,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T37588",
      "AdminNo": "HQ37",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868702,
      "Serial": 244723,
      "Material": 15402007,
      "EQSLOC": "DW08"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T95924",
      "AdminNo": "HQ37T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865382,
      "Serial": 30704,
      "Material": 13875426,
      "EQSLOC": "DW08"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ38",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870461,
      "Serial": 511248,
      "Material": 13469317,
      "EQSLOC": "DW08"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T95992",
      "AdminNo": "HQ38T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865229,
      "Serial": 10730,
      "Material": 13875443,
      "EQSLOC": "DW08"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "G42170",
      "AdminNo": "HQ39GT",
      "Description": "GEN SET HMT PU-798A",
      "Model": "PU798A",
      "Equipment": 1017869907,
      "Serial": "T090360",
      "Material": 14133818,
      "EQSLOC": "DW08"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T37588",
      "AdminNo": "HQ4",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867841,
      "Serial": 262903,
      "Material": 15402007,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T56383",
      "AdminNo": "HQ4",
      "Description": "TRK UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868318,
      "Serial": 262581,
      "Material": 15402017,
      "EQSLOC": "EGQR"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ40",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870584,
      "Serial": 573364,
      "Material": 13469317,
      "EQSLOC": "DVZX"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T41995",
      "AdminNo": "HQ41",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869125,
      "Serial": "L-A114411BGKT",
      "Material": 14473882,
      "EQSLOC": "EGR4"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ41",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869833,
      "Serial": 502506,
      "Material": 13469317,
      "EQSLOC": "DW2P"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ41",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869999,
      "Serial": 511249,
      "Material": 13469317,
      "EQSLOC": "DW4W"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "G18358",
      "AdminNo": "HQ41G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017861477,
      "Serial": "FZA27464",
      "Material": 12853012,
      "EQSLOC": "DW2P"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T96564",
      "AdminNo": "HQ41T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870747,
      "Serial": "TL-201724BGAS",
      "Material": 14491775,
      "EQSLOC": "EGR4"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T56383",
      "AdminNo": "HQ5",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1011558569,
      "Serial": 330993,
      "Material": 15402017,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869750,
      "Serial": 502575,
      "Material": 13469317,
      "EQSLOC": "DVZW"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869918,
      "Serial": 502539,
      "Material": 13469317,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870459,
      "Serial": 511065,
      "Material": 13469317,
      "EQSLOC": "EGQQ"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870586,
      "Serial": 573375,
      "Material": 13469317,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870590,
      "Serial": 573421,
      "Material": 13469317,
      "EQSLOC": "DW3P"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T56383",
      "AdminNo": "HQ6",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1014516103,
      "Serial": 315296,
      "Material": 15402017,
      "EQSLOC": "DVZW"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869838,
      "Serial": 502436,
      "Material": 13469317,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869922,
      "Serial": 502324,
      "Material": 13469317,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T41995",
      "AdminNo": "HQ60",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867392,
      "Serial": "L-T120940EHBW",
      "Material": 14473882,
      "EQSLOC": "DW4X"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T37588",
      "AdminNo": "HQ61",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868059,
      "Serial": 263118,
      "Material": 15402007,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T37588",
      "AdminNo": "HQ61",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868064,
      "Serial": 262995,
      "Material": 15402007,
      "EQSLOC": "DW02"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ61",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870077,
      "Serial": 511282,
      "Material": 13469317,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ61",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870592,
      "Serial": 573451,
      "Material": 13469317,
      "EQSLOC": "DW4X"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "G07461",
      "AdminNo": "HQ61NGT",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1031882375,
      "Serial": "E170187521",
      "Material": 15617455,
      "EQSLOC": "DW02"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T95924",
      "AdminNo": "HQ61T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865385,
      "Serial": 30673,
      "Material": 13875426,
      "EQSLOC": "DW4X"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ62",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870170,
      "Serial": 511331,
      "Material": 13469317,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ62",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870272,
      "Serial": 511191,
      "Material": 13469317,
      "EQSLOC": "DW09"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ62",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870360,
      "Serial": 511126,
      "Material": 13469317,
      "EQSLOC": "DW4X"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ62",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870504,
      "Serial": 511367,
      "Material": 13469317,
      "EQSLOC": "DW2N"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ62",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870513,
      "Serial": 199348,
      "Material": 13808604,
      "EQSLOC": "DW2N"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T95992",
      "AdminNo": "HQ62T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865232,
      "Serial": 11927,
      "Material": 13875443,
      "EQSLOC": "DW02"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T95924",
      "AdminNo": "HQ62T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865384,
      "Serial": 30665,
      "Material": 13875426,
      "EQSLOC": "DW4X"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95924",
      "AdminNo": "HQ62T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865390,
      "Serial": 30690,
      "Material": 13875426,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T37588",
      "AdminNo": "HQ63",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867752,
      "Serial": 262775,
      "Material": 15402007,
      "EQSLOC": "DW2N"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ63",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870071,
      "Serial": 511239,
      "Material": 13469317,
      "EQSLOC": "DW4X"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T11588",
      "AdminNo": "HQ63A",
      "Description": "TRUCK UTILITY M1152",
      "Model": "M1152",
      "Equipment": 1017870372,
      "Serial": 226331,
      "Material": 15187332,
      "EQSLOC": "H2VF"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T11588",
      "AdminNo": "HQ63B",
      "Description": "TRUCK UTILITY M1152",
      "Model": "M1152",
      "Equipment": 1017870373,
      "Serial": 226427,
      "Material": 15187332,
      "EQSLOC": "H2VF"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "G07461",
      "AdminNo": "HQ63GT",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1031870607,
      "Serial": "E170183416",
      "Material": 15617455,
      "EQSLOC": "DW2N"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "HQ63T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865113,
      "Serial": 10657,
      "Material": 13875443,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ64",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869744,
      "Serial": 502263,
      "Material": 13469317,
      "EQSLOC": "DW4X"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ64",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869825,
      "Serial": 502511,
      "Material": 13469317,
      "EQSLOC": "AH2I"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ64",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869826,
      "Serial": 502546,
      "Material": 13469317,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T11588",
      "AdminNo": "HQ64A",
      "Description": "TRUCK UTILITY M1152",
      "Model": "M1152",
      "Equipment": 1017870371,
      "Serial": 226295,
      "Material": 15187332,
      "EQSLOC": "H2VF"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T11588",
      "AdminNo": "HQ64B",
      "Description": "TRUCK UTILITY M1152",
      "Model": "M1152",
      "Equipment": 1017870374,
      "Serial": 226483,
      "Material": 15187332,
      "EQSLOC": "H2VF"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T37588",
      "AdminNo": "HQ65",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017867461,
      "Serial": 263037,
      "Material": 15402007,
      "EQSLOC": "DW4X"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ65",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869985,
      "Serial": 511270,
      "Material": 13469317,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T41036",
      "AdminNo": "HQ66",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869688,
      "Serial": "M-A114659BGKT",
      "Material": 14473889,
      "EQSLOC": "DW2N"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ66",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870301,
      "Serial": 206319,
      "Material": 13808604,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T95924",
      "AdminNo": "HQ66T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865355,
      "Serial": 30693,
      "Material": 13875426,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T56383",
      "AdminNo": "HQ6A",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868068,
      "Serial": 258264,
      "Material": 15402017,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "G74711",
      "AdminNo": "HQ6G1",
      "Description": "GEN ST DSL MEP-803A",
      "Model": "MEP803A",
      "Equipment": 1032290198,
      "Serial": "FZ41124",
      "Material": 12755061,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ6X",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870090,
      "Serial": 207112,
      "Material": 13808604,
      "EQSLOC": "AH3A"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T34704",
      "AdminNo": "HQ7",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1011560184,
      "Serial": 325640,
      "Material": 15402038,
      "EQSLOC": "DW2R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T56383",
      "AdminNo": "HQ7",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868328,
      "Serial": 258858,
      "Material": 15402017,
      "EQSLOC": "DW1U"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870150,
      "Serial": 511181,
      "Material": 13469317,
      "EQSLOC": "DW3P"
    },
    {
      "UIC": "WHBRT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870268,
      "Serial": 510033,
      "Material": 13469317,
      "EQSLOC": "EGQQ"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870442,
      "Serial": 511217,
      "Material": 13469317,
      "EQSLOC": "DVZW"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "T07679",
      "AdminNo": "HQ7",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870460,
      "Serial": 511112,
      "Material": 13469317,
      "EQSLOC": "DW4V"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ8",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870259,
      "Serial": 511338,
      "Material": 13469317,
      "EQSLOC": "DW3R"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ80",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870582,
      "Serial": 573329,
      "Material": 13469317,
      "EQSLOC": "DW07"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T95992",
      "AdminNo": "HQ80T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865235,
      "Serial": 12002,
      "Material": 13875443,
      "EQSLOC": "DW07"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T38844",
      "AdminNo": "HQ81",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869037,
      "Serial": 54627,
      "Material": 11112274,
      "EQSLOC": "EGQ1"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ81",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870276,
      "Serial": 511294,
      "Material": 13469317,
      "EQSLOC": "DW07"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T95992",
      "AdminNo": "HQ81T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865146,
      "Serial": 11968,
      "Material": 13875443,
      "EQSLOC": "EGQ1"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T38844",
      "AdminNo": "HQ82",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869003,
      "Serial": 49670,
      "Material": 11112274,
      "EQSLOC": "EGQ1"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T07679",
      "AdminNo": "HQ82",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870262,
      "Serial": 511035,
      "Material": 13469317,
      "EQSLOC": "DW01"
    },
    {
      "UIC": "WJK6AA",
      "LINNumber": "T95992",
      "AdminNo": "HQ82T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865231,
      "Serial": 11919,
      "Material": 13875443,
      "EQSLOC": "DW01"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T38844",
      "AdminNo": "HQ84",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869036,
      "Serial": 5419,
      "Material": 11112274,
      "EQSLOC": "EGQ1"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ85",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870447,
      "Serial": 511296,
      "Material": 13469317,
      "EQSLOC": "EGQ1"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ86",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870250,
      "Serial": 511184,
      "Material": 13469317,
      "EQSLOC": "EGQ1"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T07679",
      "AdminNo": "HQ9",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869923,
      "Serial": 502514,
      "Material": 13469317,
      "EQSLOC": "EGR5"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T41995",
      "AdminNo": "HQ91",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867383,
      "Serial": "L-T120896EHAW",
      "Material": 14473882,
      "EQSLOC": "EGR5"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T95992",
      "AdminNo": "HQ9T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865142,
      "Serial": 10731,
      "Material": 13875443,
      "EQSLOC": "EGR5"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T38844",
      "AdminNo": "MED1",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869043,
      "Serial": 56800,
      "Material": 11112274,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T38707",
      "AdminNo": "MED10",
      "Description": "TRK AMB 2 LITTER M996",
      "Model": "M996",
      "Equipment": 1017869943,
      "Serial": 70864,
      "Material": 11112275,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "MED1T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865140,
      "Serial": 10724,
      "Material": 13875443,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T38844",
      "AdminNo": "MED2",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869042,
      "Serial": 55054,
      "Material": 11112274,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T38844",
      "AdminNo": "MED2",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869141,
      "Serial": 51374,
      "Material": 11112274,
      "EQSLOC": "DW3S"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "G18358",
      "AdminNo": "MED2G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864403,
      "Serial": "FZA09290",
      "Material": 12853012,
      "EQSLOC": "DW3S"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "MED2T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865136,
      "Serial": 10669,
      "Material": 13875443,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T38844",
      "AdminNo": "MED3",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869140,
      "Serial": 60410,
      "Material": 11112274,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "G18358",
      "AdminNo": "MED3K1",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864402,
      "Serial": "FZA08903",
      "Material": 12853012,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "MED3T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865138,
      "Serial": 10714,
      "Material": 13875443,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "T96564",
      "AdminNo": "MED3T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870805,
      "Serial": "TL-201871BGBS",
      "Material": 14491775,
      "EQSLOC": "DW3S"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T38844",
      "AdminNo": "MED4",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869004,
      "Serial": 50191,
      "Material": 11112274,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG24T0",
      "LINNumber": "C11280",
      "AdminNo": "MED4",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869183,
      "Serial": "88-AFL5584",
      "Material": 12816451,
      "EQSLOC": "DW3S"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "MED4T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865271,
      "Serial": 22820090644,
      "Material": 13875443,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T38844",
      "AdminNo": "MED5",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869008,
      "Serial": 51650,
      "Material": 11112274,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "MED5T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865137,
      "Serial": 10672,
      "Material": 13875443,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "MED6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869759,
      "Serial": 502340,
      "Material": 13469317,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T38844",
      "AdminNo": "MED8",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869014,
      "Serial": 51770,
      "Material": 11112274,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T38707",
      "AdminNo": "MED9",
      "Description": "TRK AMB 2 LITTER M996",
      "Model": "M996",
      "Equipment": 1017869941,
      "Serial": 44288,
      "Material": 11112275,
      "EQSLOC": "EGPD"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "MTR1T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865394,
      "Serial": 30172,
      "Material": 13875443,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "MTR2",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870159,
      "Serial": 511293,
      "Material": 13469317,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "MTR2T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865393,
      "Serial": 30167,
      "Material": 13875443,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "MTR3T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865392,
      "Serial": 22820090860,
      "Material": 13875443,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "MTR4T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865391,
      "Serial": 22820090853,
      "Material": 13875443,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "MTR5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869993,
      "Serial": 511360,
      "Material": 13469317,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "MTR6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869749,
      "Serial": 502468,
      "Material": 13469317,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T95992",
      "AdminNo": "MTR6T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865115,
      "Serial": 10664,
      "Material": 13875443,
      "EQSLOC": "EGPA"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "M30688",
      "AdminNo": "MTRCS-1",
      "Description": "MULT-TEMP REFR CONT",
      "Model": "MTRCS02",
      "Equipment": 1017868399,
      "Serial": 9500951,
      "Material": 15929018,
      "EQSLOC": "DW1B"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "V12141",
      "AdminNo": "PUMP5",
      "Description": "TK-PUMP UN 126ETP",
      "Model": "126ETP",
      "Equipment": 1017865746,
      "Serial": "126-0794",
      "Material": 12740021,
      "EQSLOC": "EGNW"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T96564",
      "AdminNo": "R121T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870796,
      "Serial": "TL-201739BGAS",
      "Material": 14491775,
      "EQSLOC": "G4G5"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T96564",
      "AdminNo": "R122T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870870,
      "Serial": "TL-205184BGLT",
      "Material": 14491775,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T96564",
      "AdminNo": "R123T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870886,
      "Serial": "TL-205799EGBU",
      "Material": 14491775,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T96564",
      "AdminNo": "R124T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870889,
      "Serial": "TL-205985EGCU",
      "Material": 14491775,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "S70027",
      "AdminNo": "R125T",
      "Description": "SEMITRAILER LOW BED",
      "Model": "M871A3",
      "Equipment": 1017870743,
      "Serial": "V-2412A-7-A5901879",
      "Material": 14586865,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "S70517",
      "AdminNo": "R126T",
      "Description": "STLR LB 25T M172A1",
      "Model": "M172A1",
      "Equipment": 1017855657,
      "Serial": 47193,
      "Material": 3176448,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T95555",
      "AdminNo": "R127T",
      "Description": "TRLER FLAT BED M1095",
      "Model": "M1095",
      "Equipment": 1017870398,
      "Serial": "TM-207622EHMU",
      "Material": 14491776,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T95924",
      "AdminNo": "R128T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865417,
      "Serial": 9297,
      "Material": 13875426,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T49255",
      "AdminNo": "R130F",
      "Description": "TRK LF FK 4K RT W/CAB",
      "Model": "M4K",
      "Equipment": 1017869157,
      "Serial": "8909-736",
      "Material": 13308906,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T49255",
      "AdminNo": "R131F",
      "Description": "TRK LF FK 4K W/O CAB",
      "Model": "MHE270",
      "Equipment": 1017870910,
      "Serial": "8909-713",
      "Material": 13308907,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T49255",
      "AdminNo": "R132F",
      "Description": "TRK LF FK 4K RT W/CAB",
      "Model": "MHE271",
      "Equipment": 1017869156,
      "Serial": "8909-732",
      "Material": 13308906,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T49255",
      "AdminNo": "R133F",
      "Description": "TRK LF FK 4K W/O CAB",
      "Model": "MHE270",
      "Equipment": 1011739003,
      "Serial": "8909-642",
      "Material": 13308907,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T73347",
      "AdminNo": "R135F",
      "Description": "TRK LFT FK VAR RCH RT",
      "Model": "ATLAS",
      "Equipment": 1017869721,
      "Serial": "10KA1516R1",
      "Material": 14172886,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T73347",
      "AdminNo": "R136F",
      "Description": "TRK LIFT FORK",
      "Model": "ATLAS II",
      "Equipment": 1017867916,
      "Serial": "10KB0483",
      "Material": 15536676,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "G42488",
      "AdminNo": "R142G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1017870490,
      "Serial": "K120419580",
      "Material": 15617329,
      "EQSLOC": "G4G5"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "L84622",
      "AdminNo": "R143G",
      "Description": "GENERATO SE DIE",
      "Model": "PU-2002",
      "Equipment": 1017870903,
      "Serial": "L120434659",
      "Material": 15624010,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "G42488",
      "AdminNo": "R144G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1017870493,
      "Serial": "K120419592",
      "Material": 15617329,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "C36151",
      "AdminNo": "R1C",
      "Description": "CRANE WHL MTD",
      "Model": "LRT110",
      "Equipment": 1017870197,
      "Serial": 98087,
      "Material": 11650646,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T41995",
      "AdminNo": "R210",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867334,
      "Serial": "L-A115051BGLT",
      "Material": 14473882,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T41995",
      "AdminNo": "R211",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869131,
      "Serial": "L-A114600BGKT",
      "Material": 14473882,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T41995",
      "AdminNo": "R212",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869680,
      "Serial": "L-A114597BGKT",
      "Material": 14473882,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T41995",
      "AdminNo": "R213",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867391,
      "Serial": "L-T120939EHBW",
      "Material": 14473882,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "H00654",
      "AdminNo": "R2H",
      "Description": "HEATER DU TY 350K BTU",
      "Model": "LCFH",
      "Equipment": 1017863034,
      "Serial": 175102000000000000,
      "Material": 15001534,
      "EQSLOC": "G4G5"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T07679",
      "AdminNo": "R302",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870160,
      "Serial": 511337,
      "Material": 13469317,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T41036",
      "AdminNo": "R311",
      "Description": "TRK CG 5T 6X6 MTV W/E",
      "Model": "M1093A1WOW",
      "Equipment": 1017869109,
      "Serial": "M-A114669BGKT",
      "Material": 14473889,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T61239",
      "AdminNo": "R312",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868972,
      "Serial": "T-A110204BGCT",
      "Material": 14473893,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T61239",
      "AdminNo": "R313",
      "Description": "TRK TRACTOR M1088A1",
      "Model": "M1088A1",
      "Equipment": 1017868412,
      "Serial": "T-A012560BFDJ",
      "Material": 14473893,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T41995",
      "AdminNo": "R314",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867385,
      "Serial": "L-T120898EHAW",
      "Material": 14473882,
      "EQSLOC": "G4G5"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T41995",
      "AdminNo": "R315",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869112,
      "Serial": "L-A114440BGKT",
      "Material": 14473882,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T41995",
      "AdminNo": "R316",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869113,
      "Serial": "L-A114445BGKT",
      "Material": 14473882,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T41995",
      "AdminNo": "R317",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869111,
      "Serial": "L-A114380BGKT",
      "Material": 14473882,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "H00654",
      "AdminNo": "R3H",
      "Description": "HEATER DU TY 350K BTU",
      "Model": "LCFH",
      "Equipment": 1017863078,
      "Serial": 175107000000000000,
      "Material": 15001534,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "H00654",
      "AdminNo": "R4H",
      "Description": "HEATER DU TY 350K BTU",
      "Model": "LCFH",
      "Equipment": 1017863079,
      "Serial": 175107000000000000,
      "Material": 15001534,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "H00654",
      "AdminNo": "R5H",
      "Description": "HEATER DU TY 350K BTU",
      "Model": "LCFH",
      "Equipment": 1017863080,
      "Serial": 175107000000000000,
      "Material": 15001534,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T07679",
      "AdminNo": "R6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870086,
      "Serial": 511169,
      "Material": 13469317,
      "EQSLOC": "G4G5"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T07679",
      "AdminNo": "R7",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870087,
      "Serial": 203771,
      "Material": 13808604,
      "EQSLOC": "G4G5"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "L28351",
      "AdminNo": "RMKT01",
      "Description": "KITCHN FLD TRAILR MTD",
      "Model": "MKT99 GRN",
      "Equipment": 1017869365,
      "Serial": "1369-85",
      "Material": 14838617,
      "EQSLOC": "GGLK"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "YF1097",
      "AdminNo": "SCT1",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091495,
      "Serial": "1120180602X1297",
      "Material": 16698480,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "SCT10",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870082,
      "Serial": 510031,
      "Material": 13469317,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "SCT11",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870455,
      "Serial": 511235,
      "Material": 13469317,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "YF1097",
      "AdminNo": "SCT2",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091500,
      "Serial": "1120180610X1297",
      "Material": 16698480,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "YF1097",
      "AdminNo": "SCT3",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1033091539,
      "Serial": "1220160125X1297",
      "Material": 16698480,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "SCT4",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870358,
      "Serial": 511096,
      "Material": 13469317,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "SCT5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870175,
      "Serial": 511380,
      "Material": 13469317,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "SCT6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870155,
      "Serial": 511224,
      "Material": 13469317,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T41995",
      "AdminNo": "SCT7",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867102,
      "Serial": "L-A115038BGLT",
      "Material": 14473882,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "SCT8",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870365,
      "Serial": 511306,
      "Material": 13469317,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "T07679",
      "AdminNo": "SCT9",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870084,
      "Serial": 510073,
      "Material": 13469317,
      "EQSLOC": "DW1R"
    },
    {
      "UIC": "WAQ0A0",
      "LINNumber": "T56383",
      "AdminNo": "SNE-A",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868407,
      "Serial": 262298,
      "Material": 15402017,
      "EQSLOC": "EGQ5"
    },
    {
      "UIC": "WAQ0B0",
      "LINNumber": "T56383",
      "AdminNo": "SNE-B",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868408,
      "Serial": 258832,
      "Material": 15402017,
      "EQSLOC": "EGRM"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "T56383",
      "AdminNo": "SSA 07",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1011557907,
      "Serial": 330881,
      "Material": 15402017,
      "EQSLOC": "DW30"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T32629",
      "AdminNo": "TNK1",
      "Description": "TANK LIQD STORAGE",
      "Model": "M105",
      "Equipment": 1017869279,
      "Serial": 718,
      "Material": 14877760,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T32629",
      "AdminNo": "TNK2",
      "Description": "TANK LIQD STORAGE",
      "Model": "M105",
      "Equipment": 1017869280,
      "Serial": 721,
      "Material": 14877760,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T32629",
      "AdminNo": "TNK3",
      "Description": "TANK LIQD STORAGE",
      "Model": "M105",
      "Equipment": 1017869281,
      "Serial": 723,
      "Material": 14877760,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T32629",
      "AdminNo": "TNK4",
      "Description": "TANK LIQD STORAGE",
      "Model": "M105",
      "Equipment": 1017869282,
      "Serial": 727,
      "Material": 14877760,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T32629",
      "AdminNo": "TNK5",
      "Description": "TANK LIQD STORAGE",
      "Model": "M105",
      "Equipment": 1017869283,
      "Serial": 728,
      "Material": 14877760,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T32629",
      "AdminNo": "TNK6",
      "Description": "TANK LIQD STORAGE",
      "Model": "M105",
      "Equipment": 1017869284,
      "Serial": "0198R",
      "Material": 14877760,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T32629",
      "AdminNo": "TNK7",
      "Description": "TANK LIQD STORAGE",
      "Model": "M105",
      "Equipment": 1017869285,
      "Serial": "0222R",
      "Material": 14877760,
      "EQSLOC": "DW0O"
    },
    {
      "UIC": "WG6WT0",
      "LINNumber": "G07461",
      "AdminNo": "UIC   -",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1031807634,
      "Serial": "E170187430",
      "Material": 15617455,
      "EQSLOC": "DW1S"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "G07461",
      "AdminNo": "UIC   -",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1031871631,
      "Serial": "E170182945",
      "Material": 15617455,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "G07461",
      "AdminNo": "UIC   -",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1031879818,
      "Serial": "E170182939",
      "Material": 15617455,
      "EQSLOC": "DW4X"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "T87771",
      "AdminNo": "UIC   -",
      "Description": "SNOWMOBILE TYPE 3",
      "Model": "TYPE 3",
      "Equipment": 1033066471,
      "Serial": "2BPSGD9A09V001036",
      "Material": 10909325,
      "EQSLOC": "DVYJ"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "YF4097",
      "AdminNo": "UIC   -",
      "Description": "SNOWMOBILE",
      "Model": "",
      "Equipment": 1033074294,
      "Serial": 2696112,
      "Material": "01C941478",
      "EQSLOC": "DVYJ"
    },
    {
      "UIC": "WG24B0",
      "LINNumber": "YF4097",
      "AdminNo": "UIC   -",
      "Description": "SNOWMOBILE",
      "Model": "",
      "Equipment": 1033074295,
      "Serial": "4UF02SNW62T125937",
      "Material": "01C941478",
      "EQSLOC": "DVYJ"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G07461",
      "AdminNo": "UIC   -",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1033956056,
      "Serial": "G190600820",
      "Material": 15617455,
      "EQSLOC": "AH36"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G07461",
      "AdminNo": "UIC   -",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1033956057,
      "Serial": "K120414537",
      "Material": 15617455,
      "EQSLOC": "AH36"
    },
    {
      "UIC": "WG24C0",
      "LINNumber": "G07461",
      "AdminNo": "UIC   -",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1033956058,
      "Serial": "K120414536",
      "Material": 15617455,
      "EQSLOC": "AH36"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T20131",
      "AdminNo": "UIC   -",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1033966884,
      "Serial": 1119,
      "Material": 15176939,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T20131",
      "AdminNo": "UIC   -",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1033966887,
      "Serial": 1123,
      "Material": 15176939,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T20131",
      "AdminNo": "UIC   -",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1033966888,
      "Serial": 1125,
      "Material": 15176939,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T20131",
      "AdminNo": "UIC   -",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1033966889,
      "Serial": 1126,
      "Material": 15176939,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T20131",
      "AdminNo": "UIC   -",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1034000368,
      "Serial": 1135,
      "Material": 15176939,
      "EQSLOC": "AH2M"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T20131",
      "AdminNo": "UIC   -",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1034000369,
      "Serial": 1137,
      "Material": 15176939,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "T20131",
      "AdminNo": "UIC   -",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1034000370,
      "Serial": 1139,
      "Material": 15176939,
      "EQSLOC": "AH2M"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T20131",
      "AdminNo": "UIC   -",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1034010590,
      "Serial": 1129,
      "Material": 15176939,
      "EQSLOC": "AH2Y"
    },
    {
      "UIC": "WC9TH0",
      "LINNumber": "T20131",
      "AdminNo": "UIC   -",
      "Description": "TANK UNIT FUEL DISP",
      "Model": "MFS-TRM",
      "Equipment": 1034010591,
      "Serial": 1131,
      "Material": 15176939,
      "EQSLOC": "AH2Y"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YB057P",
      "AdminNo": "WAQ0C0-C2104",
      "Description": "OUTBOARD MOTOR,GASOLINE",
      "Model": "",
      "Equipment": 1017829636,
      "Serial": 5102104,
      "Material": 12675047,
      "EQSLOC": "EGQD"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "G18358",
      "AdminNo": "WAQ0C0-C257",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866097,
      "Serial": "FZA21257",
      "Material": 12853012,
      "EQSLOC": "DW33"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YB057P",
      "AdminNo": "WAQ0C0-C2602",
      "Description": "OUTBOARD MOTOR,GASOLINE",
      "Model": "",
      "Equipment": 1017829637,
      "Serial": 5102602,
      "Material": 12675047,
      "EQSLOC": "EGQD"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YB057P",
      "AdminNo": "WAQ0C0-C2887",
      "Description": "OUTBOARD MOTOR,GASOLINE",
      "Model": "",
      "Equipment": 1017829594,
      "Serial": 5092887,
      "Material": 12675047,
      "EQSLOC": "EGQE"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YB057P",
      "AdminNo": "WAQ0C0-C3334",
      "Description": "OUTBOARD MOTOR,GASOLINE",
      "Model": "",
      "Equipment": 1017829638,
      "Serial": 5103334,
      "Material": 12675047,
      "EQSLOC": "EGQD"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YB057P",
      "AdminNo": "WAQ0C0-C3965",
      "Description": "OUTBOARD MOTOR,GASOLINE",
      "Model": "",
      "Equipment": 1017829639,
      "Serial": 5103965,
      "Material": 12675047,
      "EQSLOC": "DW31"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YB057P",
      "AdminNo": "WAQ0C0-C4425",
      "Description": "OUTBOARD MOTOR,GASOLINE",
      "Model": "",
      "Equipment": 1017829640,
      "Serial": 5104425,
      "Material": 12675047,
      "EQSLOC": "DW32"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "YB057P",
      "AdminNo": "WAQ0C0-C4440",
      "Description": "OUTBOARD MOTOR,GASOLINE",
      "Model": "",
      "Equipment": 1017829641,
      "Serial": 5104440,
      "Material": 12675047,
      "EQSLOC": "DW33"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "FD1518",
      "AdminNo": "WAQ0T0-",
      "Description": "GENERATOR PORTABLE: HOND-EU2000IC HONDA",
      "Model": "",
      "Equipment": 1017830079,
      "Serial": "EAAJ-2646930",
      "Material": "01C155994",
      "EQSLOC": "DW2N"
    },
    {
      "UIC": "WAQ0T0",
      "LINNumber": "FD1518",
      "AdminNo": "WAQ0T0-",
      "Description": "GENERATOR PORTABLE: HOND-EU2000IC HONDA",
      "Model": "",
      "Equipment": 1017830080,
      "Serial": "EAAJ-2646939",
      "Material": "01C155994",
      "EQSLOC": "DW2N"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "LF209L",
      "AdminNo": "WB77AA-",
      "Description": "TRUCK,HAND",
      "Model": "",
      "Equipment": 1017761451,
      "Serial": 1017761451,
      "Material": 2221028,
      "EQSLOC": "ERFV"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "YF3001",
      "AdminNo": "WB77AA-",
      "Description": "TRAILERS, ASSORTED: AUTO WAGON WELLS CAR",
      "Model": "",
      "Equipment": 1017774374,
      "Serial": "1WC200J2647010986",
      "Material": "01C138199",
      "EQSLOC": "EGS1"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "11160N",
      "AdminNo": "WB77AA-EOD-GATOR",
      "Description": "UTILITY VEHICLE,4WD",
      "Model": "",
      "Equipment": 1017766013,
      "Serial": "MOM6X4D015199",
      "Material": 14202816,
      "EQSLOC": "ERFV"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T56383",
      "AdminNo": "WB77AA-EOD1",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017774967,
      "Serial": 330946,
      "Material": 15402017,
      "EQSLOC": "EGS1"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "G42170",
      "AdminNo": "WB77AA-EOD1-2G",
      "Description": "GEN SET HMT PU-798A",
      "Model": "PU798A",
      "Equipment": 1017774486,
      "Serial": "T-06-017-032",
      "Material": 14133818,
      "EQSLOC": "ERFW"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "G42170",
      "AdminNo": "WB77AA-EOD1-3G",
      "Description": "GEN SET HMT PU-798A",
      "Model": "PU798A",
      "Equipment": 1017774485,
      "Serial": "T-07-310-441",
      "Material": 14133818,
      "EQSLOC": "EGRW"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T07679",
      "AdminNo": "WB77AA-EOD11",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017774493,
      "Serial": 502387,
      "Material": 13469317,
      "EQSLOC": "ERFX"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T07679",
      "AdminNo": "WB77AA-EOD12",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017774718,
      "Serial": 607912,
      "Material": 13469317,
      "EQSLOC": "ERFV"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T37588",
      "AdminNo": "WB77AA-EOD16",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017774735,
      "Serial": 262934,
      "Material": 15402007,
      "EQSLOC": "EGOG"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T95924",
      "AdminNo": "WB77AA-EOD16T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017771323,
      "Serial": 43020091006,
      "Material": 13875426,
      "EQSLOC": "ERFX"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T07679",
      "AdminNo": "WB77AA-EOD22",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017774492,
      "Serial": 502352,
      "Material": 13469317,
      "EQSLOC": "EGRX"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T07679",
      "AdminNo": "WB77AA-EOD23",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017774720,
      "Serial": 573245,
      "Material": 13469317,
      "EQSLOC": "EGS0"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "T37588",
      "AdminNo": "WB77AA-EOD26",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017774957,
      "Serial": 263003,
      "Material": 15402007,
      "EQSLOC": "EGOG"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T95924",
      "AdminNo": "WB77AA-EOD26T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017771324,
      "Serial": 43020091092,
      "Material": 13875426,
      "EQSLOC": "EGS0"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T37588",
      "AdminNo": "WB77AA-EOD3",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017774956,
      "Serial": 262941,
      "Material": 15402007,
      "EQSLOC": "EGRW"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T95924",
      "AdminNo": "WB77AA-EOD36T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017771326,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "EGRX"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T95924",
      "AdminNo": "WB77AA-EOD3T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017771325,
      "Serial": 63020091715,
      "Material": 13875426,
      "EQSLOC": "EGS1"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "T07679",
      "AdminNo": "WB77AA-EOD4",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017774491,
      "Serial": 502174,
      "Material": 13469317,
      "EQSLOC": "FWDN"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "W98825",
      "AdminNo": "WB77AA-EOD4T",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017771584,
      "Serial": "3228A",
      "Material": 11087367,
      "EQSLOC": "ERFV"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T07679",
      "AdminNo": "WB77AA-EOD5",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017774716,
      "Serial": 608134,
      "Material": 13469317,
      "EQSLOC": "EGRW"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "T07679",
      "AdminNo": "WB77AA-EOD6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017774721,
      "Serial": 571758,
      "Material": 13469317,
      "EQSLOC": "EGS1"
    },
    {
      "UIC": "WB77AA",
      "LINNumber": "G18358",
      "AdminNo": "WB77AA-EODHQ",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017771332,
      "Serial": "FZA02055",
      "Material": 12853012,
      "EQSLOC": "ERFV"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "LF3053",
      "AdminNo": "WC9TA0-",
      "Description": "FORKLIFT ELECTRIC: 7BPUE15 TOYOTA",
      "Model": "",
      "Equipment": 1017855363,
      "Serial": 80192,
      "Material": "01C084551",
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "LF3002",
      "AdminNo": "WC9TA0-",
      "Description": "TRUCK FORKLIFT: 7FBCU30 TOYOTA",
      "Model": "",
      "Equipment": 1017870894,
      "Serial": 61949,
      "Material": "01C082569",
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "LF3002",
      "AdminNo": "WC9TA0-",
      "Description": "TRUCK FORKLIFT: 7FBCU30 TOYOTA",
      "Model": "",
      "Equipment": 1017870895,
      "Serial": 61955,
      "Material": "01C082569",
      "EQSLOC": "AH2N"
    },
    {
      "UIC": "WC9TA0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TB0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753200,
      "Serial": "SCO38137",
      "Material": 14422751,
      "EQSLOC": "EGOL"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "G77765",
      "AdminNo": "WC9TB0-",
      "Description": "GENERATOR SIGNAL",
      "Model": "SG-1364/U",
      "Equipment": 1017865743,
      "Serial": 101721,
      "Material": 15336563,
      "EQSLOC": "DW0D"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "K28601",
      "AdminNo": "WC9TD0-",
      "Description": "KITCHN CO LVL FEEDTY2",
      "Model": "MKT95",
      "Equipment": 1017753337,
      "Serial": 1017753337,
      "Material": 13741980,
      "EQSLOC": "AH2S"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "K28601",
      "AdminNo": "WC9TD0-",
      "Description": "KITCHN CO LVL FEEDTY2",
      "Model": "MKT95",
      "Equipment": 1017753338,
      "Serial": 1017753338,
      "Material": 13741980,
      "EQSLOC": "AH2S"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753346,
      "Serial": "SC019857",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753347,
      "Serial": "SC045193",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753348,
      "Serial": "SC037906",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753349,
      "Serial": "SC045210",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753350,
      "Serial": "SC045168",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753351,
      "Serial": "H03009",
      "Material": 14505671,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753352,
      "Serial": "SC045238",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753353,
      "Serial": "SC045191",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753354,
      "Serial": "SC045190",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753355,
      "Serial": "SC045207",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753376,
      "Serial": "SC045235",
      "Material": 14422751,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753377,
      "Serial": "SC045239",
      "Material": 14505671,
      "EQSLOC": "DW1F"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TD0-CROP-2",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866530,
      "Serial": "SC03312",
      "Material": 14422751,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "H00586",
      "AdminNo": "WC9TD0-D03274",
      "Description": "HEATER D 120000BTU/HR",
      "Model": "H140",
      "Equipment": 1017862741,
      "Serial": "H1403274",
      "Material": 14770568,
      "EQSLOC": "EGP6"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "A94943",
      "AdminNo": "WC9TD0-D2816AK",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870712,
      "Serial": "RSB-T06-2816",
      "Material": 15583100,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "A94943",
      "AdminNo": "WC9TD0-D2832AK",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870713,
      "Serial": "RSB-T06-2832",
      "Material": 15583100,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WC9TD0",
      "LINNumber": "A94943",
      "AdminNo": "WC9TD0-D2866AK",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870708,
      "Serial": "RSB-T06-2866",
      "Material": 15583100,
      "EQSLOC": "DW1E"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "S33399",
      "AdminNo": "WC9TE0-",
      "Description": "FOOD SANITATION CN",
      "Model": "FSC-2",
      "Equipment": 1017758836,
      "Serial": 1017758836,
      "Material": 14962112,
      "EQSLOC": "GGLK"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "S33399",
      "AdminNo": "WC9TE0-",
      "Description": "FOOD SANITATION CN",
      "Model": "FSC-2",
      "Equipment": 1017758839,
      "Serial": 1017758839,
      "Material": 14962112,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TF0",
      "LINNumber": "T96564",
      "AdminNo": "WC9TF0-",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870795,
      "Serial": "TL-201736BGAS",
      "Material": 14491775,
      "EQSLOC": "DW1A"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "K28601",
      "AdminNo": "WC9TG0-",
      "Description": "KITCHEN COMPANY LEVEL",
      "Model": "MKT95",
      "Equipment": 1017753505,
      "Serial": "PGLA-WC9TG0-483",
      "Material": 12009828,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "S33399",
      "AdminNo": "WC9TG0-66FS",
      "Description": "FOOD SANITATION CN",
      "Model": "FSC-2",
      "Equipment": 1017758840,
      "Serial": 41866,
      "Material": 14962112,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "A94943",
      "AdminNo": "WC9TG0-ASK1",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870705,
      "Serial": "RSB-T06-0903",
      "Material": 15583100,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "A94943",
      "AdminNo": "WC9TG0-ASK2",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870706,
      "Serial": "RSB-T06-1206",
      "Material": 15583100,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "A94943",
      "AdminNo": "WC9TG0-ASK3",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870707,
      "Serial": "RSB-T06-1207",
      "Material": 15583100,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "F64544",
      "AdminNo": "WC9TG0-FRS",
      "Description": "FORWD REP SYS (FRS)",
      "Model": "M7FRS",
      "Equipment": 1017869214,
      "Serial": "2164-3",
      "Material": 15331621,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "G07461",
      "AdminNo": "WC9TG0-G11G",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870850,
      "Serial": "K120421017",
      "Material": 15617455,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "G07461",
      "AdminNo": "WC9TG0-G12G",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870847,
      "Serial": "K120421013",
      "Material": 15617455,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G223FR1",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753560,
      "Serial": "SC042616",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G223FR2",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753561,
      "Serial": "SCO19846",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G224FR1",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753514,
      "Serial": "SC045245",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G224FR2",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753562,
      "Serial": "SC042653",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G225FR1",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753556,
      "Serial": "SC042814",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G225FR2",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753557,
      "Serial": "SC042762",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G244FR1",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753558,
      "Serial": "SC042735",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G244FR2",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753559,
      "Serial": "SC042626",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G245FR1",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753513,
      "Serial": "SC045243",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G246FR1",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017753515,
      "Serial": "SC038255",
      "Material": 14422751,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "B83002",
      "AdminNo": "WC9TG0-G247FR1",
      "Description": "BED CGO FLTRK DEMOUNT",
      "Model": "M3 CROP",
      "Equipment": 1017866527,
      "Serial": "SC03232",
      "Material": 14422751,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T49255",
      "AdminNo": "WC9TG0-G251",
      "Description": "TRK LF FK 4K W/O CAB",
      "Model": "MHE270",
      "Equipment": 1017869159,
      "Serial": "8909-273",
      "Material": 13308907,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "L84622",
      "AdminNo": "WC9TG0-G27G",
      "Description": "GENERATO SE DIE",
      "Model": "PU-2002",
      "Equipment": 1017870909,
      "Serial": "C150810718",
      "Material": 15624010,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T40090",
      "AdminNo": "WC9TG0-G327G",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870920,
      "Serial": "A130435409",
      "Material": 15623689,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "L26934",
      "AdminNo": "WC9TG0-G351G",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1017870753,
      "Serial": "T15-055-003",
      "Material": 15623992,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "T40090",
      "AdminNo": "WC9TG0-G35G",
      "Description": "GENERATO SE DIS",
      "Model": "PU-2101",
      "Equipment": 1017870917,
      "Serial": "A130435398",
      "Material": 15623689,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "G42170",
      "AdminNo": "WC9TG0-G4G",
      "Description": "GEN SET HMT PU-798A",
      "Model": "PU798A",
      "Equipment": 1017869915,
      "Serial": "T-06-318-190",
      "Material": 14133818,
      "EQSLOC": "AH2W"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "G18358",
      "AdminNo": "WC9TG0-G6G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017866075,
      "Serial": "FZA07216",
      "Material": 12853012,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "G36237",
      "AdminNo": "WC9TG0-G9G",
      "Description": "GEN SET DIESEL EN DEW",
      "Model": "MEP531A",
      "Equipment": 1017855184,
      "Serial": "EX02218",
      "Material": 14351565,
      "EQSLOC": "EGOQ"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "M30688",
      "AdminNo": "WC9TG0-GMTRCS",
      "Description": "MULT-TEMP REFR CONT",
      "Model": "MTRCS02",
      "Equipment": 1017868398,
      "Serial": 9500950,
      "Material": 15929018,
      "EQSLOC": "EGOS"
    },
    {
      "UIC": "WC9TG0",
      "LINNumber": "C11280",
      "AdminNo": "WC9TG0-SUSV3",
      "Description": "CARRIER CGO FT 1.5T",
      "Model": "M973A1",
      "Equipment": 1017869180,
      "Serial": "88-AFL6867",
      "Material": 12816451,
      "EQSLOC": "EGOR"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "S33399",
      "AdminNo": "WC9TT0-",
      "Description": "FOOD SANITATION CN",
      "Model": "FSC-2",
      "Equipment": 1017758837,
      "Serial": 1017758837,
      "Material": 14962112,
      "EQSLOC": "DW4R"
    },
    {
      "UIC": "WC9TT0",
      "LINNumber": "G07461",
      "AdminNo": "WC9TT0-",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1017870853,
      "Serial": "K120421026",
      "Material": 15617455,
      "EQSLOC": "DW4R"
    },
    {
      "UIC": "WC9TB0",
      "LINNumber": "G05005",
      "AdminNo": "WEV8AA-",
      "Description": "GENERATOR,SIGNAL",
      "Model": "SG-1366/U",
      "Equipment": 1011582044,
      "Serial": "SG51030655",
      "Material": 15658789,
      "EQSLOC": "AH2O"
    },
    {
      "UIC": "WH9RA0",
      "LINNumber": "YF1097",
      "AdminNo": "WH9RA0-GMV1",
      "Description": "UTILITY VEHICLE,OFFROAD",
      "Model": "XM1297",
      "Equipment": 1031849282,
      "Serial": "0520150470X1297",
      "Material": 16698480,
      "EQSLOC": "EGNG"
    },
    {
      "UIC": "WH9RD0",
      "LINNumber": "G18358",
      "AdminNo": "WH9RD0-D1G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864354,
      "Serial": "FZA12874",
      "Material": 12853012,
      "EQSLOC": "EVCT"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "SA2024",
      "AdminNo": "WH9RT0-",
      "Description": "TWO WHEELED TRAILER MOUNTED ECU: 2001932",
      "Model": "",
      "Equipment": 1017869466,
      "Serial": "20840-001",
      "Material": "01C031372",
      "EQSLOC": "DVZ3"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "G18358",
      "AdminNo": "WH9RT0-HHC1G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864479,
      "Serial": "FZA12936",
      "Material": 12853012,
      "EQSLOC": "DVYV"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "G18358",
      "AdminNo": "WH9RT0-HHC2G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864478,
      "Serial": "FZA12890",
      "Material": 12853012,
      "EQSLOC": "DVYV"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "W98825",
      "AdminNo": "WH9RT0-HHC4W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1017863719,
      "Serial": "2678D",
      "Material": 11087367,
      "EQSLOC": "DVYV"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T41995",
      "AdminNo": "WH9RT0-HHC5",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017867001,
      "Serial": "L-A115039BGLT",
      "Material": 14473882,
      "EQSLOC": "DVYV"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870368,
      "Serial": 510049,
      "Material": 13469317,
      "EQSLOC": "DVYW"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC71",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870156,
      "Serial": 511241,
      "Material": 13469317,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC72",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869842,
      "Serial": 502510,
      "Material": 13469317,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC73",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870157,
      "Serial": 511251,
      "Material": 13469317,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC74",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869986,
      "Serial": 511302,
      "Material": 13469317,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC75",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870440,
      "Serial": 511208,
      "Material": 13469317,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HHC75T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865592,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC76",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870364,
      "Serial": 511268,
      "Material": 13469317,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC77",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870063,
      "Serial": 511215,
      "Material": 13469317,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HHC77T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864927,
      "Serial": 10590,
      "Material": 13875443,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC78",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870257,
      "Serial": 511312,
      "Material": 13469317,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC79",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870495,
      "Serial": 511278,
      "Material": 13469317,
      "EQSLOC": "DVYX"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T38844",
      "AdminNo": "WH9RT0-HHC80A",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869009,
      "Serial": 52116,
      "Material": 11112274,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T38844",
      "AdminNo": "WH9RT0-HHC81A",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869138,
      "Serial": 47479,
      "Material": 11112274,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T38844",
      "AdminNo": "WH9RT0-HHC83A",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869139,
      "Serial": 53860,
      "Material": 11112274,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T38844",
      "AdminNo": "WH9RT0-HHC84A",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017869038,
      "Serial": 54892,
      "Material": 11112274,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC86",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870345,
      "Serial": 511352,
      "Material": 13469317,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HHC86T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864989,
      "Serial": 11977,
      "Material": 13875443,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC87",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870445,
      "Serial": 511286,
      "Material": 13469317,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HHC87T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864928,
      "Serial": 10591,
      "Material": 13875443,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T38844",
      "AdminNo": "WH9RT0-HHC890Z",
      "Description": "TRK AMB 4 LITTER M997",
      "Model": "M997",
      "Equipment": 1017868999,
      "Serial": 54268,
      "Material": 11112274,
      "EQSLOC": "DVYZ"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC91",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870451,
      "Serial": 511314,
      "Material": 13469317,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HHC91T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865521,
      "Serial": 5244,
      "Material": 13875443,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC92",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870005,
      "Serial": 511336,
      "Material": 13469317,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HHC92T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865523,
      "Serial": 1245000000000,
      "Material": 13875443,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HHC93T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865525,
      "Serial": 23448,
      "Material": 13875443,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HHC94T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865520,
      "Serial": 22820090866,
      "Material": 13875443,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC95",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870353,
      "Serial": 511291,
      "Material": 13469317,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95924",
      "AdminNo": "WH9RT0-HHC95T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865450,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC96",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869748,
      "Serial": 502534,
      "Material": 13469317,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95924",
      "AdminNo": "WH9RT0-HHC96T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017865449,
      "Serial": 124500000000,
      "Material": 13875426,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HHC97",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870438,
      "Serial": 511178,
      "Material": 13469317,
      "EQSLOC": "DVYY"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T37588",
      "AdminNo": "WH9RT0-HHC98",
      "Description": "TRK UT EX CAP M1152A1",
      "Model": "M1152A1",
      "Equipment": 1017868063,
      "Serial": 262927,
      "Material": 15402007,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T41995",
      "AdminNo": "WH9RT0-HQ11",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869132,
      "Serial": "L-A114601BGKT",
      "Material": 14473882,
      "EQSLOC": "DVZ1"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T96564",
      "AdminNo": "WH9RT0-HQ11T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870800,
      "Serial": "TL-201813BGBS",
      "Material": 14491775,
      "EQSLOC": "DVZ1"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T96564",
      "AdminNo": "WH9RT0-HQ21T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870799,
      "Serial": "TL-201810BGBS",
      "Material": 14491775,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ22",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870059,
      "Serial": 511393,
      "Material": 13469317,
      "EQSLOC": "DVZ2"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ3",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870508,
      "Serial": 511389,
      "Material": 13469317,
      "EQSLOC": "DVZ3"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ34",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870351,
      "Serial": 511267,
      "Material": 13469317,
      "EQSLOC": "DVZ3"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HQ34T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865181,
      "Serial": 12005,
      "Material": 13875443,
      "EQSLOC": "DVZ3"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T41995",
      "AdminNo": "WH9RT0-HQ41",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1017869733,
      "Serial": "L-A114528BGKT",
      "Material": 14473882,
      "EQSLOC": "DVZ4"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T96564",
      "AdminNo": "WH9RT0-HQ4T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1017870804,
      "Serial": "TL-201870BGBS",
      "Material": 14491775,
      "EQSLOC": "DVZ4"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ6",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870589,
      "Serial": 573417,
      "Material": 13469317,
      "EQSLOC": "DVZ3"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HQ61T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017864932,
      "Serial": 10641,
      "Material": 13875443,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ62",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017869927,
      "Serial": 502573,
      "Material": 13469317,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "G18358",
      "AdminNo": "WH9RT0-HQ62G",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1017864477,
      "Serial": "FZA07490",
      "Material": 12853012,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ63",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870083,
      "Serial": 510054,
      "Material": 13469317,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ64",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870498,
      "Serial": 511315,
      "Material": 13469317,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ65",
      "Description": "TRK UTIL 10000 M1097",
      "Model": "M1097",
      "Equipment": 1017870168,
      "Serial": 511202,
      "Material": 13469317,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T56383",
      "AdminNo": "WH9RT0-HQ67",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868330,
      "Serial": 258806,
      "Material": 15402017,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T56383",
      "AdminNo": "WH9RT0-HQ68",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868709,
      "Serial": 258793,
      "Material": 15402017,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T56383",
      "AdminNo": "WH9RT0-HQ6Z",
      "Description": "TR UT EX CAP: M1165A1",
      "Model": "M1165A1",
      "Equipment": 1017868326,
      "Serial": 262327,
      "Material": 15402017,
      "EQSLOC": "DVZ5"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ7",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870095,
      "Serial": 206742,
      "Material": 13808604,
      "EQSLOC": "DVZ3"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95992",
      "AdminNo": "WH9RT0-HQ7T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1017865149,
      "Serial": 11980,
      "Material": 13875443,
      "EQSLOC": "DVZ3"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T07679",
      "AdminNo": "WH9RT0-HQ7Z",
      "Description": "TRK UTIL HV M1097A2",
      "Model": "M1097A2",
      "Equipment": 1017870096,
      "Serial": 206909,
      "Material": 13808604,
      "EQSLOC": "AH3U"
    },
    {
      "UIC": "WH9RT0",
      "LINNumber": "T95924",
      "AdminNo": "WH9RT0-HQ90T",
      "Description": "TLR CGO HI MOB 11/4T",
      "Model": "M1102",
      "Equipment": 1017864870,
      "Serial": 7865,
      "Material": 13875426,
      "EQSLOC": "DVZ3"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "YF5070",
      "AdminNo": "WPESAA-",
      "Description": "SNOWMOBILE, SLED: GALAXY POLARIS",
      "Model": "",
      "Equipment": 1033491385,
      "Serial": "TMP_0000191360",
      "Material": "01C087076",
      "EQSLOC": "DVZK"
    },
    {
      "UIC": "WH9RC0",
      "LINNumber": "YF5070",
      "AdminNo": "WPESAA-",
      "Description": "SNOWMOBILE, SLED: GALAXY POLARIS",
      "Model": "",
      "Equipment": 1033491386,
      "Serial": "TMP_0000191361",
      "Material": "01C087076",
      "EQSLOC": "DVZK"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "EA2002",
      "AdminNo": "WPESAA-",
      "Description": "AUGER,EARTH,SKID MOUNTED: X1450 MCMILLEN",
      "Model": "",
      "Equipment": 1033826566,
      "Serial": "TMP_0000256374",
      "Material": "01C104832",
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WG24A0",
      "LINNumber": "EA2002",
      "AdminNo": "WPESAA-",
      "Description": "AUGER,EARTH,SKID MOUNTED: X1450 MCMILLEN",
      "Model": "",
      "Equipment": 1033826567,
      "Serial": "TMP_0000256375",
      "Material": "01C104832",
      "EQSLOC": "EGR9"
    },
    {
      "UIC": "WE29AA",
      "LINNumber": "C36586",
      "AdminNo": "WTBAAA-CL_S320",
      "Description": "CRANE WHL HYDR AT422T",
      "Model": "AT422T",
      "Equipment": 1010666162,
      "Serial": 221875,
      "Material": 14482619,
      "EQSLOC": "FWDM"
    },
    {
      "UIC": "WAQ0C0",
      "LINNumber": "B84293",
      "AdminNo": "WZZYAA-INFB-1",
      "Description": "BOAT,LANDING,INFLATABLE",
      "Model": "FC-470",
      "Equipment": 1021418515,
      "Serial": "11-0369",
      "Material": 15991756,
      "EQSLOC": "DW30"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "A94943",
      "AdminNo": "Z30",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870714,
      "Serial": "RSB-T06-2835",
      "Material": 15583100,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "A94943",
      "AdminNo": "Z31",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870715,
      "Serial": "RSB-T06-2888",
      "Material": 15583100,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WC9TE0",
      "LINNumber": "A94943",
      "AdminNo": "Z32",
      "Description": "KITCHEN MODULE",
      "Model": "AK",
      "Equipment": 1017870716,
      "Serial": "RSB-T06-2894",
      "Material": 15583100,
      "EQSLOC": "EGNX"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "FD1500",
      "AdminNo": "A611G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427568,
      "Serial": "TMP_0000187412",
      "Material": "016792558",
      "EQSLOC": "BFNJ"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "FD1500",
      "AdminNo": "A612G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427569,
      "Serial": "TMP_0000187413",
      "Material": "016792558",
      "EQSLOC": "BFNJ"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "FD1500",
      "AdminNo": "A613G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427570,
      "Serial": "TMP_0000187414",
      "Material": "016792558",
      "EQSLOC": "BFNJ"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "FD1500",
      "AdminNo": "A614G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427571,
      "Serial": "TMP_0000187415",
      "Material": "016792558",
      "EQSLOC": "BFNJ"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "FD1500",
      "AdminNo": "A615G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427572,
      "Serial": "TMP_0000187416",
      "Material": "016792558",
      "EQSLOC": "BFNJ"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "FD1500",
      "AdminNo": "A616G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427573,
      "Serial": "TMP_0000187417",
      "Material": "016792558",
      "EQSLOC": "BFNJ"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "FD1500",
      "AdminNo": "B620G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427578,
      "Serial": "G190611275",
      "Material": "016792558",
      "EQSLOC": "BFNV"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "FD1500",
      "AdminNo": "B621G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427576,
      "Serial": "G190611265",
      "Material": "016792558",
      "EQSLOC": "BFNT"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "FD1500",
      "AdminNo": "B624G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427577,
      "Serial": "G190611277",
      "Material": "016792558",
      "EQSLOC": "BFNU"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "FD1500",
      "AdminNo": "B625G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427575,
      "Serial": "H190624316",
      "Material": "016792558",
      "EQSLOC": "BFNS"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "FD1500",
      "AdminNo": "B626G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427574,
      "Serial": "H190624713",
      "Material": "016792558",
      "EQSLOC": "BFNR"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "FD1500",
      "AdminNo": "G640",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427567,
      "Serial": "G190611202",
      "Material": "016792558",
      "EQSLOC": "BFOQ"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "FD1500",
      "AdminNo": "G641",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427586,
      "Serial": "I190630677",
      "Material": "016792558",
      "EQSLOC": "A8L6"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "FD1500",
      "AdminNo": "G642",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427587,
      "Serial": "G190611198",
      "Material": "016792558",
      "EQSLOC": "BFOM"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "FD1500",
      "AdminNo": "G643",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427588,
      "Serial": "H190624710",
      "Material": "016792558",
      "EQSLOC": "BFON"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "FD1500",
      "AdminNo": "G644",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427589,
      "Serial": "G190611233",
      "Material": "016792558",
      "EQSLOC": "BFOO"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "FD1500",
      "AdminNo": "G645",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427590,
      "Serial": "G190611215",
      "Material": "016792558",
      "EQSLOC": "BFOP"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "FD1500",
      "AdminNo": "WE1AE0-E650G",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427566,
      "Serial": "G1960611230",
      "Material": "016792558",
      "EQSLOC": "BFPA"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "FD1500",
      "AdminNo": "WPESAA-",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427579,
      "Serial": "G190611225",
      "Material": "016792558",
      "EQSLOC": "BFNW"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "FD1500",
      "AdminNo": "WPESAA-",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427580,
      "Serial": "TMP_0000187424",
      "Material": "016792558",
      "EQSLOC": "BFO6"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "FD1500",
      "AdminNo": "WPESAA-",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427581,
      "Serial": "TMP_0000187425",
      "Material": "016792558",
      "EQSLOC": "BFO7"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "FD1500",
      "AdminNo": "WPESAA-",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427582,
      "Serial": "TMP_0000187426",
      "Material": "016792558",
      "EQSLOC": "BFO8"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "FD1500",
      "AdminNo": "WPESAA-",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427583,
      "Serial": "TMP_0000187427",
      "Material": "016792558",
      "EQSLOC": "BFO9"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "FD1500",
      "AdminNo": "WPESAA-",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427584,
      "Serial": "TMP_0000187428",
      "Material": "016792558",
      "EQSLOC": "BFOG"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "FD1500",
      "AdminNo": "WPESAA-",
      "Description": "GENERATOR SET,DIESEL ENGINE",
      "Model": "",
      "Equipment": 1033427585,
      "Serial": "TMP_0000187429",
      "Material": "016792558",
      "EQSLOC": "BFOL"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "FD1501",
      "AdminNo": "WE1AE0-",
      "Description": "GENERATOR GAS: HONDA",
      "Model": "",
      "Equipment": 1009666501,
      "Serial": "GC04-4505680",
      "Material": "01C039450",
      "EQSLOC": "BFPA"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "FD1518",
      "AdminNo": "WE1AA0-",
      "Description": "GENERATOR PORTABLE: HOND-EU2000IC HONDA",
      "Model": "",
      "Equipment": 1009678728,
      "Serial": "1000420",
      "Material": "01C155994",
      "EQSLOC": "BFNN"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "FD1518",
      "AdminNo": "WE1AB0-",
      "Description": "GENERATOR PORTABLE: HOND-EU2000IC HONDA",
      "Model": "",
      "Equipment": 1009678723,
      "Serial": "1081909",
      "Material": "01C155994",
      "EQSLOC": "BFNT"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "FD1518",
      "AdminNo": "WE1AC0-",
      "Description": "GENERATOR PORTABLE: HOND-EU2000IC HONDA",
      "Model": "",
      "Equipment": 1009678725,
      "Serial": "1081954",
      "Material": "01C155994",
      "EQSLOC": "BFOK"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "FD1518",
      "AdminNo": "WE1AC0-",
      "Description": "GENERATOR PORTABLE: HOND-EU2000IC HONDA",
      "Model": "",
      "Equipment": 1009678727,
      "Serial": "1081956",
      "Material": "01C155994",
      "EQSLOC": "BFOK"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "G07461",
      "AdminNo": "HQ8G",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1033314823,
      "Serial": "E190558141",
      "Material": "015617455",
      "EQSLOC": "BFQ6"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "G07461",
      "AdminNo": "UIC   -",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1033320967,
      "Serial": "E190549431",
      "Material": "015617455",
      "EQSLOC": "BFQ2"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "G07461",
      "AdminNo": "UIC   -",
      "Description": "GEN ST D",
      "Model": "MEP-1040",
      "Equipment": 1033322032,
      "Serial": "E190558124",
      "Material": "015617455",
      "EQSLOC": "BFQ3"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "G11966",
      "AdminNo": "WE1AC0-CAT632",
      "Description": "GEN ST DSL MEP-802A",
      "Model": "MEP802A",
      "Equipment": 1009686472,
      "Serial": "FZ13115",
      "Material": "012747387",
      "EQSLOC": "A8L1"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "G11966",
      "AdminNo": "WE1AC0-CAT633",
      "Description": "GEN ST DSL MEP-802A",
      "Model": "MEP802A",
      "Equipment": 1009686479,
      "Serial": "FZ13117",
      "Material": "012747387",
      "EQSLOC": "A8L1"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "G11966",
      "AdminNo": "WE1AC0-CAT634",
      "Description": "GEN ST DSL MEP-802A",
      "Model": "MEP802A",
      "Equipment": 1009686492,
      "Serial": "FZ13125",
      "Material": "012747387",
      "EQSLOC": "A8L1"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "G11966",
      "AdminNo": "WE1AC0-CAT635",
      "Description": "GEN ST DSL MEP-802A",
      "Model": "MEP802A",
      "Equipment": 1009686495,
      "Serial": "FZ13126",
      "Material": "012747387",
      "EQSLOC": "A8L1"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "G11966",
      "AdminNo": "WE1AC0-CGEN02",
      "Description": "GEN ST DSL MEP-802A",
      "Model": "MEP802A",
      "Equipment": 1009683423,
      "Serial": "FZ12736",
      "Material": "012747387",
      "EQSLOC": "A8L1"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "G11966",
      "AdminNo": "WE1AT0-MP1",
      "Description": "GEN ST DSL MEP-802A",
      "Model": "MEP802A",
      "Equipment": 1009673666,
      "Serial": "RZB00727",
      "Material": "012747387",
      "EQSLOC": "A8L7"
    },
    {
      "UIC": "WE1AD7",
      "LINNumber": "G18358",
      "AdminNo": "WE1AD7-HQG19",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1009686079,
      "Serial": "FZA13106",
      "Material": "012853012",
      "EQSLOC": "H0Z4"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "G18358",
      "AdminNo": "WE1AT0-HHCGEN",
      "Description": "GEN SET DED MEP 831",
      "Model": "MEP831",
      "Equipment": 1009686072,
      "Serial": "FZA01429",
      "Material": "012853012",
      "EQSLOC": "BFQ3"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AE0-E651G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033312439,
      "Serial": "K180448202",
      "Material": "015617329",
      "EQSLOC": "BFPD"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AE0-E652G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033325811,
      "Serial": "K180448213",
      "Material": "015617329",
      "EQSLOC": "BFPE"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AE0-E653G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033325812,
      "Serial": "K180448214",
      "Material": "015617329",
      "EQSLOC": "BFPF"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AE0-E654G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033326107,
      "Serial": "K180448188",
      "Material": "015617329",
      "EQSLOC": "BFPC"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AE0-E655G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033327714,
      "Serial": "K180448104",
      "Material": "015617329",
      "EQSLOC": "BFPG"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AF0 - F660G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033322252,
      "Serial": "K180448196",
      "Material": "015617329",
      "EQSLOC": "BFPO"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AF0 - F661G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033314824,
      "Serial": "E180351816",
      "Material": "015617329",
      "EQSLOC": "BFQ4"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AF0 - F662G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033322253,
      "Serial": "J180730798",
      "Material": "015617329",
      "EQSLOC": "BFPK"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AF0 - F663G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033322255,
      "Serial": "J180430793",
      "Material": "015617329",
      "EQSLOC": "BFPL"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AF0 - F664G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033322254,
      "Serial": "J180430791",
      "Material": "015617329",
      "EQSLOC": "BFPM"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AF0 - F665G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033324197,
      "Serial": "K180448218",
      "Material": "015617329",
      "EQSLOC": "BFPN"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "G42488",
      "AdminNo": "WE1AF0-F666G",
      "Description": "GENERATOR SET DISE",
      "Model": "MEP-1030",
      "Equipment": 1033324196,
      "Serial": "E180351818",
      "Material": "015617329",
      "EQSLOC": "BFPJ"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "G49966",
      "AdminNo": "UIC   -",
      "Description": "GENERATOR ST D",
      "Model": "MEP-1050",
      "Equipment": 1033322886,
      "Serial": "B190506502",
      "Material": "015617634",
      "EQSLOC": "BFQ9"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "L26934",
      "AdminNo": "A616PU",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1033323924,
      "Serial": "T19-256-005",
      "Material": "015623992",
      "EQSLOC": "BFNJ"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "L26934",
      "AdminNo": "B627PU",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1033323027,
      "Serial": "T19-256-011",
      "Material": "015623992",
      "EQSLOC": "BFNZ"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "L26934",
      "AdminNo": "D646PU",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1033322250,
      "Serial": "T19-256-013",
      "Material": "015623992",
      "EQSLOC": "BFOQ"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "L26934",
      "AdminNo": "UIC   -",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1033315313,
      "Serial": "T19-256-002",
      "Material": "015623992",
      "EQSLOC": "BFQ3"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "L26934",
      "AdminNo": "UIC   -",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1033338267,
      "Serial": "T19-256-004",
      "Material": "015623992",
      "EQSLOC": "BFOK"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "L26934",
      "AdminNo": "WE1AE0-E656PU",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1033327715,
      "Serial": "T19-256-014",
      "Material": "015623992",
      "EQSLOC": "BFPA"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "L26934",
      "AdminNo": "WE1AF0 - F666PU",
      "Description": "GENERATR SET DI",
      "Model": "PU-2001",
      "Equipment": 1033324198,
      "Serial": "T19-256-019",
      "Material": "015623992",
      "EQSLOC": "BFPO"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "L27002",
      "AdminNo": "UIC   -",
      "Description": "POWER PLANT ELECT",
      "Model": "PP-3001",
      "Equipment": 1033322033,
      "Serial": "T19-196-001",
      "Material": "015623700",
      "EQSLOC": "CE9Q"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "P28083",
      "AdminNo": "WE1AT0-HHCS6G1",
      "Description": "POWER PLANT AN/MJQ-35",
      "Model": "MJQ35",
      "Equipment": 1009682358,
      "Serial": "T9326359",
      "Material": "013134216",
      "EQSLOC": "A8L7"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "P63394",
      "AdminNo": "WE1AT0-HDRASH",
      "Description": "PWR PLT: UTILITY",
      "Model": "PU-824A/T",
      "Equipment": 1009681588,
      "Serial": "TMSS-30357",
      "Material": "015478552",
      "EQSLOC": "BFPY"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AB0-B620",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680783,
      "Serial": "264778",
      "Material": "015402038",
      "EQSLOC": "A7VV"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AB0-B621",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680766,
      "Serial": "264718",
      "Material": "015402038",
      "EQSLOC": "A7VV"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AB0-B622",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680730,
      "Serial": "264308",
      "Material": "015402038",
      "EQSLOC": "A7VV"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AB0-B623",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680757,
      "Serial": "264473",
      "Material": "015402038",
      "EQSLOC": "A7VV"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AB0-B624",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680798,
      "Serial": "264955",
      "Material": "015402038",
      "EQSLOC": "A7VV"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AC0-C631",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680748,
      "Serial": "264404",
      "Material": "015402038",
      "EQSLOC": "A8L1"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AC0-C632",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680686,
      "Serial": "264353",
      "Material": "015402038",
      "EQSLOC": "A8L1"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AC0-C633",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680681,
      "Serial": "264259",
      "Material": "015402038",
      "EQSLOC": "A8L1"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AC0-C634",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680691,
      "Serial": "264396",
      "Material": "015402038",
      "EQSLOC": "A8L1"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AC0-C635",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680713,
      "Serial": "264895",
      "Material": "015402038",
      "EQSLOC": "A8L1"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AT0-HHC6",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009682415,
      "Serial": "264238",
      "Material": "015402038",
      "EQSLOC": "A8L7"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AT0-HQ1",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009682393,
      "Serial": "263520",
      "Material": "015402038",
      "EQSLOC": "A8L7"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AT0-HQ2",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009682170,
      "Serial": "262962",
      "Material": "015402038",
      "EQSLOC": "A8L7"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AT0-HQ6",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009680089,
      "Serial": "263297",
      "Material": "015402038",
      "EQSLOC": "A8L7"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AT0-HQ7",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009682388,
      "Serial": "263437",
      "Material": "015402038",
      "EQSLOC": "A8L7"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T34704",
      "AdminNo": "WE1AT0-HQ9",
      "Description": "TR UT INT ARM M1151A1",
      "Model": "M1151A1",
      "Equipment": 1009682174,
      "Serial": "263078",
      "Material": "015402038",
      "EQSLOC": "A8L7"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T41135",
      "AdminNo": "WE1AT0-HQ43",
      "Description": "TRK CGO M1083A1 W/W",
      "Model": "M1083A1WW",
      "Equipment": 1009680043,
      "Serial": "BT106992BGKS",
      "Material": "014473884",
      "EQSLOC": "BFPY"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T41995",
      "AdminNo": "WE1AT0-HQ84",
      "Description": "TRK CGO 2 1/2T M1081",
      "Model": "M1081",
      "Equipment": 1009680671,
      "Serial": "LT7118BCLF",
      "Material": "013553064",
      "EQSLOC": "BFPY"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "T41995",
      "AdminNo": "WE1AA0-A618",
      "Description": "TRK CGO 2 1/2T M1081",
      "Model": "M1081",
      "Equipment": 1009680655,
      "Serial": "LT6677BCKF",
      "Material": "013553064",
      "EQSLOC": "BFNH"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T41995",
      "AdminNo": "WE1AB0-B23",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1009681035,
      "Serial": "L-T120393EHGV",
      "Material": "014473882",
      "EQSLOC": "BFNZ"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "T41995",
      "AdminNo": "WE1AD0-D48A",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1009681025,
      "Serial": "L-T120436EHGV",
      "Material": "014473882",
      "EQSLOC": "BFOS"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "T41995",
      "AdminNo": "WE1AE0-E658",
      "Description": "TRK CARG LMTV-M1081A1",
      "Model": "M1081A1WOW",
      "Equipment": 1009681030,
      "Serial": "L-T120805EHMV",
      "Material": "014473882",
      "EQSLOC": "BFP3"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "T41995",
      "AdminNo": "WE1AF0-F668",
      "Description": "TRK CGO 2 1/2T M1081",
      "Model": "M1081",
      "Equipment": 1014001218,
      "Serial": "LT2848BBKD",
      "Material": "013553064",
      "EQSLOC": "BFPQ"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T41995",
      "AdminNo": "WE1AT0-HQ82",
      "Description": "TRK CGO 2 1/2T M1081",
      "Model": "M1081",
      "Equipment": 1009680660,
      "Serial": "LT7488BCMF",
      "Material": "013553064",
      "EQSLOC": "BFQ6"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T41995",
      "AdminNo": "WE1AT0-HQ83",
      "Description": "TRK CGO 2 1/2T M1081",
      "Model": "M1081",
      "Equipment": 1009680648,
      "Serial": "LT6277BCHF",
      "Material": "013553064",
      "EQSLOC": "BFPY"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T49947",
      "AdminNo": "WE1AT0-",
      "Description": "TENT LIGHT MAINT ENCL",
      "Model": "",
      "Equipment": 1009661923,
      "Serial": "1009661923",
      "Material": "014563637",
      "EQSLOC": "BFQ6"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T57382",
      "AdminNo": "UIC   -",
      "Description": "TOOL KIT TK-17",
      "Model": "",
      "Equipment": 1031430398,
      "Serial": "1031430398",
      "Material": "011950855",
      "EQSLOC": "BFQ8"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T60081",
      "AdminNo": "WE1AC0-C301",
      "Description": "TR C 2 1/2T M1078",
      "Model": "M1078",
      "Equipment": 1009681705,
      "Serial": "AT1783BACD",
      "Material": "013543385",
      "EQSLOC": "BFOK"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T61908",
      "AdminNo": "WE1AT0-HQ96",
      "Description": "TRK CGO W/E M1083A1",
      "Model": "M1083A1",
      "Equipment": 1012853433,
      "Serial": "B-T108051EGLS",
      "Material": "014473890",
      "EQSLOC": "BFQ4"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T73347",
      "AdminNo": "WE1AT0-HQ81",
      "Description": "TRK LFT FK VAR RCH RT",
      "Model": "10000M",
      "Equipment": 1009680976,
      "Serial": "10KA0307R",
      "Material": "014172886",
      "EQSLOC": "BFQ6"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T94671",
      "AdminNo": "WE1AT0-HQ89",
      "Description": "TRUCK,WRECKER",
      "Model": "M1089A1P2/",
      "Equipment": 1015835947,
      "Serial": "10TANHFF2GS775930",
      "Material": "015953994",
      "EQSLOC": "BFQ6"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T94709",
      "AdminNo": "WE1AT0-HQ88",
      "Description": "TRUCK WKR W/W M1089A1",
      "Model": "M1089A1WW",
      "Equipment": 1009680488,
      "Serial": "W-104533EGES",
      "Material": "014473892",
      "EQSLOC": "BFQ6"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T95992",
      "AdminNo": "B622T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009684272,
      "Serial": "1245000210706",
      "Material": "013875443",
      "EQSLOC": "BFNS"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T95992",
      "AdminNo": "B624T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009684292,
      "Serial": "1245000210723",
      "Material": "013875443",
      "EQSLOC": "BFNU"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T95992",
      "AdminNo": "E250T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009683655,
      "Serial": "08951",
      "Material": "013875443",
      "EQSLOC": "BFNT"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T95992",
      "AdminNo": "HQ8T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685431,
      "Serial": "1245000210709",
      "Material": "013875443",
      "EQSLOC": "BFPY"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T95992",
      "AdminNo": "HQ92T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685146,
      "Serial": "1245000210821",
      "Material": "013875443",
      "EQSLOC": "BFQ3"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T95992",
      "AdminNo": "WA8GA0-A217T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009684301,
      "Serial": "1245000210726",
      "Material": "013875443",
      "EQSLOC": "BFNR"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AA0-A611T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685937,
      "Serial": "1245000212575",
      "Material": "013875443",
      "EQSLOC": "BFNP"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AA0-A612T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685934,
      "Serial": "1245000212548",
      "Material": "013875443",
      "EQSLOC": "BFNO"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AA0-A613T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685940,
      "Serial": "1245000212578",
      "Material": "013875443",
      "EQSLOC": "BFNN"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AA0-A614T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685143,
      "Serial": "1245000210812",
      "Material": "013875443",
      "EQSLOC": "BFNM"
    },
    {
      "UIC": "WE1AA0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AA0-A615T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685147,
      "Serial": "1245000210822",
      "Material": "013875443",
      "EQSLOC": "BFNL"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AC0-C300T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685931,
      "Serial": "1245000212557",
      "Material": "013875443",
      "EQSLOC": "BFO7"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AC0-C330T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685766,
      "Serial": "1245000212535",
      "Material": "013875443",
      "EQSLOC": "BFO8"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AC0-C340T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685769,
      "Serial": "1245000212536",
      "Material": "013875443",
      "EQSLOC": "BFO9"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AC0-C350T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685923,
      "Serial": "1245000212537",
      "Material": "013875443",
      "EQSLOC": "BFOL"
    },
    {
      "UIC": "WE1AC0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AC0-C360T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685926,
      "Serial": "1245000212538",
      "Material": "013875443",
      "EQSLOC": "BFO6"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AC0-C370T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685928,
      "Serial": "1245000212556",
      "Material": "013875443",
      "EQSLOC": "BFQ1"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AD0-D640T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685463,
      "Serial": "1245000212552",
      "Material": "013875443",
      "EQSLOC": "BFPY"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AD0-D641T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685474,
      "Serial": "1245000212555",
      "Material": "013875443",
      "EQSLOC": "A8L6"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AD0-D642T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685704,
      "Serial": "1245000212576",
      "Material": "013875443",
      "EQSLOC": "BFOM"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AD0-D643T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685454,
      "Serial": "1245000212549",
      "Material": "013875443",
      "EQSLOC": "BFON"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AD0-D645T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685460,
      "Serial": "1245000212551",
      "Material": "013875443",
      "EQSLOC": "BFOP"
    },
    {
      "UIC": "WE1AD0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AD0-D646T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685471,
      "Serial": "1245000212554",
      "Material": "013875443",
      "EQSLOC": "BFOQ"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AE0-E650T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009684255,
      "Serial": "24319",
      "Material": "013875443",
      "EQSLOC": "BFPA"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AE0-E651T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009684258,
      "Serial": "24335",
      "Material": "013875443",
      "EQSLOC": "BFPG"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AE0-E652T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009684251,
      "Serial": "24303",
      "Material": "013875443",
      "EQSLOC": "BFPF"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AE0-E653T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685943,
      "Serial": "1245000212547",
      "Material": "013875443",
      "EQSLOC": "BFPE"
    },
    {
      "UIC": "WE1AE0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AE0-E656T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685711,
      "Serial": "1245000212580",
      "Material": "013875443",
      "EQSLOC": "BFPA"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AF0-662T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685737,
      "Serial": "1245000212678",
      "Material": "013875443",
      "EQSLOC": "BFPK"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AF0-664T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009683875,
      "Serial": "09076",
      "Material": "013875443",
      "EQSLOC": "BFPM"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AF0-665T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685422,
      "Serial": "1245000210813",
      "Material": "013875443",
      "EQSLOC": "BFPN"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AF0-F661T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685468,
      "Serial": "1245000212553",
      "Material": "013875443",
      "EQSLOC": "BFPJ"
    },
    {
      "UIC": "WE1AF0",
      "LINNumber": "T95992",
      "AdminNo": "WE1AF0-F663T",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009685947,
      "Serial": "1245000212560",
      "Material": "013875443",
      "EQSLOC": "BFPL"
    },
    {
      "UIC": "WE1AB0",
      "LINNumber": "T95992",
      "AdminNo": "WHDQC0-C136AT",
      "Description": "TLR CGO HI MOB 3/4T",
      "Model": "M1101",
      "Equipment": 1009683881,
      "Serial": "09085",
      "Material": "013875443",
      "EQSLOC": "BFNV"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T96564",
      "AdminNo": "HHC4T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1009685364,
      "Serial": "TL014448BFCK",
      "Material": "014491775",
      "EQSLOC": "BFPY"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "T96564",
      "AdminNo": "WHDQC0-C138T",
      "Description": "TRLER FLAT BED M1082",
      "Model": "M1082",
      "Equipment": 1009682625,
      "Serial": "TL-206601BGFU",
      "Material": "014491775",
      "EQSLOC": "BFPY"
    },
    {
      "UIC": "WE1AT0",
      "LINNumber": "W98825",
      "AdminNo": "HQ4W",
      "Description": "TRAILER WTR M149A2",
      "Model": "M149A2",
      "Equipment": 1018913726,
      "Serial": "PH07BF-531",
      "Material": "011087367",
      "EQSLOC": "BFPY"
    }
  ]
